/* eslint-disable */
<template>
  <div v-if="resetPopoverToggle">

    <!--popup for mobile warning-->
    <v-card v-if="popoverToggles.mobileWarning">
      <v-icon @click="closeMenu('mobileWarning')" style="position: absolute; top: 0; right: 0;">clear</v-icon>
      <div style="padding: 36px 8px; width: 100%; display: flex; flex-flow: column; justify-content: flex-start; align-items: center;">
        <h1 style="text-align: center; font-size:16px;">For a better experience, flip your phone to landscape.</h1>
        <h1 style="text-align: center; padding-top: 24px; font-size:16px;" v-if="primaryAccount != 'Learner'">As an instructor, your experience is not optimized for mobile.</h1>
        <img style="width: 90%; margin-top: 16px;" src="https://cdn.playposit.com/image-uploads/image-22-05-2019-15-41-44--flippp.png" />
      </div>
    </v-card>

    <!--popups for class-->
    <!--popup for adding a class-->
    <v-card v-if="popoverToggles.addMenu" height="312" elevation="0">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon color="white">add_circle_outline</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span class="text-white">Add Class</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-card height="200" elevation="0">
        <div class="card-icon center">
          <div class="center">
            <v-icon :color="addClass.color" large>folder_shared</v-icon>
          </div>
          <div style="padding-right: 60px;">
            <form @submit.prevent="createClass">
              <v-text-field
                v-model="addClass.name"
                :error-messages="formErrors('add')"
                label="Name"
                required
              ></v-text-field>
            </form>
            <v-list style="background-color: #fafafa; margin-top: 20px;">
              <span class="branded-grey" style="font-size:.9rem">Class Folder Color</span>
              <v-list-tile>
                 <v-list-tile-content style="margin-left:-16px;">
                   <el-color-picker v-model="addClass.color" @input="checkColor"></el-color-picker>
                 </v-list-tile-content>
                 <v-list-tile-action>
                   <span v-if="addClass.colorWarning" style="color:red;">This color is too light to choose.</span>
                 </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </div>
        </div>
      </v-card>
     <v-divider></v-divider>
     <v-card-actions class="row-space" style="height:56px">
        <v-btn flat class="branded-grey" @click="closeMenu('addClass')">Cancel</v-btn>
        <v-btn class="branded-background text-white" :disabled="formErrors('add').length > 0" @click="createClass">Save</v-btn>
      </v-card-actions>
    </v-card>

    <!--popup for editing a class-->
    <v-card v-if="popoverToggles.editMenu" height="312" elevation="0">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon color="white">edit</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span class="text-white">Edit Class</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-card height="200" elevation="0">
        <div class="card-icon">
          <div class="center">
            <v-icon :color="editClass.default_color" large>folder_shared</v-icon>
          </div>
          <div style="padding: 20px 60px 20px 20px;">
            <form @submit.prevent="editClassFunc" class="edit-class">
              <v-text-field
                v-model="editClass.name"
                :error-messages="formErrors('edit')"
                label="Name"
                required
              ></v-text-field>
            </form>
            <v-list style="background-color: #fafafa;">
              <span class="branded-grey" style="font-size:.9rem">Class Folder Color</span>
              <v-list-tile >
               <v-list-tile-content style="margin-left:-16px;">
                 <el-color-picker v-model="editClass.default_color" @input="checkColor"></el-color-picker>
               </v-list-tile-content>
               <v-list-tile-action>
                 <span v-if="editClass.colorWarning" style="color:red;">This color is too light to choose.</span>
               </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </div>
        </div>
      </v-card>
     <v-divider></v-divider>
     <v-card-actions class="row-space" style="height:56px">
        <v-btn flat class="branded-grey" @click="closeMenu('edit')">Cancel</v-btn>
        <v-btn class="branded-background text-white" :disabled="formErrors('edit').length > 0 || editClassChanged"  @click="editClassFunc">Save</v-btn>
      </v-card-actions>
    </v-card>

    <!--popup for adding folder-->
    <v-card v-if="popoverToggles.addFolder" height="412" elevation="0">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon color="white">add_circle_outline</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span class="text-white">Add Folder</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-card height="300" elevation="0">
        <div class="card-icon center">
          <div class="center">
            <v-icon :color="addFolder.default_color" large>folder</v-icon>
          </div>
          <div style="padding-right: 60px;">
            <form @submit.prevent="createFolder">
              <v-text-field
                v-model="addFolder.name"
                :error-messages="formErrors('foldername')"
                label="Name"
                required
              ></v-text-field>
            </form>
            <v-list style="background-color: #fafafa; margin-top: 20px;">
              <span class="branded-grey" style="font-size:.9rem">Folder Color</span>
              <v-list-tile>
                 <v-list-tile-content style="margin-left:-16px;">
                   <el-color-picker v-model="addFolder.default_color" @input="checkColor"></el-color-picker>
                 </v-list-tile-content>
                 <v-list-tile-action>
                   <span v-if="addFolder.colorWarning" style="color:red;">This color is too light to choose.</span>
                 </v-list-tile-action>
              </v-list-tile>
            </v-list>
            <v-list style="background-color: #fafafa; margin-top: 20px;">
              <v-list-tile-content >
                <v-select
                  v-if="activeViewInstructor === 'Folders'"
                  style="width:100%;"
                  :items="subfolderOptions"
                  v-model="addFolder.subfolder"
                  label="Create Folder In"
                ></v-select>
                <v-select
                  v-if="activeViewInstructor === 'Folder'"
                  style="width:100%;"
                  :items="subfolderOptions"
                  disabled
                  :value="queryParamsInstructors.folder_id"
                  label="Create Folder In"
                ></v-select>
              </v-list-tile-content>
            </v-list>
          </div>
        </div>
      </v-card>
     <v-divider></v-divider>
     <v-card-actions class="row-space" style="height:56px">
        <v-btn flat class="branded-grey" @click="closeMenu('addFolder')">Cancel</v-btn>
        <v-btn class="branded-background text-white" :disabled="formErrors('foldername').length > 0"  @click="createFolder">Save</v-btn>
      </v-card-actions>
    </v-card>

    <!--popup for adding Nodefolder-->
    <v-card v-if="popoverToggles.addNodeFolder" height="240" elevation="0">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon color="white">add_circle_outline</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span class="text-white">Add Folder</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-card height="125" elevation="0">
        <div class="card-icon center">
          <div class="center ">
            <v-icon class="branded-text" large>folder</v-icon>
          </div>
          <div style="padding-right: 60px;">
            <form @submit.prevent="createNodeFolder">
              <v-text-field
                v-model="addFolder.name"
                :error-messages="formErrors('foldername')"
                label="Name"
                required
              ></v-text-field>
            </form>
          </div>
        </div>
      </v-card>
     <v-divider></v-divider>
     <v-card-actions class="row-space" style="height:56px">
        <v-btn flat class="branded-grey" @click="closeMenu('addNodeFolder')">Cancel</v-btn>
        <v-btn class="branded-background text-white" :disabled="formErrors('foldername').length > 0"   @click="createNodeFolder">Save</v-btn>
      </v-card-actions>
    </v-card>

    <!--popup for editing folder-->
    <v-card v-if="popoverToggles.editFolder" height="412" elevation="0">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon color="white">folder</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span class="text-white">Edit Folder</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-card height="300" elevation="0">
        <div class="card-icon center">
          <div class="center">
            <v-icon :color="editFolder.default_color" large>folder</v-icon>
          </div>
          <div style="padding-right: 60px;">
            <form @submit.prevent="editFolderFunc">
              <v-text-field
                v-model="editFolder.name"
                :error-messages="formErrors('foldernameedit')"
                label="Name"
                required
              ></v-text-field>
            </form>
            <v-list style="background-color: #fafafa; margin-top: 20px;">
              <span class="branded-grey" style="font-size:.9rem">Folder Color</span>
              <v-list-tile>
                 <v-list-tile-content style="margin-left:-16px;">
                   <el-color-picker v-model="editFolder.default_color" @input="checkColor"></el-color-picker>
                 </v-list-tile-content>
                 <v-list-tile-action>
                   <span v-if="editFolder.colorWarning" style="color:red;">This color is too light to choose.</span>
                 </v-list-tile-action>
              </v-list-tile>
            </v-list>
            <v-list style="background-color: #fafafa; margin-top: 20px;">
              <v-list-tile-content >
                <v-select
                  style="width:100%;"
                  :items="subfolderOptions"
                  :disabled="editFolder.subfolder === 0"
                  v-model="editFolder.subfolder"
                  label="Create Folder In"
                ></v-select>
              </v-list-tile-content>
            </v-list>
          </div>
        </div>
      </v-card>
     <v-divider></v-divider>
     <v-card-actions class="row-space" style="height:56px">
        <v-btn flat class="branded-grey" @click="closeMenu('addFolder')">Cancel</v-btn>
        <v-btn class="branded-background text-white" :disabled="formErrors('foldernameedit').length > 0 || !editFolderChange"  @click="editFolderFunc">Save</v-btn>
      </v-card-actions>
    </v-card>
    
     <!--popup for editing node folder-->
    <v-card v-if="popoverToggles.editNodeFolder" height="412" elevation="0">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon color="white">folder</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span class="text-white">Edit Folder</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-card height="300" elevation="0">
        <div class="card-icon center">
          <div class="center">
            <v-icon class="branded-text" large>folder</v-icon>
          </div>
          <div style="padding-right: 60px;">
            <form @submit.prevent="editTreeFolderFunc"> 
              <v-text-field
                v-model="editFolder.name"
                :error-messages="formErrors('foldernameedit')"
                label="Name"
                required
              ></v-text-field>
            </form>
          </div>
        </div>
      </v-card>
     <v-divider></v-divider>
     <v-card-actions class="row-space" style="height:56px">
        <v-btn flat class="branded-grey" @click="closeMenu('editNodeFolder')">Cancel</v-btn>
        <v-btn  class="branded-background text-white"  @click="editTreeFolderFunc">Save</v-btn>
      </v-card-actions>
    </v-card>

    <!--popover to add bulb to folder-->
     <v-card v-if="popoverToggles.addToFolder" height="462" elevation="0">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-responsive :aspect-ratio="16/9" max-height="36px" max-width="64px" style="margin-right: 20px;">
            <div class="thumbnail-wrapper-nonselect" :style="videoThumbnail"></div>
          </v-responsive>
          <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span class="text-white text-truncate-popover">Add "{{dialogShow.data.name}}" to Folder</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-card elevation="0" v-if="popoverDataLoading" height="350">
        <v-container  class="loader-popover">
          <v-progress-circular indeterminate size=50 :width="5"></v-progress-circular>
        </v-container>
      </v-card>
      <v-card elevation="0" v-if="!popoverDataLoading">
        <div style="background-color: white;">
          <div style="width:100%; height: 50px;" class="column">
            <span>Expand row to add bulb to subfolders</span>
          </div>
          <el-table
          :data="foldersBulb.folders"
          height="300px"
          :show-header="false"
          >
            <el-table-column type="expand">
              <template slot-scope="props">
                <div>
                  <el-table
                  :data="props.row.subfolders"
                  height="60px"
                  :row-class-name="subFolderClass"
                  :show-header="false"
                  >
                    <el-table-column
                      prop=""
                      label=""
                      width="95">
                    </el-table-column>
                    <el-table-column
                      prop=""
                      label=""
                      width="50">
                      <template slot-scope="scope">
                        <div class="row-center">
                          <v-icon :color="scope.row.default_color">folder</v-icon>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="name"
                      label="Folder Name"
                      min-width="200"
                      >
                      <template slot-scope="scope">
                        <div class="row-start">
                          <span
                            :class="[ isSafari ? 'safari-bulb-name-truncate' : 'bulb-name-truncate' ]">
                            {{ scope.row.name }}
                          </span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop=""
                      align="center"
                      label="Add To Folder"
                      width="250">
                      <template slot-scope="scope">
                       <v-btn class="branded-background text-white subfolder-btn" v-if="!(scope.row.id in foldersBulb.folders_bulb)" @click="addBulbToFolder(scope.row.id)">Add to Subfolder</v-btn>
                       <v-btn class="branded-text subfolder-btn" flat text  v-if="scope.row.id in foldersBulb.folders_bulb" @click="removeBulbToFolder(scope.row.id)">Remove from Subfolder</v-btn>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop=""
                      label=""
                      width="50">
                      <template slot-scope="scope">
                      </template>
                    </el-table-column>
                    <template slot="empty">
                      <h5 style="margin-top: 16px;">No subfolders in this folder.</h5>
                    </template>
                  </el-table>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop=""
              label=""
              width="50">
              <template slot-scope="scope">
                <div class="row-center">
                  <v-icon :color="scope.row.default_color">folder</v-icon>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="Folder Name"
              min-width="200"
              >
              <template slot-scope="scope">
                <div class="row-start" :style="isSafari ? 'width: 200px' : ''">
                  <span class="bulb-name-truncate">
                    {{scope.row.name}}
                  </span>
              </div>
            </template>
            </el-table-column>
            <el-table-column
              prop=""
              align="center"
              label="Add To Folder"
              width="300">
              <template slot-scope="scope">
                  <v-btn class="branded-background text-white" v-if="!(scope.row.id in foldersBulb.folders_bulb)" @click="addBulbToFolder(scope.row.id)">Add to Folder</v-btn>
                  <v-btn class="branded-text" flat text v-if="scope.row.id in foldersBulb.folders_bulb" @click="removeBulbToFolder(scope.row.id)">Remove from Folder</v-btn>
              </template>
            </el-table-column>
            <el-table-column
              prop=""
              label=""
              width="100">
              <template slot-scope="scope">
              </template>
            </el-table-column>
            <template slot="empty">
              <h5 style="margin-top: 16px;">No Folders. Create a folder before adding a bulb</h5>
            </template>
          </el-table>
        </div>
      </v-card>
      <v-divider></v-divider>
      <v-card-actions class="row-space" style="height:56px">
        <v-btn flat class="branded-grey" @click="closeMenu('monitor')">Cancel</v-btn>
        <v-btn class="branded-background text-white"  @click="closeMenu('monitor')">Save</v-btn>
      </v-card-actions>
    </v-card>

    <!--//popup for copying a folder-->
    <v-card v-if="popoverToggles.copyFolder" elevation="0">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon color="white">folder</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span class="text-white">Copy Folder</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-card  elevation="0">
        <v-list three-line>
          <v-list-tile >
            <v-list-tile-content>
              Would you like to create a copy of the {{dialogShow.data.subfolder ? 'subfolder' : 'folder'}} "{{dialogShow.data.data.name}}"?
            </v-list-tile-content>
          </v-list-tile>
          <v-spacer></v-spacer>
        </v-list>
        <v-list three-line>
          <v-list-tile class="center">
            <v-list-tile-content >
              <form @submit.prevent="copyFolderFunc" class="full-width">
                <v-text-field
                  class="full-width"
                  v-model="copyFolder.name"
                  label="Copied Folder Name"
                  :error-messages="formErrors('copyFolder')"
                ></v-text-field>
              </form>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
      <v-divider></v-divider>
        <v-card-actions class="row-space" style="height:56px">
          <v-btn flat class="branded-grey" @click="closeMenu('copyFolder')">Cancel</v-btn>
          <div class="row-center">
            <v-btn text class="branded-background text-white"  @click="copyFolderFunc" :disabled="formErrors('copyFolder').length > 0" >Copy</v-btn>
          </div>
        </v-card-actions>
    </v-card>

    <!--//popup to share folder-->
    <v-card v-if="popoverToggles.shareFolder" elevation="0">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon color="white">folder</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span class="text-white">Share Folder "{{dialogShow.data.name}}"</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-card elevation="0">
        <div style="padding:0px 24px; width: 100%; height: 30px; display:flex; flex-flow: row; justify-content: flex-start; align-items: flex-end;">
          <span>Share url:</span>
        </div>
        <div class="share-learner-copy-container">
          <v-text-field  box hide-details readonly :value="shareFolderUrl" aria-label="folder url"></v-text-field>
          <ClipboardCopy :copyText="shareFolderUrl"></ClipboardCopy>
        </div>
     </v-card>
     <v-divider></v-divider>
     <v-card-actions class="row-space" style="height:56px">
        <v-btn  flat class="branded-grey" @click="closeMenu('shareFolder')" tabindex="4" aria-label="Close button. Press enter to exit share bulb">Close</v-btn>
     </v-card-actions>
    </v-card>

    <!--Popups for Student Mangagement-->

    <!--popup for moving students-->
    <v-card v-if="popoverToggles.moveMenu"  height="412" style="min-width:650px;" elevation="0">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon color="white">arrow_right_alt</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span class="text-white">Move Student{{this.selectedData.length > 1 ? 's' : ''}} To New Class</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-card height="295" elevation="0" style="margin-top: 10px;">
        <el-table
          :data="classes.data"
          highlight-current-row
          @current-change="handleMoveCurrent"
          height="300px"
          :row-class-name="moveStudentTable"
        >
          <el-table-column
            prop="name"
            label="Class Name">
          </el-table-column>
        </el-table>
      </v-card>
      <v-card-actions class="row-space" style="height:56px">
        <v-btn flat class="branded-grey" @click="closeMenu('move')">Cancel</v-btn>
        <div class="row-center">
          <v-btn flat text class="branded-text" @click="downloadData('Learners-BA')" :disabled="Object.keys(moveClass.classSelected).length === 0">Download Data</v-btn>
          <v-btn class="branded-background text-white" @click="moveStudents(true)" :disabled="Object.keys(moveClass.classSelected).length === 0">Move</v-btn>
        </div>
      </v-card-actions>
    </v-card>


    <!--Popups for Bulb Actions-->

    <!--popup for removing bulb/class/learner-->
    <v-card v-if="popoverToggles.remove" style="min-width:650px;">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-icon color="white" class="padding-right">{{remove.icon}}</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span class="text-white text-truncate-popover">{{remove.title}}</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-card elevation="0">
        <v-card-title>
          {{remove.question}}
          <v-btn flat text class="branded-text" v-if="remove.type != 'Folders' && remove.type != 'BulbFolder'" id="removeAccessButton" @click="downloadData(remove.type)" :disabled="dialogShow.data.bulb_role > 1">{{downloadDataText}}</v-btn>
        </v-card-title>
      </v-card>
      <v-card-actions class="row-space" style="height:56px">
        <v-btn flat class="branded-grey" @click="closeMenu('remove')">Cancel</v-btn>
        <div class="row-center">
          <v-btn class="branded-background text-white" @click="removeItem(remove.type)">{{remove.action}}</v-btn>
        </div>
      </v-card-actions>
    </v-card>



    <!--//popup for copying a bulb-->
    <v-card v-if="popoverToggles.copyMenu" elevation="0">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-responsive :aspect-ratio="16/9" max-height="36px" max-width="64px" style="margin-right: 20px;">
            <div class="thumbnail-wrapper-nonselect" :style="videoThumbnail"></div>
          </v-responsive>
          <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span class="text-white">Copy Bulb</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-card  elevation="0">
        <v-list three-line>
          <v-list-tile >
            <v-list-tile-content>
              Would you like to create a copy of "{{(filterSearch.legacy)? dialogShow.data.title : dialogShow.data.name}}"?
            </v-list-tile-content>
          </v-list-tile>
          <v-spacer></v-spacer>
        </v-list>
        <v-list three-line>
          <v-list-tile class="center">
            <v-list-tile-content >
              <form @submit.prevent="" class="full-width">
                <v-text-field
                  class="full-width"
                  v-model="copy.name"
                  label="Copied Bulb Name"
                  :placeholder="copyBulbName"
                  :error-messages="formErrors('copy')"
                ></v-text-field>
              </form>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-spacer></v-spacer>
        <div
          v-if="_.isNull(dialogShow.data.lmb_id)"
          class="copy-advanced">
          <a class="link-button" @click="copy.advanced = !copy.advanced" >Advanced settings</a>
          <div v-if="copy.advanced">
            <v-switch v-model="copy.fullCopy" :label="copyBulbLabel" hide-details height="30"></v-switch>
          </div>
        </div>
      </v-card>
      <v-divider></v-divider>
        <v-card-actions class="row-space" style="height:56px">
          <v-btn flat class="branded-grey" @click="closeMenu('copy')">Cancel</v-btn>
          <div class="row-center">
            <v-btn
              @click="copyBulb(true, dialogShow.data.id)"
              v-if="!dialogShow.data.lmb_id"
              :disabled="formErrors('copy').length > 0"
              flat
              text
              class="branded-text"
            >
              Copy & Edit
            </v-btn>
            <v-btn
              text
              class="branded-background text-white"
              @click="copyBulb(false, dialogShow.data.id, dialogShow.data.lmb_id)"
              :disabled="formErrors('copy').length > 0">
              Copy Only
            </v-btn>
          </div>
        </v-card-actions>
    </v-card>

    <!--//popup for sharing a bulb-->
    <v-card v-if="popoverToggles.shareMenu" elevation="0">
      <v-list class="branded-background">
        <v-list-tile v-if="selectedData.length > 0">
          <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span class="text-white text-truncate-popover">Adding Co-owners for {{  dialogShow.data.bulbs.length }} Bulbs</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile avatar v-else>
          <v-responsive :aspect-ratio="16/9" max-height="36px" max-width="64px" style="margin-right: 20px;">
            <div class="thumbnail-wrapper-nonselect" :style="videoThumbnail"></div>
          </v-responsive>
          <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span class="text-white text-truncate-popover">{{(activeViewInstructor === 'Bulbs') ? 'Assign' : 'Collaborate on'}} "{{dialogShow.data.name}}"</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <Share
        :bulb_data="dialogShow.data"
        :class_data="assignClass"
        :instructor_id="instructorData.id"
        :classes="classes"
        :hotlink="popoverHotlink"
        :type="activeViewInstructor"
        :lti="LTIlaunch"
        :school_id="school.id">
      </Share>
      <v-divider></v-divider>
      <v-card-actions class="row-space" style="height:56px">
        <v-btn v-if="permissionPending" flat class="branded-grey" @click="undoBulbTransfer">Cancel</v-btn>
        <v-btn v-else flat class="branded-grey" @click="closeMenu('shareMenu')">Close</v-btn>
        <v-btn v-if="permissionPending" flat class="branded-background text-white" @click="transferOwnership(dialogShow.data.id)">Transfer Bulb(s)</v-btn>
      </v-card-actions>
    </v-card>

    <!--//popup for sharing a class-->
    <v-card v-if="popoverToggles.coursePermission" elevation="0">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-icon color="white" class="mr-2">folder_shared</v-icon>
          <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span class="text-white text-truncate-popover">Collaborate on "{{ dialogShow.data.name }}"</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <CoursePermission
        :selectedClass="dialogShow.data"
        :school_id="school.id"
        :overwriteAccess.sync="overwriteAccess"
      ></CoursePermission>
      <v-divider></v-divider>
      <v-card-actions class="row-space" style="height:56px">
        <v-btn
          @click="undoSectionTransfer"
          v-if="permissionPending"
          flat
          class="branded-grey"
        >
          Cancel
        </v-btn>
        <v-btn
          @click="closeMenu('coursePermission')"
          v-else
          flat
          class="branded-grey"
        >
          Close
        </v-btn>
        <v-btn
          v-if="permissionPending"
          flat
          class="branded-background text-white"
          @click="transferSectionOwnership(dialogShow.data.id)"
        >
          Transfer Class
        </v-btn>
      </v-card-actions>
    </v-card>

    <!--//popup for assigning a bulb from My Bulbs-->
    <v-card v-if="popoverToggles.assignMenu" height="assignPopoverHeight" elevation="0">
      <v-list class="branded-background">
      	<v-list-tile avatar>
      	<v-responsive :aspect-ratio="16/9" max-height="36px" max-width="64px" style="margin-right: 20px;">
      		<div class="thumbnail-wrapper-nonselect" :style="videoThumbnail"></div>
      	</v-responsive>
      	<v-list-tile-content style="display: flex; flex-flow: row; justify-content:space-between; align-items:center">
      		<v-list-tile-title >
      			<span :class="instructorType === 'free' ? 'text-white text-truncate-popover assign-title-width': 'text-white text-truncate-popover'">Assign {{dialogShow.data.name}}</span>
      		</v-list-tile-title>
      		<v-tooltip
      			v-if="instructorType === 'free'"
      			top
      			:z-index="99999999999"
      		>
      			<template slot="activator">
      				<div class="assign-limit">
      					<v-progress-linear
      						no-flex
      						v-model="baPercentage"
      						color="white"
      					></v-progress-linear>
      					<div
      						ref="storageLabel"
      						class="assign-limit-label"
      					>
      						<v-icon
      							v-show="baPercentage >= 90"
      							color="white"
      							small
      							class="mr-1"
      						>
      							warning
      						</v-icon>
      						{{baPercentage}}% of bulb attempts used.
      					</div>
      				</div>
      			</template>
      			<v-layout column justify-center>
      				<v-layout justify-space-between>
      					<div class="text-white">Current bulb attempts used:</div>
      					<div class="text-white" style="padding-left:8px;">{{free.ba_limit}}</div>
      				</v-layout>
      			</v-layout>
      		</v-tooltip>
      	</v-list-tile-content>
       </v-list-tile>
      </v-list>
      <v-tabs grow v-model="assignTabs">
        <v-tab>
          Assign to Class
        </v-tab>
        <v-tab :disabled="assignBroadcast">
          Get Assign Link
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="assignTabs">
        <v-tab-item :key="0">
          <AssignCourse :assignBroadcast="assignBroadcast" :hotlinkAssignLink="hotlinkAssignLink"></AssignCourse>
        </v-tab-item>
        <v-tab-item :key="1">
          <AssignLink :assignClass="assignClass" :bulb="dialogShow.data" :hotlink="popoverHotlink" :hotlinkAssignCourse="hotlinkAssignCourse"></AssignLink>
        </v-tab-item>
      <v-divider></v-divider>
        <v-card-actions class="row-space" style="height:56px">
         <v-btn flat class="branded-grey" @click="closeMenu('assign')">Close</v-btn>
        </v-card-actions>
      </v-tabs-items>
    </v-card>


    <!--//popup for monitor a bulb from My Bulbs-->
    <v-card v-if="popoverToggles.monitor" height="412" elevation="0">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-responsive :aspect-ratio="16/9" max-height="36px" max-width="64px" style="margin-right: 20px;">
            <div class="thumbnail-wrapper-nonselect" :style="videoThumbnail"></div>
          </v-responsive>
          <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span class="text-white text-truncate-popover">Monitor "{{dialogShow.data.name}}"</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-card elevation="0" v-if="popoverDataLoading" height="300">
        <v-container  class="loader-popover">
          <v-progress-circular indeterminate size=50 :width="5"></v-progress-circular>
        </v-container>
      </v-card>
      <v-card elevation="0" v-if="!popoverDataLoading">
        <div style="background-color: white;">
          <el-table
          :data="classes.data"
          height="300px"
          :row-class-name="assignTableClass"
          :show-header="false"
          >
            <el-table-column
              prop=""
              label=""
              width="50">
              <template slot-scope="scope">
                <div class="row-center">
                  <v-icon v-if="scope.row.lmsType" :color="scope.row.default_color">folder</v-icon>
                  <v-icon v-if="!scope.row.lmsType" :color="scope.row.default_color">folder_shared</v-icon>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="Class Name"
              width="350"
              >
            </el-table-column>
            <el-table-column
              prop=""
              align="center"
              label="Date Picker"
              class-name="flex-stretch-center"
              width="300">
              <template slot-scope="scope">
                <v-btn-toggle
                  v-if="assignDates[scope.row.id] || (assignDates[scope.row.id] === null)"
                  class="independent-btn-toggle"
                >
                  <v-btn
                    depressed
                    class='branded-background text-white'
                    @click="monitorHotlink(scope.row)"
                  >
                    Monitor
                  </v-btn>
                  <v-btn
                    color="primary"
                    class="lighten-1 no-left-border"
                    outline
                    @click="externalMonitorHotlink(scope.row)"
                  >
                    <v-icon
                      small
                      color="primary"
                    >
                      open_in_new
                    </v-icon>
                  </v-btn>
                </v-btn-toggle>
                <v-btn
                  @click="instructorData.migrated ? null : popoverHotlink('monitor', 'assignMenu', 'assign')"
                  v-if="(assignDates[scope.row.id] === undefined) && !scope.row.lmsType"
                  flat
                  text
                  class='branded-text'
                  :disabled="!!instructorData.migrated"
                >
                  Assign bulb
                </v-btn>
                <span v-if="!(scope.row.id in assignDates) && scope.row.lmsType">Please assign bulb from {{scope.row.lmsType}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop=""
              label=""
              width="100">
              <template slot-scope="scope">
              </template>
            </el-table-column>
            <template slot="empty">
              <h1>No Classes. Create a class before monitoring bulb.</h1>
            </template>
          </el-table>
        </div>
      </v-card>
      <v-divider></v-divider>
      <v-card-actions class="row-space" style="height:56px">
        <v-btn flat class="branded-grey" @click="closeMenu('monitor')">Close</v-btn>
      </v-card-actions>
    </v-card>

     <!--//popup to broadcast a bulb from My Bulbs-->
    <v-card v-if="popoverToggles.broadcast" height="412" elevation="0">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-responsive :aspect-ratio="16/9" max-height="36px" max-width="64px" style="margin-right: 20px;">
            <div class="thumbnail-wrapper-nonselect" :style="videoThumbnail"></div>
          </v-responsive>
          <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span class="text-white text-truncate-popover">Broadcast "{{dialogShow.data.name}}"</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-card elevation="0" v-if="popoverDataLoading" height="300">
        <v-container  class="loader-popover">
          <v-progress-circular indeterminate size=50 :width="5"></v-progress-circular>
        </v-container>
      </v-card>
      <v-card elevation="0" v-if="!popoverDataLoading">
        <div style="background-color: white;">
          <el-table
          :data="classes.data"
          height="300px"
          :row-class-name="assignTableClass"
          :show-header="false"
          >
            <el-table-column
              prop=""
              label=""
              width="50">
              <template slot-scope="scope">
                <div class="row-center">
                  <v-icon v-if="scope.row.lmsType" :color="scope.row.default_color">folder</v-icon>
                  <v-icon v-if="!scope.row.lmsType" :color="scope.row.default_color">folder_shared</v-icon>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="Class Name"
              width="350"
              >
            </el-table-column>
            <el-table-column
              prop=""
              align="center"
              label="Date Picker"
              width="300">
              <template slot-scope="scope">
                <v-btn
                  @click="instructorData.migrated ? null : broadcast({ class: scope.row, bulb_section: assignedBulbSections[scope.row.id]})"
                  v-if="assignDates[scope.row.id] || (assignDates[scope.row.id] === null)"
                  class='branded-background text-white'
                  :disabled="!!instructorData.migrated"
                >
                  Broadcast
                </v-btn>
                <v-btn
                  @click="instructorData.migrated ? null : popoverHotlink('monitor', 'assignMenu', 'broadcast')"
                  v-if="assignDates[scope.row.id] === undefined 
                  && (!scope.row.lmsType
                  || scope.row.lmsType === 'Google' 
                  || scope.row.lmsType === 'SchoologyFree'
                  || scope.row.lmsType === 'Clever')" 
                  flat text class='branded-text'
                  :disabled="!!instructorData.migrated"
                >
                  Assign bulb
                </v-btn>
                <span
                  v-if="!(scope.row.id in assignDates)
                  && scope.row.lmsType
                  && scope.row.lmsType !== 'Google' 
                  && scope.row.lmsType !== 'SchoologyFree'
                  && scope.row.lmsType !== 'Clever'"
                >
                  Please broadcast bulb from {{scope.row.lmsType}}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop=""
              label=""
              width="100">
              <template slot-scope="scope">
              </template>
            </el-table-column>
            <template slot="empty">
              <h1>No Classes. Create a class before monitoring bulb.</h1>
            </template>
          </el-table>
        </div>
      </v-card>
      <v-divider></v-divider>
      <v-card-actions class="row-space" style="height:56px">
        <v-btn flat class="branded-grey" @click="closeMenu('broadcast')">Close</v-btn>
      </v-card-actions>
    </v-card>

     <!--Learner Made Bulbs-->

    <!--popup for adding a learner made bulb-->
    <v-card v-if="popoverToggles.lmb" elevation="0">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon color="white">add_circle_outline</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span v-if="!lmbData.peer_review" class="text-white">Add Learner Made Bulb</span>
              <span v-else class="text-white">Add Peer Review Assignment</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-card elevation="0">
        <v-container>
          <v-list three-line style="background-color:#fafafa">
            <v-list-tile>
              <v-text-field
                autofocus
                v-model="lmbData.name"
                :error-messages="formErrors('lmb') && errors"
                :label="!lmbData.peer_review ? 'Name of Learner Made Bulb' : 'Name of Peer Review Assignment'"
                @blur="lmbData.name === '' ? errors.push('Name is required') : ''"
              ></v-text-field>
            </v-list-tile>
            <v-list-tile>
              <v-textarea
                :rows="2"
                no-resize
                v-model="lmbData.learning_objective"
                label="Learning objective/instructions"
                counter="255"
                maxlength="255"
              ></v-textarea>
            </v-list-tile>
          </v-list>
          <v-spacer></v-spacer>
          <a class="link-button" @click="lmbData.advanced = !lmbData.advanced" >Advanced settings</a>
          <div class="flex-column" v-if="lmbData.advanced">
            <div style="padding: 0px 16px;">
              <v-text-field
                v-model.number="lmbData.points"
                type="number"
                max=100
                :error-messages="formErrors('lmbpoints')"
                label="Points"
                required
                :disabled="lmbData.pr_rubric"
             ></v-text-field>
            </div>
            <v-switch
              v-if="instructorType !== 'pro'"
              v-model="lmbData.allowPrivateVideoHosts"
              label="Allow learners to use private video hosts"
              hide-details
              height="30"
              style="padding: 0px 16px;"
            ></v-switch>
            <v-switch
              v-if="(
                instructorType !== 'pro'
                && school
                && Array.isArray(school.permissionKeys)
                && school.permissionKeys.includes('enableAllowLmbStudentVideoIntegrationAccessToggle')
              )"
              v-model="lmbData.learnersAccessTheirOwnVideoIntegrationContent"
              :disabled="!lmbData.allowPrivateVideoHosts"
              hide-details
              height="30"
              style="padding: 0px 36px;"
            >
              <template v-slot:label>
                <div id="lmb-private-video-host-content-label">
                  Learners will access their own content within private video hosts
                  <Tooltip
                    top
                    :z-index="9999999999999999999"
                    attach="#lmb-private-video-host-content-label"
                    content-class="lmb-private-video-host-content-label-content"
                  >
                    <v-icon
                      color="primary"
                      class="nudge-top-3px ml-2"
                    >
                      info_outline
                    </v-icon>
                    <template v-slot:text>
                      If not enabled, learners will access their teacher's content within private video hosts.
                    </template>
                  </Tooltip>
                </div>
              </template>
            </v-switch>
            <div
              class="d-flex advanced-section-lmb"
              v-if="
                (
                  (
                    (
                      instructorType === 'institutionLTI'
                      || instructorType === 'institutionNonLTI'
                    )
                    && (
                      adminData.hosting
                      || adminData.mp4
                    )
                  )
                  || instructorType === 'pro'
                ) && !adminData.hasLimitedVideoUploadAccess
              ">
              <v-switch v-model="lmbData.allow_upload" hide-details height="30" style="padding: 0px 16px;">
                <template v-slot:label>
                  Allow learners to upload video files
                  <div v-if="!lmbData.peer_review">
                    <v-btn flat icon class="branded-text" href="https://knowledge.playposit.com/article/214-learner-made-bulbs-in-3-0#lmb-upload" target="_blank">
                      <v-icon>info</v-icon>
                    </v-btn>
                  </div>
                </template>
              </v-switch>
            </div>
            <v-switch v-model="lmbData.peer_review" label="Enable peer review" hide-details height="30" v-if="peerReviewSchool" style="padding: 0px 16px;"></v-switch>
            <v-switch v-model="lmbData.pr_rubric" label="Enable grading rubric" hide-details height="30" style="padding: 0px 36px;" :disabled="!lmbData.peer_review" v-if="peerReviewSchool"></v-switch>
            <v-switch v-model="lmbData.pr_anonymous" label="Anonymize student rubric submissions" hide-details height="30" style="padding: 0px 36px;" :disabled="!lmbData.pr_rubric" v-if="peerReviewSchool"></v-switch>
            <div class="d-flex justify-space-between advanced-section-lmb">
              <v-switch v-model="lmbData.autograde" hide-details height="30" style="padding: 0px 16px;" :disabled="lmbData.pr_rubric">
                <template v-slot:label>
                  Enable complete/incomplete grading
                  <div v-if="LMSdata.type === 'Canvas'">
                    <v-btn flat icon class="branded-text" href="https://knowledge.playposit.com/article/224-peer-review-instructors#setup " target="_blank">
                      <v-icon>info</v-icon>
                    </v-btn>
                  </div>
                  <div v-else-if="LMSdata.type !== ''">
                    <v-btn flat icon class="branded-text" href="https://knowledge.playposit.com/article/291-peer-review-for-instructors-using-playposit-groups#setup" target="_blank">
                      <v-icon>info</v-icon>
                    </v-btn>
                  </div>
                </template>
              </v-switch>
            </div>
          </div>
        </v-container>
      </v-card>
     <v-divider></v-divider>
     <v-card-actions class="row-space" style="height:56px">
        <v-btn flat class="branded-grey" @click="closeMenu('lmb')">Cancel</v-btn>
        <v-btn class="branded-background text-white" 
          :disabled="formErrors('lmb').length > 0 || formErrors('lmbpoints').length > 0" 
          @click="createLMB"
          :loading="instructorAjaxing"
        >{{(lmbData.peer_review && lmbData.pr_rubric) ? 'Create Rubric' : 'Save'}}</v-btn>
      </v-card-actions>
    </v-card>

    <!--popup for editing a learner made bulb-->
    <v-card v-if="popoverToggles.lmbEdit" elevation="0">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-list-tile-avatar :size="48">
            <v-responsive :aspect-ratio="16/9">
              <div class="thumbnail-wrapper-nonselect" :style="videoThumbnail"></div>
            </v-responsive>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span v-if="!lmbData.peer_review" class="text-white">Edit Learner Made Bulb</span>
              <span v-else class="text-white">Edit Peer Review Assignment</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-card elevation="0">
        <v-container>
          <v-list three-line style="background-color:#fafafa">
            <v-list-tile>
              <v-text-field
                v-model="lmbData.name"
                :error-messages="formErrors('lmb')"
                :label="!lmbData.peer_review ? 'Name of Learner Made Bulb' : 'Name of Peer Review Assignment'"
                required
              ></v-text-field>
            </v-list-tile>
            <v-list-tile>
              <v-textarea
                :rows="3"
                no-resize
                v-model="lmbData.learning_objective"
                label="Learning objective/instructions"
                counter="255"
                maxlength="255"
              ></v-textarea>
            </v-list-tile>
          </v-list>
          <v-spacer></v-spacer>
          <a class="link-button" @click="lmbData.advanced = !lmbData.advanced" >Advanced settings</a>
          <div v-if="lmbData.advanced">
            <div v-if="!(lmbData.pr_rubric || (!editLMBRubric && instructorType === 'institutionLTI'))"style="padding: 0px 16px;">
              <v-text-field
                v-model.number="lmbData.points"
                type="number"
                min=0
                :max="lmbData.pr_rubric ? null : 100"
                :error-messages="formErrors('lmbpoints')"
                label="Points"
                required
             ></v-text-field>
            </div>
            <v-switch
              v-if="instructorType !== 'pro'"
              v-model="lmbData.allowPrivateVideoHosts"
              label="Allow learners to use private video hosts"
              hide-details
              height="30"
              style="padding: 0px 16px;"
            ></v-switch>
            <v-switch
              v-if="(
                instructorType !== 'pro'
                && school
                && Array.isArray(school.permissionKeys)
                && school.permissionKeys.includes('enableAllowLmbStudentVideoIntegrationAccessToggle')
              )"
              v-model="lmbData.learnersAccessTheirOwnVideoIntegrationContent"
              :disabled="!lmbData.allowPrivateVideoHosts"
              hide-details
              height="30"
              style="padding: 0px 36px;"
            >
              <template v-slot:label>
                <div id="lmb-private-video-host-content-label">
                  Learners will access their own content within private video hosts
                  <Tooltip
                    top
                    :z-index="9999999999999999999"
                    attach="#lmb-private-video-host-content-label"
                    content-class="lmb-private-video-host-content-label-content"
                  >
                    <v-icon
                      color="primary"
                      class="nudge-top-3px ml-2"
                    >
                      info_outline
                    </v-icon>
                    <template v-slot:text>
                      If not enabled, learners will access their teacher's content within private video hosts.
                    </template>
                  </Tooltip>
                </div>
              </template>
            </v-switch>
            <div class="d-flex advanced-section-lmb" v-if="(((instructorType === 'institutionLTI' || instructorType === 'institutionNonLTI') && (adminData.hosting || adminData.mp4)) || instructorType === 'pro') && !adminData.hasLimitedVideoUploadAccess">
              <v-switch v-model="lmbData.allow_upload" hide-details height="30" style="padding: 0px 16px;">
                <template v-slot:label>
                  Allow learners to upload video files
                  <div v-if="!lmbData.peer_review">
                    <v-btn flat icon class="branded-text" href="https://knowledge.playposit.com/article/214-learner-made-bulbs-in-3-0#lmb-upload" target="_blank">
                      <v-icon>info</v-icon>
                    </v-btn>
                  </div>
                </template>
              </v-switch>
            </div>
            <div style="padding: 0px 16px;">
              <span>Peer review settings cannot be changed. Create a new Learner Made Bulb to enable/disable peer review</span>
            </div>
            <v-switch v-if="peerReviewSchool" v-model="lmbData.peer_review" disabled label="Enable peer review" hide-details height="30" style="padding: 0px 16px;"></v-switch>
            <div class="advanced-section-lmb d-flex justify-space-between" v-if="peerReviewSchool">
              <v-switch v-model="lmbData.pr_rubric" label="Enable grading rubric" hide-details height="30" style="padding: 0px 0px 0px 36px;" disabled ></v-switch>
              <v-btn flat text class="branded-text" :disabled="!editLMBRubric" @click="editRubric" v-if="lmbData.pr_rubric" style="height:24px;">
                Edit Rubric
              </v-btn>
            </div>
            <v-switch v-model="lmbData.pr_anonymous" label="Anonymize student rubric submissions" hide-details height="30" style="padding: 0px 36px;" disabled v-if="peerReviewSchool"></v-switch>
            <div class="advanced-section-lmb d-flex justify-space-between">
              <v-switch v-model="lmbData.autograde" label="Enable complete/incomplete grading" hide-details height="30" :disabled="lmbData.pr_rubric || (!editLMBRubric && instructorType === 'institutionLTI')" style="padding: 0px 16px;"></v-switch>
            </div>
            <!-- <v-switch v-model="lmbData.share" label="Allow learners to share bulb with peers" hide-details height="30" :disabled="lmbData.peer_review" v-if="(instructorType === 'pro') || instructorType === 'institutionNonLTI'" style="padding: 0px 16px;"></v-switch>
            <v-switch v-model="lmbData.data" label="Allow learners to monitor peer responses" hide-details height="30" style="padding: 0px 36px;" :disabled="!lmbData.share || lmbData.anonymous || lmbData.peer_review" v-if="instructorType === 'pro' || instructorType === 'institutionNonLTI'"></v-switch>
            <v-switch v-model="lmbData.anonymous" label="Allow learners to monitor anonymous responses" hide-details height="30" style="padding: 0px 36px;":disabled="!lmbData.share || lmbData.data || lmbData.peer_review" v-if="instructorType === 'pro' || instructorType === 'institutionNonLTI'"></v-switch> -->
          </div>
        </v-container>
      </v-card>
     <v-divider></v-divider>
     <v-card-actions class="row-space" style="height:56px">
        <v-btn flat class="branded-grey" @click="closeMenu('lmbEdit')">Cancel</v-btn>
        <v-btn class="branded-background text-white" :disabled="formErrors('lmb').length > 0 || formErrors('lmbpoints').length > 0 || !lmbEditChange"  @click="editLMB">{{(lmbData.peer_review && lmbData.pr_rubric && lmbData.rubric_id === 0) ? 'Create Rubric' : 'Save'}}</v-btn>
      </v-card-actions>
    </v-card>

    <!--Popups for Videos-->


    <!--popup for uploading video-->
     <v-card v-if="popoverToggles.addVideo" style="height:512px;" elevation="0">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon color="white">cloud_upload</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span class="text-white">Upload Video</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-card elevation="0" v-if="popoverDataLoading" height="400">
        <v-container  class="loader-popover">
          <v-progress-circular indeterminate size=50 :width="5"></v-progress-circular>
        </v-container>
      </v-card>
      <v-card elevation="0" v-if="!popoverDataLoading" height="400">
        <PlaypositVideoTranscoder
          :api-url="serverURL"
          :token="instructorData.token"
          :teacher-id="instructorData.id"
          :bulb-id="newBulb"
          :showCloseButton="false"
          :activeColor="school.active_color"
          starting-key="upload"
          @success="handleVideoTranscoderSuccess"
          @error="handleVideoTranscoderError"
        />
      </v-card>
      <v-card-actions class="row-space" style="height:56px">
        <v-btn flat class="branded-grey" @click="closeMenu('addVideo')">Close</v-btn>
        <!--<div class="row-center">-->
        <!--  <v-btn class="branded-background text-white" @click="buildVideoBulb(data.video_id)">Build Into Bulb</v-btn>-->
        <!--</div>-->
      </v-card-actions>
    </v-card>

    <!--Popup for Data Export/Import-->

    <!--Popover for exporting data-->
    <v-card v-if="popoverToggles.export" elevation="0">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon color="white">cloud_download</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span class="text-white">Export {{this.exportType}} Data</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-card elevation="0">
        <v-card-title>
          When exporting data, please do not close window. In cases of large data sets or slow connections, please allow export to finish before closing window.
        </v-card-title>
      </v-card>
      <v-divider></v-divider>
      <v-card-actions class="row-space" style="height:56px">
        <v-btn flat class="branded-grey" @click="closeMenu('export')">Cancel</v-btn>
        <div class="row-center">
          <v-btn  class="branded-background text-white" @click="exportData">Export Data</v-btn>
        </div>
      </v-card-actions>
    </v-card>

    <!--//popup for checking import lesson status-->
    <v-card v-if="popoverToggles.importStatus" height="512" elevation="0">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon color="white">cloud_upload</v-icon>
          </v-list-tile-avatar>
        <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span class="text-white text-truncate-popover">Classic Bulb Status</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-card elevation="0" v-if="importLogsLoading" height="400">
        <v-container  class="loader-popover">
          <v-progress-circular indeterminate size=100 :width="10"></v-progress-circular>
        </v-container>
      </v-card>
      <v-card elevation="0" v-if="!importLogsLoading">
        <v-alert
          v-model="legacy.showImportWarning"
          type="warning"
        >
          <span style="color:white;">Importing your bulbs was interupted or ran into an error. Please contact PlayPosit support at <a  style="color:white;" href='mailto:help@playposit.org' target='_blank'>help@playposit.org</a></span>
        </v-alert>
        <div style="background-color: white;">
          <el-table
          :data="importLogs"
          :default-sort = "{prop: 'timestamp', order: 'descending'}"
          :height="importLogTableHeight"
          >
            <el-table-column
              header-align="center"
              prop="name"
              sortable
              label="Bulb Name">
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              width="200"
              prop="description"
              sortable
              label="Status">
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="timestamp"
              width="200"
              sortable
              :formatter="formatTimestamp"
              label="Timestamp">
            </el-table-column>
            <template slot="empty">
              <h1>No Sync Logs Available</h1>
            </template>
          </el-table>
        </div>
      </v-card>
      <v-divider></v-divider>
      <v-card-actions class="row-space" style="height:56px">
        <v-btn flat class="branded-grey" @click="closeMenu('importStatus')">Close</v-btn>
        <div class="row-center">
        </div>
      </v-card-actions>
    </v-card>

    <!--Filters and Bulb Info-->

    <!--Popover for table filters-->
     <v-card v-if="popoverToggles.filterMenu" elevation="0">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon
              v-if="activeViewInstructor != 'My-Bulbs'
                && activeViewInstructor != 'Playlists'"
              color="white"
              >
                search
              </v-icon>
            <v-icon v-else color="white">filter_list</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span
                v-if="activeViewInstructor != 'My-Bulbs' 
                  && activeViewInstructor != 'Playlists'"
                class="text-white"
              >
                Search and Filter
              </span>
              <span v-else class="text-white">Filter</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-list three-line style="padding:18px 24px !important;">
        <v-list-tile
          v-if="activeViewInstructor != 'My-Bulbs'
            && activeViewInstructor != 'Playlists'
            && hasPlaylistAccess"
        >
          <v-select
            class="width-small select-overflow"
            :items="contentTypes"
            v-model="premadeContentType"
          ></v-select>
        </v-list-tile>
        <v-list-tile v-if="activeViewInstructor != 'My-Bulbs' && activeViewInstructor != 'Playlists'">
          <v-combobox
            class="width-small select-overflow"
            v-model="filters.name"
            label="Keywords"
            chips
            flat
            clearable
            multiple
          >
            <template slot="selection" slot-scope="data" class="select-overflow">
              <v-chip
                :style="tagStyle('Name')"
                close
                @input="removeFilterChip(['name', data.item])"
              >
                <strong :style="tagTextStyle('Name')">{{ data.item }}</strong>&nbsp;
              </v-chip>
            </template>
          </v-combobox>
        </v-list-tile>
        <v-list-tile v-if="activeViewInstructor != 'My-Bulbs' && activeViewInstructor != 'Playlists'">
          <v-combobox
            class="width-small select-overflow"
            v-model="filters.creator"
            label="Creator Last Name"
            chips
            flat
            clearable
            multiple
          >
            <template slot="selection" slot-scope="data">
              <v-chip
                :style="tagStyle('Creator')"
                close
                @input="removeFilterChip(['creator', data.item])"
              >
                <strong :style="tagTextStyle('Creator')">{{ data.item }}</strong>&nbsp;
              </v-chip>
            </template>
          </v-combobox>
        </v-list-tile>
        <v-list-tile v-if="!this.filters.legacy && premadeContentType === 'Bulbs'">
          <v-autocomplete
            ref="keywords"
            class="width-small select-overflow"
            v-model="filters.keywords"
            :items="tags.keywords"
            label="Tags"
            chips
            flat
            cache-items
            clearable
            multiple
            :loading="searchingForTags"
            :search-input.sync="tagSearchString"
            @change="closeFilterSelector('keywords')"
          >
            <template slot="selection" slot-scope="data">
              <v-chip
                :style="tagStyle('user-generated')"
                close
                @input="removeFilterChip(['keywords', data.item])"
              >
                <strong :style="tagTextStyle('user-generated')">{{ data.item }}</strong>&nbsp;
              </v-chip>
            </template>
          </v-autocomplete>
        </v-list-tile>
        <v-list-tile
          v-if="(
            !this.filters.legacy
            && premadeContentType === 'Bulbs'
          )"
          style="margin-bottom: -35px; margin-top: -20px;">
          <v-checkbox
            v-model="filters.tagExactMatch"
            label="Exact Matches Only">
          </v-checkbox>
          <ChickFilATagButton
            :school="school"
            service="dashboard"/>
        </v-list-tile>
        <v-list-tile
          v-if="!this.filters.legacy
          && premadeContentType === 'Bulbs'">
          <v-autocomplete
            ref="excludeTags"
            class="width-small select-overflow"
            v-model="filters.excludeTags"
            :items="tags.keywords"
            label="Exclude Tags"
            chips
            flat
            clearable
            multiple
            cache-items
            :loading="searchingForTags"
            :search-input.sync="excludeTagSearchString"
            @change="closeFilterSelector('excludeTags')">
            <template
              slot="selection"
              slot-scope="data">
              <v-chip
                :style="tagStyle('user-generated')"
                close
                @input="removeFilterChip(['excludeTags', data.item])">
                <strong
                  :style="tagTextStyle('user-generated')">
                  {{ data.item }}
                </strong>&nbsp;
              </v-chip>
            </template>
          </v-autocomplete>
        </v-list-tile>
        <v-list-tile v-if="!this.filters.legacy && premadeContentType === 'Bulbs'">
          <v-autocomplete
            ref="age"
            class="width-small select-overflow"
            v-model="filters.age"
            :items="tags.age"
            label="Target Audience"
            chips
            flat
            clearable
            multiple
            :small-chips="true"
            @change="closeFilterSelector('age')"
          >
            <template slot="selection" slot-scope="data">
              <v-chip
                :style="tagStyle('age')"
                close
                @input="removeFilterChip(['age', data.item])"
              >
                <strong :style="tagTextStyle('age')">{{ data.item }}</strong>&nbsp;
              </v-chip>
            </template>
          </v-autocomplete>
        </v-list-tile>
        <v-list-tile v-if="!this.filters.legacy && premadeContentType === 'Bulbs'">
          <v-autocomplete
            ref="subject"
            class="width-small select-overflow"
            v-model="filters.subject"
            :items="tags.subject"
            label="Subject"
            chips
            flat
            clearable
            multiple
            @change="closeFilterSelector('subject')"
          >
            <template slot="selection" slot-scope="data">
              <v-chip
                :style="tagStyle('subject')"
                close
                @input="removeFilterChip(['subject', data.item])"
              >
                <strong :style="tagTextStyle('subject')">{{ data.item }}</strong>&nbsp;
              </v-chip>
            </template>
          </v-autocomplete>
        </v-list-tile>
        <v-list-tile v-if="!this.filters.legacy && activeViewInstructor === 'My-Bulbs'">
          <v-autocomplete
            ref="bulbRole"
            class="width-small select-overflow"
            v-model="filters.bulbRole"
            :items="bulbRoles"
            label="Bulb Role"
            chips
            flat
            clearable
            multiple
            @change="closeFilterSelector('bulbRole')"
          >
            <template slot="selection" slot-scope="data">
              <v-chip
                :style="tagStyle('bulbRole')"
                close
                @input="removeFilterChip(['bulbRole', data.item])"
              >
                <strong :style="tagTextStyle('bulbRole')">{{ data.item }}</strong>&nbsp;
              </v-chip>
            </template>
          </v-autocomplete>
        </v-list-tile>
        <v-list-tile v-if="!this.filters.legacy && activeViewInstructor === 'Playlists'">
          <v-autocomplete
            ref="playlistRole"
            class="width-small select-overflow"
            v-model="filters.playlistRole"
            :items="playlistRoles"
            label="Playlist Role"
            chips
            flat
            clearable
            multiple
            @change="closeFilterSelector('playlistRole')"
          >
            <template slot="selection" slot-scope="data">
              <v-chip
                :style="tagStyle('playlistRole')"
                close
                @input="removeFilterChip(['playlistRole', data.item])"
              >
                <strong :style="tagTextStyle('playlistRole')">{{ data.item }}</strong>&nbsp;
              </v-chip>
            </template>
          </v-autocomplete>
        </v-list-tile>
        <v-list-tile
          v-if="activeViewInstructor === 'My-Community'
            && !this.filters.legacy
            && !school.hideOrganizationToggle"
          >
          <v-select
            class="width-small select-overflow"
            v-model="filters.all_district"
            label="Organization"
            :items="filterOrganizationOptions"
          >
          </v-select>
        </v-list-tile>
        <v-list-tile
          v-if="
            (
              activeViewInstructor != 'My-Bulbs'
              && activeViewInstructor != 'Playlists'
            )
            && !this.filters.legacy
            && premadeContentType === 'Bulbs'"
          >
            <v-text-field
            v-model="filters.youtube"
            label="Youtube Url"
            ></v-text-field>
        </v-list-tile>
        <v-list-tile v-if="!this.filters.legacy && activeViewInstructor === 'My-Bulbs'">
          <v-combobox
            class="width-small select-overflow"
            v-model="filters.bulbId"
            label="Bulb Id"
            chips
            flat
            clearable
            multiple
            type='number'
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            maxlength = "10"
          >
            <template slot="selection" slot-scope="data">
              <v-chip
                :style="tagStyle('user-generated')"
                close
                @input="removeFilterChip(['bulbId', data.item])"
              >
                <strong :style="tagTextStyle('bulbId')">{{ data.item }}</strong>&nbsp;
              </v-chip>
            </template>
          </v-combobox>
        </v-list-tile>
        <v-list-tile v-if="!this.filters.legacy && activeViewInstructor === 'Playlists'">
          <v-combobox
            class="width-small select-overflow"
            v-model="filters.playlistId"
            label="Playlist Id"
            chips
            flat
            clearable
            multiple
            type='number'
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            maxlength = "10"
          >
            <template slot="selection" slot-scope="data">
              <v-chip
                :style="tagStyle('user-generated')"
                close
                @input="removeFilterChip(['playlistId', data.item])"
              >
                <strong :style="tagTextStyle('playlistId')">{{ data.item }}</strong>&nbsp;
              </v-chip>
            </template>
          </v-combobox>
        </v-list-tile>
      </v-list>
      <v-card-actions class="row-space" style="height:56px">
        <v-btn
          flat
          class="branded-grey"
          @click="closeMenu('filters')"
        >
          Cancel
        </v-btn>
        <div class="row-center">
          <v-btn
            v-if="activeViewInstructor !== 'Playlists'" 
            flat
            text
            class="branded-text"
            @click="clearAllFilters"
          >
            Clear Filters
          </v-btn>
          <v-btn
            v-if="activeViewInstructor === 'Playlists'" 
            flat
            text
            class="branded-text"
            @click="clearAllPlaylistFilters"
          >
            Clear Filters
          </v-btn>
          <v-btn
            v-if="
              activeViewInstructor != 'My-Bulbs'
              && activeViewInstructor != 'Playlists'
              "
            class="branded-background text-white"
            @click="setFilters"
          >
            Filter
          </v-btn>
          <v-btn
            v-if="activeViewInstructor === 'My-Bulbs'"
            class="branded-background text-white"
            @click="setFiltersMyBulbs"
          >
            Filter
          </v-btn>
          <v-btn
            v-if="activeViewInstructor === 'Playlists'" 
            class="branded-background text-white"
            @click="setFiltersMyPlaylists"
          >
            Filter
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>

    <!--Popover for bulb settings-->
     <v-card v-if="popoverToggles.bulbInfo" elevation="0">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-responsive :aspect-ratio="16/9" max-height="36px" max-width="64px" style="margin-right: 20px;">
            <div class="thumbnail-wrapper-nonselect" :style="videoThumbnail"></div>
          </v-responsive>
          <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span class="text-white">Bulb Settings for "{{dialogShow.data.name}}"</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <PlaypositBulbSettings
        ref="bulbSettings"
        :wrapper-size="800"
        :bulb="dialogShow.data"
        :modes="[]"
        :tags="tags"
        :school-listed="school ? school.listed : false"
        :active-color="school ? school.active_color : '#2196F3'"
        :save-bulb-settings="saveBulbSettings"
        :school="school"
        :permission-keys="school && school.permissionKeys ? school.permissionKeys : []"
        :points-available="pointsAvailable"
        :user-type="bulbSettingsUserType"
        service="dashboard"
        :api-url="serverURL"
        :token="instructorData.token"
        :timezone="instructorData.timezone"
        @cancel="closeMenu('addTags')"
      />
    </v-card>


    <!-- Popups for LTI -->
    <!-- popup for linking bulb in lti -->
    <v-card v-if="popoverToggles.lti" elevation="0">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <img :src="LMSdata.img">
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span class="text-white">Link "{{dialogShow.data.name}}"</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <div
        v-if="(
          !LTIdata.previouslyLinked.loaded
          || instructorAjaxing
        )"
        style="height:250px;"
      >
        <v-container  class="loader-popover">
          <v-progress-circular indeterminate size=50 :width="5"></v-progress-circular>
        </v-container>
      </div>
      <div
        v-if="(
          LTIdata.previouslyLinked.loaded
          && !instructorAjaxing
        )"
        style="width:100%; overflow:auto;"
        class="white-background"
      >
        <div
          v-if="LTIdata.previouslyLinked.linked"
          style="min-height: 250px;"
        >
          <div>
            <div style="padding:12px 24px;">
              <p v-if="!dialogShow.data.lmb_id">
                "{{dialogShow.data.name}}" is already linked to an assignment called "{{LTIdata.previouslyLinked.data.resourceLinkTitle}}".
                 Bulbs and Playlists can only be linked once in each LMS class.
                 You will need to either unlink from this assignment or make a new copy of the bulb to link.
              </p>
              <p v-if="dialogShow.data.lmb_id">
                "{{dialogShow.data.name}}" is already linked to an assignment called "{{LTIdata.previouslyLinked.data.resourceLinkTitle}}". 
                Learner Made Bulb assignments cannot be copied or unlinked. Please create a new Learner Made Bulb assignment.
              </p>
              <span style="margin-top:12px;">
                <!-- I think this first kb article is wrong -->
                Read more 
                <a
                  v-if="_.get(LTIdata, 'previouslyLinked.data.lessonUrl') !== 'playlist'"
                  class="selectable"
                  href="https://knowledge.playposit.com/article/130-how-to-unlink-bulbs-in-an-lms" target="_blank"
                >
                  here
                </a>
                <a
                  v-else
                  class="selectable"
                  href="https://knowledge.playposit.com/article/284-how-to-link-a-playlist-in-your-lms#unlink-relink"
                >
                  here
                </a>.
              </span>
            </div>
            <div
              v-if="!dialogShow.data.lmb_id"
              class="row-between"
            >
              <div>
                <v-btn
                  flat
                  text
                  class="branded-text"
                  @click="unlinkAssignment()"
                >
                    Unlink
                </v-btn>
                <v-btn
                  v-if="activeView !== 'Playlists'"
                  text
                  class="branded-background"
                  @click="copyBulbLTI"
                >
                  <span v-if="!instructorAjaxing" class="text-white">Copy</span>
                  <v-progress-circular v-if="instructorAjaxing" indeterminate size=20 :width="4" color='white'></v-progress-circular>
                </v-btn>
              </div>
            </div>
          </div>
        </div>
        <!-- All ContentItemSelection request LMS logic: -->
        <div v-if="!LTIdata.previouslyLinked.linked">
        <v-list three-line>
          <v-list-tile>
            <v-list-tile-content>
              <span style="word-break: normal">
                Would you like to link "{{dialogShow.data.name}}" as a
                <span v-if="lti.type === 'selfpaced'">Self Paced</span>
                <span v-if="lti.type === 'broadcast'">Broadcast</span>
                <span
                  v-if="(
                    lti.type === 'lmb'
                    && !dialogShow.data.config.lmb.peer_review
                  )"
                >
                    Learner Made Bulb
                </span>
                <span
                  v-if="(
                    lti.type === 'lmb'
                    && dialogShow.data.config.lmb.peer_review
                  )"
                >
                  Peer Review
                </span>
                <span v-if="lti.type === 'Playlist'">Playlist</span>
                assignment?
                <span>
                  Read more
                  <a
                    v-if="dialogShow.data.type !== 'playlist'"
                    class="selectable"
                    href="https://knowledge.playposit.com/category/219-playposit-30-in-your-lms"
                    target="_blank"
                  >
                    here
                  </a>
                  <a
                    v-else
                    class="selectable"
                    href="https://knowledge.playposit.com/article/284-how-to-link-a-playlist-in-your-lms#link-playlist"
                    target="_blank"
                    >
                      here
                  </a>.
                </span>
              </span>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-list three-line>
          <v-list-tile
            class="center"
            v-show="!['lmb', 'playlist'].includes(lti.type)"
          >
            <v-list-tile-content>
              <v-select
                style="width: 100%"
                :items="lti.options"
                v-model="lti.type"
                label="Select Learner Experience"
              ></v-select>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            class="center"
            v-show="LMSdata.type === 'd2l'"
          >
            <v-list-tile-content>
              <v-select
                style="width: 100%"
                :items="yesNoOption"
                item-text="name"
                item-value="value"
                v-model="enableGrading"
                label="Sync Grades to LMS"
              ></v-select>
            </v-list-tile-content>
          </v-list-tile>
          <!-- Group Linking -->
          <v-container fluid>
            <v-layout
              v-if="(
                _.get(school, 'config.permissions', []).includes('hasPeerReview')
                && LTIdata.disable_placement != 0 
                && dialogShow.data.lmb_id === 1
                && dialogShow.data.config.lmb.peer_review
              )"
              justify-space-between
              row
            >
              <v-flex
                xs6
                class="mt-3"
              >
                <v-select
                  :items="groups"
                  item-text="name"
                  item-value="id"
                  v-model="lti.group_set_id"
                  label="Select Group Set"
                ></v-select>
              </v-flex>
              <v-spacer></v-spacer>
              <v-container
                xs5
                class="align-self-center align-center pb-2"
              >
                <v-btn-toggle class="independent-btn-toggle">
                  <v-btn
                    @click="slideOut({
                      toggle: true,
                      view: 'groups',
                      sectionId: LTIdata.section_id,
                      initialTab: (hasCanvasApi && LMSdata.type === 'Canvas') ? 1 : 0
                    })"
                    flat
                    outline
                    color="primary"
                  >
                    <!-- [ ] do we want this to be group sets? -->
                    Manage Group Sets
                  </v-btn>
                  <router-link
                    v-if="(
                      !hasCanvasApi
                      && LMSdata.type !== 'Canvas'
                    )"
                    style="text-decoration: none"
                    :to="{
                      name: 'groups',
                      params: {
                        sectionId: LTIdata.section_id
                      },
                      query: {
                        initialTab: 0,
                        routerView: true
                      }
                    }"
                    target="_blank"
                  >
                    <v-btn
                      icon
                      color="primary"
                      class="lighten-1"
                      outline
                    >
                      <v-icon
                        small
                        color='primary'
                      >
                        launch
                      </v-icon>
                    </v-btn>
                  </router-link>
                </v-btn-toggle>
                <v-btn
                  v-if="(
                    hasCanvasApi
                    && LMSdata.type === 'Canvas'
                  )"
                  flat
                  icon
                  class="branded-text"
                  href="https://knowledge.playposit.com/article/224-peer-review-instructors#groups"
                  target="_blank"
                >
                  <v-icon>info</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  flat
                  icon
                  class="branded-text"
                  href="https://knowledge.playposit.com/article/291-peer-review-for-instructors-using-playposit-groups#groups"
                  target="_blank"
                >
                  <v-icon>info</v-icon>
                </v-btn>
              </v-container>
            </v-layout>
          </v-container>
          <!-- Placement: embedded, new tab -->
          <v-list-tile
            v-if="LTIdata.disable_placement == 0"
            class="center"
          >
            <v-list-tile-content>
              <v-select
                style="width: 100%"
                :items="lti.placementOptions"
                v-model="lti.placement"
                label="Placement"
              ></v-select>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            v-if="(
              LTIdata.disable_placement == 0
              && lti.placement === 'iframe'
            )"
            class="center"
          >
            <v-list-tile-content
              style="
                display: flex;
                flex-flow: row;
                justify-content: center;
                align-items: space-between;
              "
            >
              <v-text-field
                style="width: 35%; margin: 0px 80px"
                type="number"
                min="320"
                v-model="lti.width"
                label="Width Of Placement"
                :error-messages="formErrors('width')"
              ></v-text-field>
              <v-text-field
                style="width: 35%; margin: 0px 80px"
                type="number"
                min="235"
                v-model="lti.height"
                label="Height Of Placement"
                :error-messages="formErrors('height')"
              ></v-text-field>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        </div>
      </div>
      <v-divider></v-divider>
        <v-card-actions
          class="row-space"
          style="height: 56px; background-color: #fff"
        >
          <v-btn
            flat
            class="branded-grey"
            @click="closeMenu('lti')"
          >
              Cancel
            </v-btn
          >
          <div class="row-center">
            <v-btn
              text
              class="branded-background text-white"
              @click="linkAssignment"
              :disabled="(
                lti.type === ''
                || LTIdata.previouslyLinked.linked
                || formErrors('height').length > 0
                || formErrors('width').length > 0
                || instructorAjaxing
              )"
            >
              Link
            </v-btn
          >
          </div>
        </v-card-actions>
    </v-card>

    <!--//popup for syncing grades with lti-->
    <v-card v-if="popoverToggles.ltiSync" height="512" elevation="0">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <img :src="dialogShow.data.image">
          </v-list-tile-avatar>
        <v-list-tile-content class="row-center">
            <v-list-tile-title class="modal-title">
              <span class="text-white text-truncate-popover">Sync data for "{{ dialogShow.data.syncStatusTitle }}"</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-btn icon @click="getStatus" style="position: absolute; top:0; right:0;">
          <v-icon color="white">refresh</v-icon>
        </v-btn>
      </v-list>
      <v-divider></v-divider>
      <v-card elevation="0">
        <div style="background-color: white;">
          <el-table
          :data="LTILogs"
          :default-sort = "{prop: 'student_name', order: 'ascending'}"
          height="400px"
          >
            <el-table-column
              header-align="center"
              prop="student_name"
              sortable
              label="Learner Name">
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              width="90"
              prop="score"
              sortable
              label="Score">
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="description"
              sortable
              label="Status">
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="timestamp"
              sortable
              label="TimeStamp">
            </el-table-column>
            <template slot="empty">
              <h1>No Sync Logs Available</h1>
            </template>
          </el-table>
        </div>
      </v-card>
      <v-divider></v-divider>
      <v-card-actions class="row-space" style="height:56px">
        <v-btn flat class="branded-grey" @click="closeMenu('ltiSync')">Close</v-btn>
        <div class="row-center">
        </div>
      </v-card-actions>
    </v-card>

    <!--Popover for bulb interaction summary view-->
    <v-card v-if="popoverToggles.bulbAnalytics" elevation="0">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon color="white">{{dialogShow.data.icon}}</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="row-space modal-title">
              <span class="text-white">{{dialogShow.data.type}}</span>
              <!--<span class="row-center text-white"><v-icon class="time-icon">access_time</v-icon>{{dialogShow.data.display}}</span>-->
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-card elevation="0">
        <div class="import-groups-container" v-if="popoverDataLoading">
           <v-progress-circular color="grey" indeterminate size=40 :width="5">
           </v-progress-circular>
        </div>
        <div style="" v-if="!popoverDataLoading">
          <div style="width: 100%; height:100%; max-height:500px;" class="pt-2">
                <p v-if="bulbHasNoSummaryData" class="display-1" style="text-align:center;">
                  No Summary Data
                </p>
            <BarChart :key="summaryChartKey" :chart-data="bulbAnalyticsSummaryChart" v-else></BarChart>
          </div>
          <v-divider></v-divider>
          <div style="display:flex; flex-flow:row;">
          <div style="width: 50%; display:flex; justify-content:center; align-items:center;" class="pt-2" align="center">
            <p class="display-1" v-if="bulbHasNoAverageData">
              No Score Data
            </p>
            <PieChart :key="averageChartKey" :options="averagePieChartOptions" :chart-data="bulbAverageScoreChart" v-else></PieChart>
          </div>
          <div style="width: 50%; display:flex; justify-content:center; align-items:center;" class="pt-2">
            <p class="display-1" v-if="bulbHasNoCompleteData">
              No Completed Data
            </p>
            <PieChart :key="completeChartKey" :options="completePieChartOptions" :chart-data="bulbCompleteChart" v-else></PieChart>
          </div>
          </div>
        </div>
      </v-card>
      <v-divider></v-divider>
      <v-card-actions class="row-space" style="height:56px">
        <v-btn flat class="branded-grey" @click="closeMenu('confirm')">Close</v-btn>
        <div class="row-center">
        </div>
      </v-card-actions>
    </v-card>

    <!--Interaction Filter settings-->
    <!--Popover for interaction filter settings-->
    <v-card v-if="popoverToggles.filterMenuInteraction" elevation="0">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon v-if="activeViewInstructor === 'Interactions'" color="white">filter_list</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span v-if="activeViewInstructor === 'Interactions'" class="text-white">Filter</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-list three-line style="padding:18px 24px !important; width: 530px;">
        <v-list-tile>
          <v-select
            class="width-small select-overflow"
            v-model="filtersInteraction.selectedStatus"
            :items="filtersInteraction.status"
            label="Status"
            solo
          ></v-select>
        </v-list-tile>
        <v-list-tile>
          <v-checkbox
            v-model="filtersInteraction.localShowPointsBadges"
            label="Show point values for responses"
            hide-details
          ></v-checkbox>
        </v-list-tile>
      </v-list>
      <v-card-actions class="row-space" style="height:56px">
        <v-btn flat class="branded-grey" @click="closeMenu('filters')">Cancel</v-btn>
        <div class="row-center">
          <v-btn flat text class="branded-text" @click="clearFilterInteractions" >Clear Filters</v-btn>
          <v-btn v-if="activeViewInstructor === 'Interactions'" class="branded-background text-white"  @click="setFiltersInteractions">Filter</v-btn>
        </div>
      </v-card-actions>
    </v-card>

    <!--Popups for Learner Dash-->

    <!--//popup to join class-->
    <v-card v-if="popoverToggles.joinClass" elevation="0">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon color="white">folder_shared</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span class="text-white">Join Class</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-card elevation="0">
        <div style="padding: 20px 60px 20px 20px;">
          <form class="row-space" @submit.prevent="searchClass">
            <v-text-field
              v-model="join.classCode"
              label="Class Code"
              :error-messages="formErrors('join')"
              required
              :tabindex="1"
              aria-label="Enter class code text input. Type the class code here. Class Code should be two numbers with a dash."
              @blur="announceAriaAlert"
            ></v-text-field>
            <p v-if="ariaAlert" aria-live="assertive" class="aria-error">{{ariaAlert}}</p>
            <v-btn type="submit" flat text class="branded-text" :disabled="formErrors('join').length > 0 || join.classCode.length === 0" tabindex="2" aria-label="Search button. Press enter to search for classes that match class code">Search</v-btn>
          </form>
        </div>
      </v-card>
      <v-card v-if="classSearch.length > 0" elevation="0" aria-live="assertive">
         <el-table
          :data="classSearch"
          height="70px"
          :show-header="false"
          :row-class-name="joinTableClass"
          >
            <el-table-column
              align="center"
              width="300"
              prop="name"
              label="Class Name"
            >
              <template slot-scope="scope">
                <span class="text-white tabable" tabindex="3" :aria-label="createAriaLabel('join', scope.row)">{{scope.row.name}}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="teacher_name"
              width="300"
              label="Instructor">
            </el-table-column>
            <el-table-column
              align="center"
              prop="class_code"
              label="Class Code">
            </el-table-column>
          </el-table>
      </v-card>
     <v-divider></v-divider>
     <v-card-actions class="row-space" style="height:56px">
        <v-btn  flat class="branded-grey" @click="closeMenu('join')" tabindex="4" aria-label="Cancel button. Press enter to exit join class">Cancel</v-btn>
        <v-btn  class="branded-background text-white"  :disabled="classSearch.length === 0 || classSearch[0].name ==='No class found'" @click="joinClass"  tabindex="5" aria-label="Join class button. Press enter to join class">Join Class</v-btn>
      </v-card-actions>
    </v-card>

    <!--//popup to share lmb-->
    <v-card v-if="popoverToggles.shareLearner" elevation="0">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-responsive :aspect-ratio="16/9" max-height="36px" max-width="64px" style="margin-right: 20px;">
            <div class="thumbnail-wrapper-nonselect" :style="videoThumbnail"></div>
          </v-responsive>
          <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span class="text-white">Share {{dialogShow.data.name}}</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-card elevation="0">
        <div class="share-learner-info-container">
          <div class="share-learner-info">
            <span>{{shareLearnerData.text}}</span>
          </div>
        </div>
        <div class="share-learner-copy-container">
          <v-text-field  box hide-details readonly :value="shareLearnerData.url" label="shareable url"></v-text-field>
          <ClipboardCopy :copyText="shareLearnerData.url"></ClipboardCopy>
        </div>
     </v-card>
     <v-divider></v-divider>
     <v-card-actions class="row-space" style="height:56px">
        <v-btn  flat class="branded-grey" @click="closeMenu('shareLearner')" tabindex="4" aria-label="Close button. Press enter to exit share bulb">Close</v-btn>
     </v-card-actions>
    </v-card>

    <!--popup for student profile-->
    <v-card v-if="popoverToggles.profile" elevation="0">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-avatar color="white" size="36">
              <span v-if="primaryAccount === 'Learner'" class="branded-text">{{learnerData.avatarInitials}}</span>
            </v-avatar>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>
              <span class="text-white">Student Profile</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-card elevation="0">
        <div style="padding:20px;" class="student-profile-container">
          <form @submit.prevent="saveProfile">
            <v-text-field
              v-model="profileData.email"
              label="Email"
              readonly
              class="disabled"
              tabindex="1"
              :autofocus="true"
              :aria-label="createAriaLabel('email', profileData.email)"
            ></v-text-field>
            <v-text-field
              v-model="profileData.first_name"
              label="First Name"
              :error-messages="formErrors('profileFirst')"
              required
              tabindex="2"
              :autofocus="true"
              :aria-label="createAriaLabel('first', profileData.first_name)"
            >
            </v-text-field>
            <p v-if="formErrors('profileFirst').length" aria-live="polite" class="aria-error">{{formErrors('profileFirst')}}</p>
            <v-text-field
              v-model="profileData.last_name"
              :error-messages="formErrors('profileLast')"
              label="Last Name"
              required
              tabindex="3"
              :autofocus="true"
              :aria-label="createAriaLabel('last', profileData.last_name)"
            ></v-text-field>
            <p v-if="formErrors('profileLast').length" aria-live="polite" class="aria-error">{{formErrors('profileLast')}}</p>
          </form>
          <v-list style="background-color: #fafafa;">
            <span class="branded-grey" style="font-size:.9rem">Temporary Display Color</span>
            <v-list-tile >
               <v-list-tile-content>
                 <el-color-picker v-model="profileData.color" @input="checkColor" @keyup.enter="profile"></el-color-picker>
               </v-list-tile-content>
               <v-list-tile-action>
                 <span v-if="this.profileData.colorWarning" style="color:red;">This color is too light to choose.</span>
               </v-list-tile-action>
            </v-list-tile>
          </v-list>
          <v-list two-line style="background-color: #fafafa;">
            <span class="branded-grey" style="margin-top:20px;">Danger Zone</span>
            <v-list-tile >
                <v-btn text flat style="color:red;" @click="deleteAccount" tabindex="4" aria-label="Delete student account button. Press enter to delete your student accout." >Delete Student Account</v-btn>
            </v-list-tile>
          </v-list>
        </div>
      </v-card>
     <v-divider></v-divider>
     <v-card-actions class="row-space" style="height:56px">
        <v-btn  flat class="branded-grey" @click="closeMenu('profile')" tabindex="5" aria-label="Cancel button. Press enter to close student profile">Cancel</v-btn>
        <v-btn   class="branded-background text-white"  :disabled="formErrors('profileFirst').length > 0 || formErrors('profileLast').length > 0 || profileChanged " @click="saveProfile" tabindex="6" aria-label="Save button. Press enter to save changes to student profile">Save</v-btn>
      </v-card-actions>
    </v-card>

    <!--popup for adding a school-->
    <v-card v-if="popoverToggles.addSchool" elevation="0">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon color="#fff">business</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span class="text-white">Add Organization</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-card elevation="0" style="max-height: 600px; overflow:scroll;">
        <div style="padding:0px 20px;">
          <v-list three-line style="background-color: #fafafa">
            <v-list-tile>
              <v-text-field
                v-model="addSchool.name"
                label="School Name"
                tabindex="1"
                :autofocus="true"
                :error-messages="formErrors('schoolName')"
              ></v-text-field>
            </v-list-tile>
            <v-list-tile>
              <v-autocomplete
                v-model="addSchool.integrations"
                class="width-small select-overflow"
                :items="addSchool.integrations"
                label="Available Integrations"
                chips
                readonly
                multiple
              >
                <template slot-scope="data">
                  <v-chip>
                    {{ data.item }}
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-list-tile>
          </v-list>
          <v-card elevation="0" style="padding: 0px 16px;">
            <span class="branded-grey" style="margin-top: 12px">Instructor Privacy</span>
            <v-radio-group v-model="addSchool.privacy" class="instructor-privacy" style="padding: 0px 16px;">
                <v-radio label="Bulb is public. Bulb is visible in Premade Bulbs." :value=1 ></v-radio>
                <v-radio label="Bulb is visible to members of your district/institution." :value=2 ></v-radio>
                <v-radio label="Bulb is visible to members of your school/site." :value=3 ></v-radio>
                <!--<v-radio disabled label="Bulb is visible to observers in the same class." :value=4 ></v-radio>-->
                <v-radio label="Bulb is private. Bulb is not visible in Premade Bulbs." :value=5 ></v-radio>
            </v-radio-group>
          </v-card>
          <v-card elevation="0" style="padding: 0px 16px;">
            <span class="branded-grey" style="margin-top: 12px">Branding</span>
            <div class="row-start-only" style="height:150px;">
              <div style="width:40%;">
                <vue-dropzone
                  :id="addSchoolOptions.id"
                  ref="bsDropzone"
                  :options="addSchoolOptions"
                  @vdropzone-success="handleDropzoneSuccess"
                  @vdropzone-removed-file="handleDropzoneRemovedFile"
                >
                </vue-dropzone>
              </div>
              <div style="width:60%;">
                <v-list style="background-color: #fafafa;" class="school-branding">
                  <v-list-tile>
                    <v-list-tile-title>
                      Active Color
                    </v-list-tile-title>
                    <v-list-tile-content>
                      <el-color-picker v-model="addSchool.active_color" @input="" @keyup.enter=""></el-color-picker>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-title>
                      Inactive Color
                    </v-list-tile-title>
                    <v-list-tile-content>
                      <el-color-picker v-model="addSchool.inactive_color" @input="" @keyup.enter=""></el-color-picker>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-title>
                      Base Color
                    </v-list-tile-title>
                    <v-list-tile-content>
                      <el-color-picker v-model="addSchool.base_color" @input="" @keyup.enter=""></el-color-picker>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </div>
            </div>
          </v-card>
        </div>
      </v-card>
     <v-divider></v-divider>
     <v-card-actions class="row-space" style="height:56px">
        <v-btn  flat class="branded-grey" @click="closeMenu('addSchool')">Cancel</v-btn>
        <v-btn   class="branded-background text-white"  :disabled="formErrors('schoolName').length > 0" @click="">Add School</v-btn>
      </v-card-actions>
    </v-card>

     <!--popup for edit a school-->
    <v-card v-if="popoverToggles.editSchool" elevation="0">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon color="#fff">business</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span class="text-white">{{(multipleSchools) ? 'Edit Organizations' : 'Edit Organization' }}</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-card elevation="0" style="max-height: 600px; overflow:scroll;">
        <div style="padding:0px 20px;">
          <v-list three-line style="background-color: #fafafa">
            <v-list-tile>
              <v-text-field
                v-model="addSchool.name"
                label="School Name"
                tabindex="1"
                :disabled="multipleSchools"
                :autofocus="true"
                :error-messages="formErrors('schoolName')"
              ></v-text-field>
            </v-list-tile>
          </v-list>
          <v-card elevation="0" style="padding: 0px 16px;">
            <span class="branded-grey" style="margin-top: 12px">Instructor Privacy</span>
            <v-radio-group v-model="addSchool.privacy" class="instructor-privacy" style="padding: 0px 16px;">
                <v-radio label="Bulb is public. Bulb is visible in Premade Bulbs." :value=1 ></v-radio>
                <v-radio label="Bulb is visible to members of your district/institution." :value=2 ></v-radio>
                <v-radio label="Bulb is visible to members of your school/site." :value=3 ></v-radio>
                <!--<v-radio disabled label="Bulb is visible to observers in the same class." :value=4 ></v-radio>-->
                <v-radio label="Bulb is private. Bulb is not visible in Premade Bulbs." :value=5 ></v-radio>
            </v-radio-group>
          </v-card>
          <v-card elevation="0" style="padding: 0px 16px;">
            <span class="branded-grey" style="margin-top: 12px">Branding</span>
            <div class="row-start-only" style="height:150px;">
              <div style="width:40%;">
                <vue-dropzone
                  :id="editSchoolOptions.id"
                  ref="bsDropzone"
                  :options="editSchoolOptions"
                  @vdropzone-success="handleDropzoneSuccess"
                  @vdropzone-removed-file="handleDropzoneRemovedFile"
                >
                </vue-dropzone>
              </div>
              <div style="width:60%;">
                <v-list style="background-color: #fafafa;" class="school-branding">
                  <v-list-tile>
                    <v-list-tile-title>
                      Active Color
                    </v-list-tile-title>
                    <v-list-tile-content>
                      <el-color-picker v-model="addSchool.active_color" @input="" @keyup.enter=""></el-color-picker>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-title>
                      Inactive Color
                    </v-list-tile-title>
                    <v-list-tile-content>
                      <el-color-picker v-model="addSchool.inactive_color" @input="" @keyup.enter=""></el-color-picker>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-title>
                      Base Color
                    </v-list-tile-title>
                    <v-list-tile-content>
                      <el-color-picker v-model="addSchool.base_color" @input="" @keyup.enter=""></el-color-picker>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </div>
            </div>
          </v-card>
          <v-card elevation="0" style="padding: 0px 16px;">
            <span class="branded-grey" style="margin-top: 12px">Danger Zone</span>
            <v-list-tile >
                <v-btn text flat style="color:red;" @click="">{{(multipleSchools) ? 'Delete Organizations' : 'Delete Organization' }}</v-btn>
            </v-list-tile>
          </v-card>
        </div>
      </v-card>
     <v-divider></v-divider>
     <v-card-actions class="row-space" style="height:56px">
        <v-btn  flat class="branded-grey" @click="closeMenu('editSchool')">Cancel</v-btn>
        <v-btn   class="branded-background text-white"  :disabled="formErrors('schoolName').length > 0 || !schoolEditChange" @click="">Save</v-btn>
      </v-card-actions>
    </v-card>


     <!--popup for add instructor-->
    <v-card v-if="popoverToggles.addInstructors" elevation="0">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon color="#fff">account_circle</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span class="text-white">Add Instructors</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-card elevation="0">
       <v-tabs grow v-model="addInstructorTab">
          <v-tab>
            Manual Entry
          </v-tab>
          <v-tab>
            CSV Upload
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="addInstructorTab">
          <v-tab-item :key="0">
            <div style="padding:24px 36px; max-height:500px; overflow-y:auto">
              <v-form v-model="addInstructorReady" style="width:100%" v-if="addInstructorReset">
                <div style="width:100%; display:flex; flex-flow:column;">
                   <v-text-field
                    v-model="addInstructorManual.email"
                    label="Email"
                    required
                    :rules="[rules.notEmpty, rules.validEmail]"
                  ></v-text-field>
                  <v-text-field
                    v-model="addInstructorManual.first_name"
                    label="First Name"
                    required
                    :rules="[rules.notEmpty]"
                  >
                  </v-text-field>
                  <v-text-field
                    v-model="addInstructorManual.last_name"
                    label="Last Name"
                    required
                    :rules="[rules.notEmpty]"
                  ></v-text-field>
                  <v-text-field
                    v-model="addInstructorManual.password"
                    label="Password"
                    required
                    :rules="[rules.notEmpty, rules.validPassword]"
                  ></v-text-field>
                  <v-select
                    label="Select Organization to Add Instructors"
                    :items="alphabetizedSchoolList"
                    v-model="addInstructorManual.institution"
                    :rules="[rules.selected]"
                    required
                  ></v-select>
                </div>
              </v-form>
              <div style="padding:12px 0px;">
                <span v-if="manualAddStatus.message.length > 0" aria-live="assertive" :class="manualAddStatus.success ? 'successful' : 'fail'">
                  {{manualAddStatus.message}}
                </span>
              </div>
            </div>
          </v-tab-item>
          <v-tab-item :key="1">
            <div style="padding:24px; max-height:500px; overflow-y:auto">
              <div>
                <span style="word-break: normal;">
                  Prior to uploading rosters, check to ensure you see the names of all organizations within your institution on this dashboard. Please limit uploads to 1000 rows. If an organization has not been set up, contact PlayPosit support.
                </span>
                <span style="padding-top:12px; word-break: normal;">
                  To upload a roster of instructors, enter all required information (first name, last name, email, password, organization) in the pre-formatted CSV template <a :href="`${publicPath}Instructor_Uploader.csv`" class="branded-text" download>here</a>.
                </span>
              </div>
              <div style="padding-top:12px;">
                <v-btn v-if="addInstructorCsv.upload" class="branded-background">
                  <v-progress-circular indeterminate size=20 :width="4" color='white'></v-progress-circular>
                </v-btn>
                <div v-if="!addInstructorCsv.upload">
                  <v-btn  class="branded-background" @click="$refs.inputUpload.click()">
                    <span class="text-white">Upload File</span>
                  </v-btn>
                  <input v-show="false" ref="inputUpload" type="file" @click="clearInstructorFile" @change="onInstructorFileChange" accept=".csv" >
                </div>
              </div>
              <div style="padding:12px 0px;">
                <div v-for="msg in addInstructorCsv.errorLog" class="instructor-error-msg">{{msg}}</div>
              </div>
              <div v-if="!addInstructorCsv.upload">
                <div v-if="addInstructorCsv.added.length > 0">
                  <span>Successfully created these instructor accounts for the requested schools:</span>
                  <el-table
                   :data="addInstructorCsv.added"
                  >
                    <el-table-column
                      prop="name"
                      label="Name"
                      sortable
                    >
                      <template slot-scope="scope">
                        <span style="color:#34a853">{{scope.row.name}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="email"
                      label="Email"
                      sortable>
                      <template slot-scope="scope">
                        <span style="color:#34a853">{{scope.row.email}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="school_name"
                      label="Organization"
                      sortable>
                      <template slot-scope="scope">
                        <span style="color:#34a853">{{scope.row.school_name}}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div v-if="addInstructorCsv.updated.length >0" style="padding-top: 18px;">
                  <span>Successfully moved these instructor accounts to the requested schools:<br/><span style="font-size:12px; font-style:italic;">Passwords unchanged</span></span>
                  <el-table
                   :data="addInstructorCsv.updated"
                  >
                    <el-table-column
                      prop="name"
                      label="Name"
                      sortable
                    >
                      <template slot-scope="scope">
                        <span style="color:#fbbc04">{{scope.row.name}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="email"
                      label="Email"
                      sortable>
                      <template slot-scope="scope">
                        <span style="color:#fbbc04">{{scope.row.email}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="school_name"
                      label="Organization"
                      sortable>
                      <template slot-scope="scope">
                        <span style="color:#fbbc04">{{scope.row.school_name}}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div v-if="addInstructorCsv.nochange.length >0" style="padding-top: 18px;">
                  <span>No change made to these instructor accounts:<br/><span style="font-size:12px; font-style:italic;">Accounts already existed and are already in requested schools</span></span>
                  <el-table
                   :data="addInstructorCsv.nochange"
                  >
                    <el-table-column
                      prop="name"
                      label="Name"
                      sortable
                    >
                      <template slot-scope="scope">
                        <span style="color:#fbbc04">{{scope.row.name}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="email"
                      label="Email"
                      sortable>
                      <template slot-scope="scope">
                        <span style="color:#fbbc04">{{scope.row.email}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="school_name"
                      label="Organization"
                      sortable>
                      <template slot-scope="scope">
                        <span style="color:#fbbc04">{{scope.row.school_name}}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div v-if="addInstructorCsv.errors.length >0" style="padding-top: 18px;">
                  <span>Could not add these instructor accounts due to errors in the CSV file:<br/><span style="font-size:12px; font-style:italic;">Please correct the errors and try again</span></span>
                  <el-table
                   :data="addInstructorCsv.errors"
                  >
                    <el-table-column
                      prop="name"
                      label="Name"
                      sortable
                    >
                      <template slot-scope="scope">
                        <span style="color:#ea4335">{{scope.row.name}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="email"
                      label="Email"
                      sortable>
                      <template slot-scope="scope">
                        <span style="color:#ea4335">{{scope.row.email}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="school_name"
                      label="Organization"
                      sortable>
                      <template slot-scope="scope">
                        <span style="color:#ea4335">{{scope.row.school_name}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="errors"
                      label="Error"
                      sortable>
                      <template slot-scope="scope">
                        <span style="color:#ea4335">{{scope.row.errors}}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
     <v-divider></v-divider>
     <v-card-actions class="row-space" style="height:56px">
        <v-btn  flat class="branded-grey" @click="closeMenu('addInstructors')">
            {{(addInstructorCsv.added.length > 0 || addInstructorCsv.nochange.length > 0) && addInstructorCsv.errors.length === 0 ? "Done" : "Cancel"}}
        </v-btn>
        <v-btn   class="branded-background text-white" v-if="addInstructorTab === 0" :disabled="!addInstructorReady || adminAjaxing" @click="addInstructor">Add</v-btn>
      </v-card-actions>
    </v-card>


     <!--popup for edit instructor-->
    <v-card v-if="popoverToggles.editInstructors" elevation="0">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon color="#fff">account_circle</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span class="text-white">{{(multipleInstructors) ? 'Edit Instructors' : 'Edit Instructor' }}</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-card elevation="0">
        <div style="padding:24px 36px; max-height:500px; overflow-y:auto">
          <v-form v-model="editInstructorReady" style="width:100%">
            <div style="width:100%; display:flex; flex-flow:column;">
               <v-text-field
                v-model="editInstructor.first_name"
                label="First Name"
                :rules="[rules.notEmpty]"
                required
                :readonly="multipleInstructors"
                :class="multipleInstructors ? 'disabled' : ''"
              >
              </v-text-field>
              <v-text-field
                v-model="editInstructor.last_name"
                :rules="[rules.notEmpty]"
                label="Last Name"
                required
                :readonly="multipleInstructors"
                :class="multipleInstructors ? 'disabled' : ''"
              ></v-text-field>
              <v-text-field
                v-model="editInstructor.email"
                label="Email"
                readonly
                class="disabled"
              ></v-text-field>
              <v-select
                label="Organization"
                :items="alphabetizedSchoolList"
                v-model="editInstructor.institution"
                :rules="[rules.selected]"
                required
              ></v-select>
            </div>
          </v-form>
          <v-list two-line style="background-color: #fafafa;">
            <span class="branded-grey" style="margin-top:20px;">Danger Zone</span>
            <v-list-tile >
              <v-btn text flat style="color:red;" @click="removeInstructorAccounts">Remove from license</v-btn>
            </v-list-tile>
          </v-list>
        </div>
      </v-card>
     <v-divider></v-divider>
     <v-card-actions class="row-space" style="height:56px">
        <v-btn  flat class="branded-grey" @click="closeMenu('editInstructors')">Cancel</v-btn>
        <v-btn   class="branded-background text-white"  :disabled="!editInstructorReady || !editInstructorChange" @click="saveEditInstructors">Save</v-btn>
      </v-card-actions>
    </v-card>

    <!--Popover for admin snapshot settings-->
    <v-card
      v-if="popoverToggles.snapshot"
      elevation="0"
      max-width="650px">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon color="#fff">settings</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>
              <span class="text-white">Snapshot Settings</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-tabs grow v-model="snapshotSettingTab">
          <v-tab>
            Filter Data
          </v-tab>
      </v-tabs>
      <v-tabs-items v-model="snapshotSettingTab">
        <v-tab-item :key="0">
          <v-card elevation="0" class="pt-4 px-4 pb-0 white">
            <span style="font-size: 18px;">Filter by organization:</span>
            <v-select
              v-model="snapshot.institution"
              :items="alphabetizedSchoolList"
            >
            </v-select>
          </v-card>
          <v-card elevation="0" class="pt-4 px-4 pb-0 white">
            <span class="pb-2" style="font-size: 18px;">Change date range:</span>
            <el-date-picker
              v-model="snapshot.date"
              type="daterange"
              range-separator="To"
              format="MM-dd-yyyy"
              :picker-options="datePickerOptions"
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder="Start date"
              end-placeholder="End date">
            </el-date-picker>
          </v-card>
          <v-card elevation="0" class="pt-2 px-4 white" style="display:flex; flex-flow: row; justify-content:flex-end; align-items:flex-end;">
            <v-btn   class="branded-background text-white" @click="filterSnapshot" :disabled="!filterSnapshotChange">Filter</v-btn>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>


    <!--Popover for admin table filters-->
     <v-card
      v-if="popoverToggles.adminFilterMenu"
      elevation="0"
      :height="(contentType === 'Bulbs' && activeViewAdmin !== 'Instructors') ? '80vh' : ''">
      <v-list class="branded-background">
        <template v-if="activeViewAdmin === 'Instructors'">
          <v-list-tile avatar>
            <v-list-tile-avatar>
              <v-icon color="white">filter_list</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title class="modal-title">
                <span class="text-white">Filter</span>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>

        <template v-else>
          <v-list-tile avatar>
            <v-list-tile-avatar>
              <v-icon color="white">search</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title class="modal-title">
                <span class="text-white">Search and Filter</span>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>

      <v-divider></v-divider>

      <template v-if="activeViewAdmin === 'Instructors'">

        <v-card elevation="0" style="padding:24px 24px 0px 24px; background-color:#fff !important;">
            <span style="font-size: 18px;">Filter by organization:</span>
            <v-autocomplete
              ref="organization"
              class="select-overflow"
              v-model="adminFilters.organization"
              :items="alphabetizedSchoolList"
              return-object
              label="Organization"
              chips
              flat
              clearable
              multiple
              @change="closeAdminFilterSelector('organization')"
            >
              <template slot="selection" slot-scope="data">
                <v-chip
                  :style="tagStyle('organization')"
                  close
                  @input="removeAdminFilterChip(['organization', data.item.text])"
                >
                  <strong :style="tagTextStyle('organization')">{{ data.item.text }}</strong>&nbsp;
                </v-chip>
              </template>
            </v-autocomplete>
            <v-switch v-model="adminFilters.adminOnly" :label="`Filter by Admin Only`" hide-details height="30"></v-switch>
          </v-card>
      </template>
      <template v-else>
        <v-list three-line style="padding:18px 24px !important;">
          <v-list-tile v-if="hasPlaylistAccess">
            <v-select
              class="width-small select-overflow"
              :items="contentTypes"
              v-model="contentType"
              @change="handleAdminFilterMenuContentSelection"
            ></v-select>
          </v-list-tile>
        <v-list-tile>
          <v-combobox
            @change="delimitAdminBulbName"
            class="width-small select-overflow"
            v-model="adminFilters.name"
            label="Name"
            :delimiters="[delimiter]"
            chips
            flat
            clearable
            multiple
          >
            <template slot="selection" slot-scope="data" class="select-overflow">
              <v-chip
                :style="tagStyle('Name')"
                close
                @input="removeAdminFilterChip(['name', data.item])"
              >
                <strong :style="tagTextStyle('Name')">{{ data.item }}</strong>&nbsp;
              </v-chip>
            </template>
          </v-combobox>
        </v-list-tile>
        <v-list-tile>
          <v-combobox
            class="width-small select-overflow"
            v-model="adminFilters.instructor"
            label="Creator Name"
            chips
            flat
            clearable
            multiple
          >
            <template slot="selection" slot-scope="data">
              <v-chip
                :style="tagStyle('Creator')"
                close
                @input="removeAdminFilterChip(['instructor', data.item])"
              >
                <strong :style="tagTextStyle('Creator')">{{ data.item }}</strong>&nbsp;
              </v-chip>
            </template>
          </v-combobox>
        </v-list-tile>
        <v-list-tile
          v-if="contentType === 'Bulbs'">
          <v-autocomplete
            ref="adminkeywords"
            class="width-small select-overflow"
            v-model="adminFilters.keywords"
            :items="tags.keywords"
            :loading="searchingForTags"
            :search-input.sync="tagSearchString"
            label="Tags"
            chips
            flat
            cache-items
            clearable
            multiple
            @change="closeAdminFilterSelector('adminkeywords')"
          >
            <template slot="selection" slot-scope="data">
              <v-chip
                :style="tagStyle('user-generated')"
                close
                @input="removeAdminFilterChip(['keywords', data.item])"
              >
                <strong :style="tagTextStyle('user-generated')">{{ data.item }}</strong>&nbsp;
              </v-chip>
            </template>
          </v-autocomplete>
        </v-list-tile>
        <v-list-tile
          style="margin-bottom: -35px; margin-top: -20px;"
          v-if="contentType === 'Bulbs'">
          <v-checkbox
            v-model="adminFilters.tagExactMatch"
            label="Exact Matches Only">
          </v-checkbox>
          <ChickFilATagButton
            :school="school"
            service="dashboard"/>
        </v-list-tile>
        <v-list-tile
          v-if="!this.filters.legacy
          && contentType === 'Bulbs'">
          <v-autocomplete
          ref="adminExcludeTags"
          class="width-small select-overflow"
          v-model="adminFilters.adminExcludeTags"
          :items="tags.keywords"
          label="Exclude Tags"
          chips
          flat
          clearable
          multiple
          cache-items
          :loading="searchingForTags"
          :search-input.sync="excludeTagSearchString"
          @change="closeAdminFilterSelector('adminExcludeTags')">
            <template slot="selection" slot-scope="data">
              <v-chip
                :style="tagStyle('user-generated')"
                close
                @input="removeAdminFilterChip(['adminExcludeTags', data.item])">
                <strong
                  :style="tagTextStyle('user-generated')">
                  {{ data.item }}
                </strong>&nbsp;
              </v-chip>
            </template>
          </v-autocomplete>
        </v-list-tile>
        <v-list-tile
          v-if="contentType === 'Bulbs'">
          <v-autocomplete
            ref="admincourse"
            allow-overflow
            class="width-small select-overflow"
            v-model="adminFilters.course"
            :items="courseResults"
            :loading=courseLoading
            :search-input.sync="searchCourse"
            item-text="name"
            item-value="id"
            deletable-chips
            cache-items
            return-object
            append-icon=""
            small-chips
            label="Course"
            @input="clearCourseSearchString"
            flat
            multiple
            @change="closeAdminFilterSelector('adminkeywords')"
          >
            <template slot="selection" slot-scope="data">
              <v-chip
                :style="tagStyle('user-generated')"
                close
                @input="removeAdminFilterChip(['course', data.item])"
              >
                <strong :style="tagTextStyle('user-generated')">{{ data.item.name }}</strong>&nbsp;
              </v-chip>
            </template>
          </v-autocomplete>
        </v-list-tile>
        <v-list-tile
          v-if="contentType === 'Bulbs'">
          <v-autocomplete
            ref="adminage"
            class="width-small select-overflow"
            v-model="adminFilters.age"
            :items="tags.age"
            label="Target Audience"
            chips
            flat
            clearable
            multiple
            :small-chips="true"
            @change="closeAdminFilterSelector('adminage')"
          >
            <template slot="selection" slot-scope="data">
              <v-chip
                :style="tagStyle('age')"
                close
                @input="removeAdminFilterChip(['age', data.item])"
              >
                <strong :style="tagTextStyle('age')">{{ data.item }}</strong>&nbsp;
              </v-chip>
            </template>
          </v-autocomplete>
        </v-list-tile>
        <v-list-tile
          v-if="contentType === 'Bulbs'">
          <v-autocomplete
            ref="adminsubject"
            class="width-small select-overflow"
            v-model="adminFilters.subject"
            :items="tags.subject"
            label="Subject"
            chips
            flat
            clearable
            multiple
            @change="closeAdminFilterSelector('adminsubject')"
          >
            <template slot="selection" slot-scope="data">
              <v-chip
                :style="tagStyle('subject')"
                close
                @input="removeAdminFilterChip(['subject', data.item])"
              >
                <strong :style="tagTextStyle('subject')">{{ data.item }}</strong>&nbsp;
              </v-chip>
            </template>
          </v-autocomplete>
        </v-list-tile>
        <v-list-tile>
          <v-autocomplete
            ref="organization"
            class="width-small select-overflow"
            v-model="adminFilters.organization"
            :items="alphabetizedSchoolList"
            return-object
            label="Organization"
            chips
            flat
            clearable
            multiple
            @change="closeAdminFilterSelector('organization')"
          >
            <template slot="selection" slot-scope="data">
              <v-chip
                :style="tagStyle('organization')"
                close
                @input="removeAdminFilterChip(['organization', data.item.text])"
              >
                <strong :style="tagTextStyle('organization')">{{ data.item.text }}</strong>&nbsp;
              </v-chip>
            </template>
          </v-autocomplete>
        </v-list-tile>
        <v-list-tile
          v-if="contentType === 'Bulbs'">
          <v-text-field
            v-model="adminFilters.youtube"
            label="Youtube Url"
          ></v-text-field>
        </v-list-tile>
        
        <v-list-tile v-if="contentType === 'Bulbs'">
          <v-combobox
            class="width-small select-overflow"
            v-model="adminFilters.bulbId"
            label="Bulb Id"
            chips
            flat
            clearable
            multiple
            type='number'
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            maxlength = "10"
          >
            <template slot="selection" slot-scope="data" class="select-overflow">
              <v-chip
                :style="tagStyle('user-generated')"
                close
                @input="removeAdminFilterChip(['bulbId', data.item])"
              >
                <strong :style="tagTextStyle('BulbId')">{{ data.item }}</strong>&nbsp;
              </v-chip>
            </template>
          </v-combobox>
        </v-list-tile>
        
      </v-list>
      </template>

      <v-card-actions  class="row-space" style="height:56px; background-color: #fff">
        <v-btn flat class="branded-grey" @click="closeMenu('adminFilterMenu')">Cancel</v-btn>
        <div class="row-center">
          <v-btn flat text class="branded-text" @click="clearAdminFilters" >Clear Filters</v-btn>
          <v-btn class="branded-background text-white"  @click="setAdminFilters">Filter</v-btn>
        </div>
      </v-card-actions>
    </v-card>

    <!--Universal Popovers-->

    <!--Popover for confirm view confirmation-->
    <v-card v-if="popoverToggles.confirm" elevation="0">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon color="white">{{confirm.icon}}</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>
              <span class="text-white">{{confirm.title}}</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-card elevation="0">
        <v-container>
          <v-card-title>{{confirm.text}}
            <v-btn v-if="confirm.download" flat text class="branded-text" @click="downloadData('Learners-BA')">Download Data</v-btn>
          </v-card-title>
          <a v-if="confirm.link" :href="confirm.link" target="_blank" class="selectable" style="text-decoration:none;">Learn More</a>
        </v-container>
      </v-card>
      <v-divider></v-divider>
      <v-card-actions class="row-space" style="height:56px">
        <v-btn v-if="dialogShow.data.type != 'rubric'" flat class="branded-grey" @click="closeMenu('confirm')">Cancel</v-btn>
        <v-btn v-if="dialogShow.data.type === 'rubric'" flat class="branded-grey" @click="closeConfirmRubric">Continue Editing</v-btn>
        <div class="row-center">
          <v-btn  class="branded-background text-white" @click="confirmRedirect(dialogShow.data.type)" >{{confirm.button}}</v-btn>
        </div>
      </v-card-actions>
    </v-card>

    <!--Popover if instructors not copied bulbs from classic yet-->
    <v-card v-if="popoverToggles.copyClassicBulbs" elevation="0">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon color="white">lightbulb</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>
              <span class="text-white">Welcome to PlayPosit 3.0!</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-card elevation="0">
        <v-container>
          <p>Before you get started, you'll need to copy your bulbs from Classic View into PlayPosit 3.0.</p>
          <a href="https://knowledge.playposit.com/article/215-faq-lms-migration-to-playposit-3-0#whyupgrade" target="_blank" class="selectable" style="text-decoration:none;">Learn More</a>
        </v-container>
      </v-card>
      <v-divider></v-divider>
      <v-card-actions class="row-right" style="height:56px">
        <v-btn  class="branded-background text-white" @click="copyClassicBulbs" >Copy Bulbs</v-btn>
      </v-card-actions>
    </v-card>

    <!-- BulbCollaborate is used in the admin media library to transfer ownership and add coOwners/facilitators -->
    <v-card
      v-if="dashModal && dashModal.type === 'adminBulbCollaborate'"
      elevation="0">
      <v-list
        class="branded-background">
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span
                class="text-white text-truncate-popover">
                  {{ adminCollaborateTitleText }}
              </span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <BulbCollaborate
        :bulb_data="dashModal.bulb">
      </BulbCollaborate>
      <v-divider></v-divider>
      <v-card-actions
        class="row-space"
        style="height:56px">
        <v-btn
          v-if="permissionPending"
          flat
          class="branded-grey"
          @click="undoBulbTransfer">
          Cancel
        </v-btn>
        <v-btn
          v-else
          flat
          class="branded-grey"
          @click="setDashModal(null)">
          Close
        </v-btn>
        <v-btn
          v-if="permissionPending"
          flat
          class="branded-background text-white"
          @click="transferOwnership(dashModal.bulb.id, true)">
          Transfer Bulb(s)
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- Start of Refactored Popovers -->
    <!-- Bulb Related Modals: -->
    <BulbAssignments
      v-if="(
        dashModal
        && dashModal.type === 'sectionInfo'
      )"
      :bulbId="dashModal.bulbId"
      :admin="dashModal.admin"
    >
    </BulbAssignments>
    <ConfirmEditBulb
      v-if="(
        dashModal
        && dashModal.type === 'confirmEditBulb'
      )"
    >
    </ConfirmEditBulb>
    <ConfirmDeleteBulb
      v-if="(
        dashModal
        && dashModal.type === 'confirmDeleteBulb'
      )"
    >
    </ConfirmDeleteBulb>
    
    <!-- Playlist Related Modals: -->
    <ConfirmDeletePlaylist
      v-if="(
        dashModal
        && dashModal.type === 'confirmDeletePlaylist'
      )"
      :playlist="dashModal.playlist"
    >
    </ConfirmDeletePlaylist>
    <ConfirmResetPlaylistAttempt
      v-if="(
        dashModal
        && dashModal.type === 'confirmResetPlaylistAttempt'
      )"
      :playlist="dashModal.playlist"
      :learner="dashModal.learner"
    >
    </ConfirmResetPlaylistAttempt>
    <CopyPlaylistLink
      v-if="(
        dashModal
        && dashModal.type === 'copyPlaylistLink'
      )"
      :playlist="dashModal.playlist"
    >
    </CopyPlaylistLink>
    <DuplicatePlaylist
      v-if="(
        dashModal
        && dashModal.type === 'duplicatePlaylist'
      )"
      :playlist="dashModal.playlist"
    >
    </DuplicatePlaylist>
    <PassbackLink
      v-if="(
        dashModal
        && dashModal.type === 'passbackLink'
      )"
      :bulbId="dashModal.bulbId"
      :bulbName="dashModal.bulbName"
      :linked="dashModal.linked"
    >
    </PassbackLink>
    <PlaylistAssign
      v-if="(
        dashModal
        && dashModal.type === 'playlistAssign'
      )"
      :playlist="dashModal.playlist"
      :hotlink="popoverHotlink"
    >
    </PlaylistAssign>
    <PlaylistCollaborate
      v-if="(
        dashModal
        && dashModal.type === 'playlistCollaborate'
      )"
      :playlist="dashModal.playlist"
      :schoolId="school.id"
    >
    </PlaylistCollaborate>
    <PlaylistMonitor
      v-if="(
        dashModal
        && dashModal.type === 'playlistMonitor'
      )"
      :playlist="dashModal.playlist"
    >
    </PlaylistMonitor>
    <PlaylistTags
      v-if="(
        dashModal
        && dashModal.type === 'playlistTags'
      )"
      :playlist="dashModal.playlist"
      :active-color="school ? school.active_color : '#2196F3'"
    >
    </PlaylistTags>
    <PlaylistCompletionFilters v-if="popoverToggles.filterMenuPlaylist"></PlaylistCompletionFilters>

    <!-- LTI Related Modals: -->
    <ConfirmUnlink
      v-if="(
        dashModal
        && dashModal.type === 'confirmUnlink'
      )"
    >
    </ConfirmUnlink>
    <Groups
      v-if="(
        dashModal
        && dashModal.type === 'groups'
      )"
      :sectionId="dashModal.sectionId"
    >
    </Groups>

    <!-- Common action modals: -->
     <DirectClassURL
      v-if="(
        dashModal
        && dashModal.type === 'directClassURL'
      )"
      :schoolId="dashModal.schoolId"
      :sectionId="dashModal.sectionId"
    >
    </DirectClassURL>
    <RejoinClass
      v-if="(
        dashModal
        && dashModal.type === 'rejoinClass'
      )"
      :rejoiningClass="dashModal.class"
    >
    </RejoinClass>
    <MigrationNotice
      v-if="(
        dashModal
        && dashModal.type === 'migrationNotice'
      )"
    >
    </MigrationNotice>
    <RemoveAccess
      v-if="(
        dashModal
        && dashModal.type === 'removeAccess'
      )"
      :archiveClass="dashModal.class"
    >
    </RemoveAccess>
  </div>
</template>

<script>
/* global dataLayer */
import Color from 'color';
import vue2Dropzone from 'vue2-dropzone';
import moment from 'moment';
import storejs from 'store';
import { validationMixin } from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators';
import { mapState, mapGetters, mapActions, mapMutations} from 'vuex';
import { encodeURI } from 'js-base64';
import * as focusTrap from 'focus-trap';

// popover screens
import AssignCourse from './modal-views/assign/AssignCourse';
import AssignLink from './modal-views/assign/AssignLink';
import BulbAssignments from './modal-views/BulbAssignments';
import BulbCollaborate from './modal-views/BulbCollaborate';
import ConfirmDeletePlaylist from './modal-views/playlist/ConfirmDeletePlaylist';
import ConfirmDeleteBulb from './modal-views/ConfirmDeleteBulb';
import ConfirmResetPlaylistAttempt from './modal-views/playlist/ConfirmResetPlaylistAttempt';
import ConfirmEditBulb from './modal-views/ConfirmEditBulb';
import ConfirmUnlink from './modal-views/ConfirmUnlink';
import CopyPlaylistLink from './modal-views/playlist/CopyPlaylistLink';
import DirectClassURL from './modal-views/DirectClassURL';
import DuplicatePlaylist from './modal-views/playlist/DuplicatePlaylist';
import PassbackLink from './modal-views/PassbackLink';
import PlaylistAssign from './modal-views/playlist/PlaylistAssign';
import PlaylistCollaborate from './modal-views/playlist/PlaylistCollaborate';
import PlaylistMonitor from './modal-views/playlist/PlaylistMonitor';
import PlaylistTags from './modal-views/playlist/PlaylistTags';
import PlaylistCompletionFilters from './modal-views/playlist/PlaylistCompletionFilters';
import CoursePermission from './CoursePermission.vue'; // [ ] move into modal-views
import Groups from './modal-views/groups/Groups';
import RejoinClass from './modal-views/RejoinClass';
import RemoveAccess from './modal-views/RemoveAccess';
import MigrationNotice from './modal-views/MigrationNotice';
import Share from './Share.vue'; // [ ] move into modal-views

// graphs
import BarChart from './graphs/StackedBarChart';
import PieChart from './graphs/PieChart';

// general components
import ClipboardCopy from '@/components/buttons/clipboardCopy';
import _ from 'lodash';

import {
  LTI_RENDER_PATHS,
  PLAYPOSIT_PHP_ENDPOINTS,
} from '@Constants';

export default {
  name: 'popover',
  props: [],
  components: {
    AssignCourse,
    AssignLink, 
    BulbAssignments,
    BulbCollaborate,
    PassbackLink,
    ClipboardCopy,
    Groups,
    Share,
    ConfirmDeletePlaylist,
    ConfirmResetPlaylistAttempt,
    ConfirmEditBulb,
    ConfirmDeleteBulb,
    ConfirmUnlink,
    CopyPlaylistLink,
    CoursePermission,
    DirectClassURL,
    DuplicatePlaylist,
    vueDropzone: vue2Dropzone,
    BarChart,
    PieChart,
    PlaylistAssign,
    PlaylistCollaborate,
    PlaylistMonitor,
    PlaylistTags,
    PlaylistCompletionFilters,
    RejoinClass,
    RemoveAccess,
    MigrationNotice,
  },
  mixins: [validationMixin],
  validations: {
      profileData:{
        first_name: {
          required,
          maxLength: maxLength(25),
          excluded: n => !(/[<>.,\/#!$%\^&\*;:{}=\?_`~()]/g.test(n)) // prevent adding scripts tags, commas, question marks, and semicolons
        },
        last_name: {
         required,
         maxLength: maxLength(25),
         excluded: n => !(/[<>.,\/#!$%\^&\*;:{}=\?_`~()]/g.test(n)) // prevent adding scripts tags, commas, question marks, and semicolons,
        },
    }
  },
  data() {
    return {
      contentTypes: ['Bulbs', 'Playlists'],
      publicPath: process.env.BASE_URL,
      resetPopoverToggle: true,
      archived: false,
      ariaAlert: null, 
      assignClass: {},
      assignTabs: 0,
      assignBroadcast: false,
      averagePieChartOptions: {
        title: {
          display: true,
          text: 'Bulb Average Score',
          position: 'top'
        },
        legend: {
          display: true,
          labels: {
            boxWidth: 20,
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            display: false, 
          }
        },
    },
    completePieChartOptions: {
        title: {
          display: true,
          text: 'Bulb Completed Status',
          position: 'top'
        },
        legend: {
          display: true,
          labels: {
            boxWidth: 20,
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            display: false,
          }
        }
    },
      addClass: {
        name: '',
        color: '#737373',
        colorWarning: false,
      },
      editClass: {
        id: 0,
        name: '',
        default_color: '#737373',
        colorWarning: false,
      },
      editClassOriginal: {
        name: '',
        default_color: '',
      },
      addFolder: {
        name: '',
        default_color: '#737373',
        colorWarning: false,
        subfolder: 0
      },
      editFolder: {
        name: '',
        default_color: '#737373',
        colorWarning: false,
        subfolder: 0
      },
      editFolderOriginal: {
        name: '',
        default_color: '',
        colorWarning: false,
        subfolder: 0
      },
      copyFolder: {
        name:''
      },
      shareFolder: {
        copied: false,
      },
      copy: {
        name: '',
        advanced: false,
        fullCopy: true,
      },
      moveClass: {
        step: 1,
        classSelected: {}
      },
      player: null,
      lmbData: {
        name: '',
        learning_objective: '',
        advanced: false,
        points: 10,
        allow_upload: false,
        peer_review: false,
        pr_rubric: false,
        pr_anonymous: false,
        autograde: false,
        share: false,
        data: false,
        anonymous:false,
        allowPrivateVideoHosts: true,
        learnersAccessTheirOwnVideoIntegrationContent: false,
      },
      lmbDataOriginal: {
        name: '',
        learning_objective: '',
        advanced: false,
        points: 10,
        allow_upload: false,
        peer_review: false,
        pr_rubric: false,
        pr_anonymous: false,
        autograde: false,
        share: false,
        data: false,
        anonymous:false,
        allowPrivateVideoHosts: true,
        learnersAccessTheirOwnVideoIntegrationContent: false,
      },
      lti: {
        options: [],
        type: '',
        placement: 'iframe',
        enable_groups: false, // this is used in an html toggle, requires bulb to be LMB and the school to have group import (api tokens)
        group_set_id: 0,
        placementOptions: [
          {
            text:'Load in a new tab',
            value:'window',
            disabled: false,
          },
          {
            text:'Show as Link',
            value:'frame',
            disabled: false,
          },
          {
            text:'Embed',
            value:'iframe',
            disabled: false,
          },
        ],
        width:800,
        height:600,
      },
      filters: {
        name: [],
        creator: [],
        subject: [],
        age: [],
        keywords: [],
        bulbRole: [],
        standards: '',
        youtube: '',
        bulbId:'',
        all_district: true,
        legacy: false,
        tagExactMatch: false,
        excludeTags: [],
        playlistRole: [],
        playlistId: [],
      },
      filterOrganizationOptions: [
        {text:"All Organizations/District Bulbs", value: true},
        {text:'My Site Bulbs Only', value: false},
      ],
      //learner popover data
      join: {
        classCode: ''
      },
      profileData: {
        email:'',
        first_name: '',
        last_name: '',
        color:'#2196F3',
        colorWarning: false,
      },
      profileDataOriginal: {
        first_name:'',
        last_name: '',
      },
      shareLearner : {
        copied: false,
      },

      //admin popover data
      addSchool: {
        name: '',
        integrations: [],
        privacy: 2,
        thumbnail: 'https://cdn.playposit.com/images/dog_white_pad.png',
        active_color: '#2196F3',
        inactive_color: '#1976d2',
        base_color: '#FFF'
      },
      multipleSchools: false,
      addSchoolOriginal: {
        name: '',
        integrations: [],
        privacy: 2,
        thumbnail: 'https://cdn.playposit.com/images/dog_white_pad.png',
        active_color: '#2196F3',
        inactive_color: '#1976d2',
        base_color: '#FFF'
      },
      addSchoolOptions: {
        id: 'school-branding-thumbnail',
        acceptedFiles: 'image/*,.png,.jpg,.jpeg,.gif',
        thumbnailWidth: 248,
        thumbnailHeight: 144,
        // resizeWidth: 200,
        maxFilesize: 50000, // MB
        timeout: 500000,
        addRemoveLinks: true,
        uploadMultiple: false,
        dictDefaultMessage:`<img class="school-branding-preview" style="background-color:#fafafa;" src="https://cdn.playposit.com/images/dog_white_pad.png" />`,
        url: 'https://api.playposit.com/upload/image',
        accept(file, done) {
          done();
        },
      },
      editSchoolOptions: {
        id: 'school-branding-thumbnail',
        acceptedFiles: 'image/*,.png,.jpg,.jpeg,.gif',
        thumbnailWidth: 248,
        thumbnailHeight: 144,
        // resizeWidth: 200,
        maxFilesize: 50000, // MB
        timeout: 500000,
        addRemoveLinks: true,
        uploadMultiple: false,
        dictDefaultMessage:'',
        url: 'https://api.playposit.com/upload/image',
        accept(file, done) {
          done();
        },
      },
      addInstructorTab: 0,
      addInstructorManual: {
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        institution: {}
      },
      addInstructorReady: false,
      addInstructorReset: true,
      editInstructor: {
        first_name: '',
        last_name: '',
        email: '',
        institution: {}
      },
      editInstructorOriginal: {
        first_name: '',
        last_name: '',
        email: '',
        institution: {}
      },
      editInstructorReady: false,
      errors: [],
      multipleInstructors: false,
      adminFilters: {
        name: [],
        instructor: [],
        subject: [],
        age: [],
        keywords: [],
        course: [],
        organization: [],
        youtube: '',
        bulbId:'',
        tagExactMatch: false,
        adminExcludeTags: [],
      },
      rules: {
        notEmpty: value => !!value.length || 'This value cannot be empty.',
        validEmail: value =>  new RegExp(/[^@]+@[^\.]+\..+/g).test(value) || 'Email must be a valid format', // !!(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value)) old regex froze dash when typing too fast
        selected: value => !!Object.keys(value).length || 'Please select an organization',
        maxLength255: value => _.get(value, 'length', 0) < 255 || 'Character Limit Reached',
        validPassword: value => {
          if (value.match(/[a-z]/g) && value.match(/[A-Z]/g) && value.match(/[0-9]/g) && value.length >= 8 && value.match(/^\S*$/)) {
            return true;
          }
          return 'Passwords must be a minimum of eight characters, have at least one number, not have spaces, and have a mix of uppercase and lowercase characters.';
        }
      },
      snapshotSettingTab: 0,
      snapshot: {
        date: [],
        institution: {}
      },
      snapshotOriginal: {
        date: [],
        institution: {}
      },
      snapshotexport: '',
      snapshotExportTypes: [
        {text:'Student Engagement (hours)', value:'engagement'},
        {text:'Most Engaged Classes', value:'classes'},
        {text:'Bulbs Delivered', value:'delivered'},
        {text:'Most Viewed Bulbs', value:'viewed'},
        {text:'Bulbs Created', value:'created'},
        {text:'Top Creator', value:'creators'},
      ],
      successAdminVideoUpload: false,
      trap: null,
      descriptionLimit: 60,
      entries: [],
      isLoading: false,
      model: null,
      searchCourse: null,
      datePickerOptions: {
        disabledDate (date) {
          return ((date < moment('12/01/2018')) || (date > moment()));
        }
      },
      
      tagSearchString: null,
      excludeTagSearchString: null,
      enableGrading: '',
      yesNoOption: [
        { 
          name: 'Yes',
          value: 1
        },
        {
           name: 'No',
           value: 0
        }
      ],
      overwriteAccess: true,
    };
  },
  computed: {
    ...mapState([
      'lti13Launch',
      'LTIPlacement',
    ]),
    ...mapState('instructors', [
      'addEmailList',
      'bulbAnalytics',
      'bulbAnalyticsSummaryChart',
      'bulbHasNoSummaryData',
      'summaryChartKey',
      'bulbAverageScoreChart',
      'averageChartKey',
      'bulbHasNoAverageData',
      'bulbCompleteChart',
      'completeChartKey',
      'bulbHasNoCompleteData',
      'permissionPending',
      'premadeFilterContentType',
      'selectedUser',
    ]),
    ...mapState('admin', [
      'courseLoading',
      'courseResults',
      'delimiter',
    ]),
    ...mapGetters([
      'activeView',
      'dashModal',
      'instructorData',
      'dialogShow',
      'primaryAccount',
      'username',
      'learnerData',
      'popoverToggles',
      'breadcrumbs',
      'lmb',
      'LTIlaunch',
      'LMSdata',
      'LTIdata',
      'LTILogs',
      'ltiSync',
      'designerApiPrefix',
      'phpApiPrefix',
      'popoverDataLoading',
      'slideOutLarge',
      'instructorType',
      'pro',
      'free',
      'adminData',
      'school',
      'peerReviewSchool',
      'legacy',
      'searchingForTags',
      'shareNodeApiPrefix',
      'serverURL',
      'hasCanvasApi',
      'userAgent',
    ]),
    ...mapGetters('instructors', [
      'activeViewInstructor',
      'queryParamsInstructors',
      'classes',
      'instructorAjaxing',
      'selectedData',
      'assignedDates',
      'assignedBulbSections',
      'gradebookBreadcrumbs',
      'interactions',
      'tags',
      'importLogs',
      'importLogsLoading',
      'filterSearch',
      'editLMBRubric',
      'groups',
      'folders',
      'foldersBulb',
      'filtersInteraction',
      'bulbRoles',
      'playlistRoles',
    ]),
    ...mapGetters('learners', [
      'activeViewLearners',
      'classSearch',
      'queryParamsLearners'
    ]),
    ...mapGetters('admin', [
      'adminFilterSearch',
      'activeViewAdmin',
      'adminAjaxing',
      'schools',
      'schoolList',
      'addInstructorCsv',
      'manualAddStatus',
      'snapshotsettings',
      'newBulb',
      'selectedDataAdmin',
      'selectedNode',
    ]),
    adminCollaborateTitleText() {
      if (this.selectedData.length > 1) {
        return `Managing permissions for ${this.selectedData.length} bulbs.`;
      }
      return `Managing permissions for ${this.dashModal.bulb.name}`;
    },
    alphabetizedSchoolList() {
      return _.orderBy(this.schoolList, ['text'], 'DESC');
    },
    bulbSettingsUserType() {
      if (this.instructorType === 'free') return 'freeTeacher';
      else if (this.instructorType === 'pro') return 'premiumTeacher';
      return _.get(this, 'instructorData.isAdmin') ? 'schoolAdmin' : 'schoolTeacher';
    },
    activeViewDisplay: function(){
      return this.activeViewInstructor.replace('-', ' ');
    },
    contentType: {
      get () {
        return this.$store.state.admin.adminFilterContentType;
      },
      set (value) {
        this.setAdminFilterContentType(value);
      }
    },
    exportType: function(){
      if(this.dialogShow.data.analytics){
        return `"${this.dialogShow.data.bulb_name}"`
      } else if(this.dialogShow.data.playlistAnalytics) {
          return `"${this.dialogShow.data.playlist_name}"`
      } else if(this.activeViewAdmin === 'Instructors' && this.dialogShow.data.isAdmin){
         return this.activeViewAdmin.replace('-', ' ');
      } else {
        return this.activeViewInstructor.replace('-', ' ');
      }
    },
    classNames: function() {
      //computed variable for all class names
      let array = [];
      this.classes.data.forEach(item => array.push(item.name));
      return array;
    },
    downloadDataText() {
      if (this.dialogShow.data.bulb_role === 3) return 'Download Data*';
      return 'Download Data';
    },
    premadeContentType: {
      get() {
        return this.premadeFilterContentType;
      },
      set(value) {
        this.setPremadeFilterContentType(value);
      }
    },
    subfolderOptions: function(){
      if(this.foldersBulb.folders.length > 0){
        let array = [];
        this.foldersBulb.folders.forEach(item => {
          //check if add or edit
          if(this.popoverToggles.editFolder){
            //if edit- remove folder from subfolder options
            if(item.id != this.dialogShow.data.id){
              array.push({text:item.name, value: item.id});
            }
          } else {
            array.push({text:item.name, value: item.id});
          }
        })
        return array;
      } else {
        return []
      }
    },
    subfolderNodeOptions: function(){
      if(this.foldersBulb.folders.length > 0){
        let array = [];
        this.foldersBulb.folders.forEach(item => {
          //check if add or edit
          if(this.popoverToggles.editFolder) {
            //if edit- remove folder from subfolder options
            if(item.id != this.dialogShow.data.id) {
              array.push({text:item.name, value: item.id});
            }
          } else {
            array.push({text:item.name, value: item.id});
          }
        })
        return array;
      } else {
        return []
      }
    },
    assignDates: function(){
      //computed variable for assigned dates
      return this.assignedDates;
    },
    assignPopoverHeight: function(){
      if(this.queryParamsInstructors.section_id === ''){
        return '412'
      } else {
        return '222'
      }
    },
    baPercentage: function(){
      if(this.instructorType === 'free'){
        return (this.free.ba_limit / 100) * 100;
      } else {
        return 0;
      }
    },
    importLogTableHeight: function(){
      //set import log table height based on warning
      if(this.legacy.showImportWarning){
        return '350px';
      } else {
        return '400px';
      }
    },
    copyBulbName: function(){
      //compute copy bulb title
      if(this.dialogShow.data) {
        if(this.filterSearch.legacy){
          this.copy.name = `Copy of ${this.dialogShow.data.title}`;
        } else {
          this.copy.name = `Copy of ${this.dialogShow.data.name}`;
        }
      }
    },


    //computed variables to track changes in edit data
    editClassChanged: function(){
      //compute flag if edit class data is changed
      return((this.editClass.name === this.editClassOriginal.name) && (this.editClass.default_color === this.editClassOriginal.default_color));
    },
    profileChanged: function(){
      //compute flag if learner profile date is changed
      return((this.profileData.first_name === this.profileDataOriginal.first_name) && (this.profileData.last_name === this.profileDataOriginal.last_name));
    },
    lmbEditChange: function(){
      let change = false;

      if(this.lmbData.name != this.lmbDataOriginal.name) change = true;
      if(this.lmbData.learning_objective != this.lmbDataOriginal.learning_objective) change = true;
      if(this.lmbData.points != this.lmbDataOriginal.points) change = true;
      if(this.lmbData.allow_upload != this.lmbDataOriginal.allow_upload) change = true;
      if(this.lmbData.peer_review != this.lmbDataOriginal.peer_review) change = true;
      if(this.lmbData.pr_rubric != this.lmbDataOriginal.pr_rubric) change = true;
      if(this.lmbData.pr_anonymous != this.lmbDataOriginal.pr_anonymous) change = true;
      if(this.lmbData.autograde != this.lmbDataOriginal.autograde) change = true;
      if(this.lmbData.share != this.lmbDataOriginal.share) change = true;
      if(this.lmbData.data != this.lmbDataOriginal.data) change = true;
      if(this.lmbData.anonymous != this.lmbDataOriginal.anonymous) change = true;
      if(this.lmbData.allowPrivateVideoHosts != this.lmbDataOriginal.allowPrivateVideoHosts) change = true;
      if(this.lmbData.learnersAccessTheirOwnVideoIntegrationContent != this.lmbDataOriginal.learnersAccessTheirOwnVideoIntegrationContent) change = true;

      return change;
    },


    //video data
    videoThumbnail:function() {
      return {
        backgroundImage: `url("${this.dialogShow.data.thumbnail}")`
      }
    },
    //remove switch variables
    remove: function(){
      if (
        this.$route.name === 'admin'
        && this.$route.path === '/dash/admin/Administration/Treeview'
      ) {
        // Admin media library
        if (_.isArray(this.dialogShow.data)) {
          // Deleting multiple bulbs
          const isPlural = this.dialogShow.data.length !== 1;
          return {
            title: `Delete ${this.dialogShow.data.length} Bulb${isPlural ? 's' : ''}` ,
            question: `Are you sure you would like to delete the ${this.dialogShow.data.length} selected bulb${isPlural ? 's' : ''}?`,
            icon: 'delete',
            action: 'Delete',
            type: 'My-Bulbs-Multiple',
          };
        }
        if (this.dialogShow.data.bulb_role === 1) return {title: `Delete "${this.dialogShow.data.name}"` , question:`Are you sure you would like to delete "${this.dialogShow.data.name}"?` , icon:'delete', action:'Delete', type:'My-Bulbs-BA'};
        // If removing access (not bulb owner)
        return {title: `Remove Access for "${this.dialogShow.data.name}"` , question:`Are you sure you would like to remove access for "${this.dialogShow.data.name}"?` , icon:'person_add_disabled', action:'Remove Access', type:'Remove-Access'};
      }
      switch(this.activeViewInstructor){
        case 'My-Bulbs':
          if (_.isArray(this.dialogShow.data)) {
            // Deleting multiple bulbs
            const isPlural = this.dialogShow.data.length !== 1;
            return {
              title: `Delete ${this.dialogShow.data.length} Bulb${isPlural ? 's' : ''}` ,
              question: `Are you sure you would like to delete the ${this.dialogShow.data.length} selected bulb${isPlural ? 's' : ''}?`,
              icon: 'delete',
              action: 'Delete',
              type: 'My-Bulbs-Multiple',
            };
          }
          // delete bulb data export
          // If bulb owner:
          if (this.dialogShow.data.bulb_role === 1) return {title: `Delete "${this.dialogShow.data.name}"` , question:`Are you sure you would like to delete "${this.dialogShow.data.name}"?` , icon:'delete', action:'Delete', type:'My-Bulbs-BA'};
          // If removing access (not bulb owner)
          return {title: `Remove Access for "${this.dialogShow.data.name}"` , question:`Are you sure you would like to remove access for "${this.dialogShow.data.name}"?` , icon:'person_add_disabled', action:'Remove Access', type:'Remove-Access'};
        case 'Classes':
          // delete section data export
          return {title: `Archive "${this.dialogShow.data.name}"` , question:`Are you sure you would like to archive "${this.dialogShow.data.name}"?` , icon:'archive', action:'Archive', type:'Gradebook'};
        case 'Bulbs': // this should really ClassBulbs
          // deleteing bulb from section
          return {title: `Remove "${this.dialogShow.data.name}"` , question:`Are you sure you would like to remove/unassign "${this.dialogShow.data.name}" from this class?` , icon:'remove_circle', action:'Remove', type:'Bulbs-BA'};
        case 'Learners':
          return {title: `Remove Learner${this.selectedData.length > 1 ? 's' : ''}` , question:`Are you sure you would like to remove the learner${this.selectedData.length > 1 ? 's' : ''} from this class? Warning: All data will be archived. To export their data for this class, click the button below.` , icon:'remove_circle', action:'Remove', type:'Learners-BA'};
        case 'Folders':
          return {title: `Delete Folder` , question:`Are you sure you would like to delete the folder "${this.dialogShow.data.name}"?` , icon:'remove_circle', action:'Delete', type:'Folders'};
        case 'Folder':
          if(this.dialogShow.data.isFolder == 1){
            //is folder
            return {title: `Delete Folder` , question:`Are you sure you would like to delete the folder "${this.dialogShow.data.name}"?` , icon:'remove_circle', action:'Delete', type:'Folders'};
          } else {
            //is bulb
            return {title: `Remove Bulb From Folder` , question:`Are you sure you would like to remove "${this.dialogShow.data.name}" from this folder?` , icon:'remove_circle', action:'Remove', type:'BulbFolder'};
          }
        case 'Subfolder':
          return {title: `Remove Bulb From Folder` , question:`Are you sure you would like to remove "${this.dialogShow.data.name}" from this folder?` , icon:'remove_circle', action:'Remove', type:'BulbFolder'};
        default:
          return {title:'Remove' , question:'Are you sure you would like to remove this?' , icon:'remove_circle', action:'Remove', type:'Default'};
      }
    },
    confirm: function(){
      switch(this.dialogShow.data.type){
        case 'classic':
          return {text:'Warning! The bulbs and learner data that you see now may not be visible in Classic View. Are you sure you want to switch to Classic View?', button:'Classic View', icon:'settings_backup_restore', title:'Classic View' , link:''};
        case 'learner':
          return {text:'Warning! The bulbs that you see now may be different from the ones that you see in Classic View. Are you sure you want to switch to Classic View?', button:'Classic View', icon:'settings_backup_restore', title:'Classic View' , link:''};
        case 'gradebook':
          return {text:'Warning! The bulbs and learner data that you see now may not be visible in Classic View. Are you sure you want to switch to Classic View?', button:'Classic Gradebook', icon:'settings_backup_restore', title:'Classic View' , link:''};
        case 'bulbs':
          return {text:'Warning! The bulbs and learner data that you see now may not be visible in Classic View. Are you sure you want to switch to Classic View?', button:'Classic View', icon:'settings_backup_restore', title:'Classic View' , link:''};
        case 'logout':
          return {text:'Are you sure that you would like to logout of your PlayPosit account?', button:'Logout', icon:'power_settings_new', title:'Logout' , link:''};
        case 'video':
          return {text:`Are you sure that you would like to remove "${this.dialogShow.data.data.name}" from My Videos?`, button:'Remove', icon:'delete', title:`Remove "${this.dialogShow.data.data.name}"` , link:''};
        case 'import':
          return {text:`To access your previously-created content, copy your bulbs into PlayPosit 3.0. Please note, data from Classic bulbs will not be copied over.`, button:'Copy Bulbs', icon:'lightbulb', title:`Copy Classic Bulbs`, link:'https://knowledge.playposit.com/article/215-faq-lms-migration-to-playposit-3-0'
          };
        case 'importunits':
          return {text:`To access your previously-created units, copy your units to folders in PlayPosit 3.0.`, button:'Copy Units', icon:'folder', title:`Copy Classic Units to Folders`, link:'https://knowledge.playposit.com/article/215-faq-lms-migration-to-playposit-3-0'
          };
        case 'reset':
          return {text:`Would you like to reset the bulb attempts for the ${this.selectedData.length} selected student${(this.selectedData.length >1) ? 's' : ''}?`, button:'Reset', icon:'replay', title:`Reset Bulb Attempts`, link:''
          };
        case 'lmbreset':
          return {text:`Would you like to reset the learner made bulb for the ${this.selectedData.length} selected student${(this.selectedData.length >1) ? 's' : ''}?`, button:'Reset', icon:'replay', title:`Reset Learner Made Bulb`, link:''
          };
        case 'removeClass':
          return {text:`Would you like to remove "${this.dialogShow.data.data.name}" from your class list?`, button:'Remove', icon:'delete', title:`Remove "${this.dialogShow.data.data.name}"`, link:''
          };
        case 'move':
          return {text:`Would you like to move the ${this.selectedData.length} learner${this.selectedData.length > 1 ? 's' : ''} to "${this.moveClass.classSelected.name}"? Warning: All data will be archived when the learner is moved to a different class. To export their data for this class, click the button below.`, button:'Move', icon:'arrow_right_alt', title:'Move Learners', link:'', download: true,
          };
        case 'unlocklmb':
          let array = this.dialogShow.data.data.student_name.split(', ');
          let student_name = `${array[1]} ${array[0]}`;
          return {text:`Would you like to unlock this bulb to allow ${student_name} to edit? Warning! This will mark the bulb as incomplete and ${student_name} will need to resubmit the bulb again.`, button:'Unlock', icon:'lock_open', title:'Unlock Learner Made Bulb', link:''
          };
        case 'unarchive':
          return {text:` Unarchiving "${this.dialogShow.data.data.name}" will make this class and assigned bulbs visible to enrolled learners again. Do you want to continue?`, button:'Unarchive', icon:'unarchive', title:`Unarchive "${this.dialogShow.data.data.name}"`, link:''
          };
        case 'rubric':
          return {text:` Warning! The rubric for this peer review assignment has not been saved. Closing the rubric designer now will disable rubric grading.`, button:'Disable Rubric', icon:'highlight_off', title:`Close and disable rubric grading`, link:''
          };
        case 'removeInstructor':
          return {text:`Warning! Would you like to remove instructor${this.selectedDataAdmin.length > 1 ? 's' : ''} from your organization?`, button:"Remove", icon:'person', title:`Remove Instructor${this.selectedDataAdmin.length > 1 ? 's' : ''}`, link:''
          };
        case 'copyfolder':
          return {text:`Would you like to copy the folder "${this.dialogShow.data.data.name}" to your folders?`, button:"Copy", icon:'folder', title:`Copy Folder "${this.dialogShow.data.data.name}"`, link:''
          };
        default:
          return {text:'Are you sure that you would like to continue?', button:'Confirm', icon:'settings_backup_restore', title:'Confirm'};
      }
    },
    shareLearnerData: function(){
      if(this.dialogShow.data.config.lmb.data || (!this.dialogShow.data.config.lmb.data && !this.dialogShow.data.config.lmb.anonymous)){
        return {url:`${this.shareNodeApiPrefix}/go/play/${this.dialogShow.data.lmb_bulb_id}/${this.instructorData.id}/${this.dialogShow.data.lmb_section_id}/0/${this.dialogShow.data.name.replace(/\s/g, '-').replace(/\//g, '-').replace(/[^a-zA-Z0-9-]/g, '')}`, text:'Copy and share this url with your peers to allow them to take your bulb.'};
      } else {
        return {url:`${this.shareNodeApiPrefix}/go/listcode/${this.dialogShow.data.lmb_bulb_id}/${this.instructorData.id}/${this.dialogShow.data.lmb_section_id}/2/${this.dialogShow.data.name.replace(/\s/g, '-').replace(/\//g, '-').replace(/[^a-zA-Z0-9-]/g, '')}`, text:'Copy and share this url with your peers to allow them to take your bulb anonymously.'};
      }
    },
    copyBulbLabel: function(){
      if(this.copy.fullCopy){
        return "Copy entire bulb (including interactions)"
      } else {
        return "Copy bulb's video sources only"
      }
    },
    //admin
    schoolEditChange: function(){
      let change = false;

      if(this.addSchool.name != this.addSchoolOriginal.name) change = true;
      if(this.addSchool.privacy != this.addSchoolOriginal.privacy) change = true;
      if(this.addSchool.thumbnail != this.addSchoolOriginal.thumbnail) change = true;
      if(this.addSchool.active_color != this.addSchoolOriginal.active_color) change = true;
      if(this.addSchool.inactive_color != this.addSchoolOriginal.inactive_color) change = true;
      if(this.addSchool.base_color != this.addSchoolOriginal.base_color) change = true;

      return change;
    },
    manualAddInstructorSuccess: function(){
      return this.manualAddStatus.success;
    },
    editInstructorChange: function(){
      return !_.isEqual(this.editInstructor, this.editInstructorOriginal);
    },
    filterSnapshotChange: function(){
      return !_.isEqual(this.snapshot, this.snapshotOriginal);
    },
    editFolderChange: function(){
      return !_.isEqual(this.editFolder, this.editFolderOriginal);
    },
    shareFolderUrl: function(){
      return `${this.phpApiPrefix}/share-folder/${this.dialogShow.data.id}`
    },
    pointsAvailable() {
      return this.dialogShow.data.points_available;
    },
    hasPlaylistAccess() {
      return _.get(this, 'school.config.permissions', []).includes('hasPlaylistAccess');
    },
    isSafari() {
      return _.get(this, 'userAgent.browser.name', '').toLowerCase() === 'safari';
    },
  },
  methods: {
  ...mapActions([
    'unlinkBulb',
    'unlinkPlaylist',
  ]),
  ...mapActions('instructors', [
    'assignBulbSection',
    'changeOwner',
    'changeSectionOwner',
    'updateInstructorBulbSettings'
  ]),
  ...mapMutations('instructors', [
    'setBulbHasNoSummaryData',
    'setPermissionPending',
    'setPremadeFilterContentType',
    'setSelectedUser',
    'resetAddEmailList',
  ]),
  ...mapMutations([
    'handleDialogOpen',
    'setDashModal',
    'slideOut',
    'triggerSnackbar',
  ]),
  ...mapMutations('admin', [
    'setAdminFilterContentType',
  ]),
  delimitAdminBulbName(value) {
    this.adminFilters.name = [...new Set(value.reduce((prev, current) => [...prev, ...current.split(this.delimiter)], []))];
  },
    //close popover menu
    announceAriaAlert: function() {
      this.ariaAlert = this.formErrors('join');
    },
    closeMenu: function(type){
      //close popover menu and reset data based on type
      if(type === "profile" && !this.profileChanged){
       //if profile, check if profile is changed and inform that changes are not saved
        if(confirm('Are you sure you would like to exit? All unsaved changes will be lost.')){
         this.dialogShow.dash = false;
         this.popoverToggles.profile = false;
        }
      } else {
      //all other types, close modal
      this.dialogShow.dash = false;

      if(type === "join"){
         //close menu and reset data
         this.popoverToggles.joinClass = false;
         this.$store.commit('learners/resetClassSearch');
       } else if(type === 'confirm' && (this.dialogShow.data.type === 'reset' || this.dialogShow.data.type === 'lmbreset' || this.dialogShow.data.type === 'move')){
         this.popoverToggles.confirm = false;
         this.$store.commit('instructors/setSelectedData', []);
         this.$store.commit('instructors/refreshData');
       } else if(type === 'move' || (type === 'remove' && this.activeViewInstructor === 'Learners')){
         this.popoverToggles.moveMenu = false;
         this.popoverToggles.remove = false;
         this.$store.commit('instructors/setSelectedData', []);
         this.$store.commit('instructors/refreshData');
       } else if(type === 'addVideo'){
         //if add video menu is closed, check if video already successfully added
         //if not- archive bulb shell
         if(this.successAdminVideoUpload){
           this.popoverToggles.addVideo = false;
         } else {
           this.popoverToggles.addVideo = false;
           this.$store.dispatch('admin/archiveShellBulb');
         }
       } else if(type === 'confirm' && this.popoverToggles.bulbAnalytics) {
         this.popoverToggles.bulbAnalytics = false;
         this.setBulbHasNoSummaryData(false);
       } else if (type === 'shareMenu') {
         this.popoverToggles.shareMenu = false;
         this.$store.commit('instructors/setSelectedData', []);
         this.$store.commit('instructors/refreshData');
       } else {
         //close menus that do not require data reset
         this.popoverToggles.addMenu = false;
         this.popoverToggles.copyMenu = false;
         this.popoverToggles.profile = false;
         this.popoverToggles.monitor = false;
         this.popoverToggles.editMenu = false;
         this.popoverToggles.filterMenu = false;
         this.popoverToggles.exportMenu = false;
         this.popoverToggles.assignMenu = false;
         this.popoverToggles.graphMenu = false;
         this.popoverToggles.assignDateMenu = false;
         this.popoverToggles.remove = false;
         this.popoverToggles.preview = false;
         this.popoverToggles.export = false;
         this.popoverToggles.importStatus = false;
         this.popoverToggles.mobileWarning = false;
         this.popoverToggles.bulbInfo = false;
         this.popoverToggles.lti = false;
         this.popoverToggles.ltiSync = false;
         this.popoverToggles.confirm = false;
         this.popoverToggles.interaction = false;
         this.popoverToggles.filterMenuInteraction = false;
         this.popoverToggles.filterMenuPlaylist = false;
         this.popoverToggles.lmb = false;
         this.popoverToggles.lmbEdit = false;
         this.popoverToggles.shareLearner = false;
         this.popoverToggles.groups = false;
         this.popoverToggles.addSchool = false;
         this.popoverToggles.addNodeFolder = false;
         this.popoverToggles.editNodeFolder = false;
         this.popoverToggles.editSchool = false;
         this.popoverToggles.addInstructors = false;
         this.popoverToggles.editInstructors = false;
         this.popoverToggles.adminFilterMenu = false;
         this.popoverToggles.snapshot = false;
         this.popoverToggles.broadcast = false;
         this.popoverToggles.addFolder = false;
         this.popoverToggles.editFolder = false;
         this.popoverToggles.addToFolder = false;
         this.popoverToggles.copyFolder = false;
         this.popoverToggles.shareFolder = false;
         this.popoverToggles.coursePermission = false;
         this.popoverToggles.copyClassicBulbs = false;
         if (
          this.activeView === 'Administration'
          && [
            'Bulbs',
            'Treeview'
          ].includes(this.activeViewAdmin)
         ) {
          EventBus.$emit('sendProquestBulbDeletionData', this.dialogShow.data);
         }
       }
     }
     this.resetPopoverToggle = true;
     this.$nextTick(() => {
       this.resetPopoverToggle = false;
     })
    },
    closeConfirmRubric: function(){
      this.popoverToggles.confirm = false;
      this.handleDialogOpen({type:'lmbRubric', data:{}})
      this.$store.commit('slideOut', {toggle:true, view: 'rubric'})
    },
    closeRubric: function(){
      this.popoverToggles.lmbRubric = false;
      this.handleDialogOpen({type:'confirm', data:{type:'rubric'}})
    },

    //life cycle functions to get and reset data
    getData: async function() {
       //gets data for share modal
       if(this.queryParamsInstructors.section_id != ''){
         this.classes.data.forEach(item => {
          if(item.id == this.queryParamsInstructors.section_id){
            this.assignClass = item;
          }
        })
       }

       //on mount, set data from data prop
       if(this.popoverToggles.editMenu) {
         //if edit class, set class name and color
         this.editClass.id = this.dialogShow.data.id;
         this.editClass.name = this.dialogShow.data.name;
         this.editClass.default_color = (!this.dialogShow.data.default_color) ? '#737373' : this.dialogShow.data.default_color;
         this.editClassOriginal.name = this.dialogShow.data.name.slice(0, this.data.name.length);
         this.editClassOriginal.default_color= (!this.dialogShow.data.default_color) ? '#737373' : this.dialogShow.data.default_color.slice(0, this.dialogShow.data.default_color.length);
       }
       if(this.popoverToggles.addFolder){
         this.$store.dispatch('instructors/getFolders', 0);
       }
       
       if(this.popoverToggles.editFolder || this.popoverToggles.editNodeFolder ) {
         this.$store.dispatch('instructors/getFolders', 0);
         let obj = {
           name: this.dialogShow.data.name,
           default_color: (this.dialogShow.data.default_color) ? this.dialogShow.data.default_color : '#737373',
           subfolder: (this.dialogShow.data.parent_id != null) ? this.dialogShow.data.parent_id : 0,
           colorWarning:false,
         }

         this.editFolder = obj;
         this.editFolderOriginal = Object.assign({}, obj);
       }

       if(this.popoverToggles.bulbAnalytics){
         this.$store.dispatch('instructors/getBulbAnalytics', this.dialogShow.data);
       }

       if(this.popoverToggles.addToFolder){
         this.$store.dispatch('instructors/getFolders', this.dialogShow.data.id);
       }

       if(this.popoverToggles.copyFolder){
         this.copyFolder.name = `Copy of ${this.dialogShow.data.data.name}`;
       }

       if(this.popoverToggles.assignMenu || this.popoverToggles.monitor || this.popoverToggles.broadcast){
         //if assign, dispatch get assigned dates for bulb id
         this.classes.archived = false;
         this.$store.dispatch('instructors/getClasses');
         this.$store.dispatch('instructors/getAssignedDates', this.dialogShow.data.id);
       }
       if(this.popoverToggles.profile){
          // if profile, get name, color, and set original data to compare changes
          this.profileData.email = this.learnerData.email;
          this.profileData.first_name = this.learnerData.firstName;
          this.profileData.last_name = this.learnerData.lastName;
          this.profileData.color = this.school.active_color;
          this.profileDataOriginal.first_name = this.learnerData.firstName;
          this.profileDataOriginal.last_name = this.learnerData.lastName;
       }
       if(this.popoverToggles.importStatus){
         this.$store.dispatch('instructors/getImportLogs');
       }

       if (this.popoverToggles.bulbInfo) {
         this.$store.dispatch('instructors/getTags', {isSearch : true});
       }
       if (this.popoverToggles.lti) { // TODO TAM reference point: this is where a lot of lti data is set, on `getData()`
        this.$store.dispatch('checkLink', { 
          contentId: this.dialogShow.data.id, 
          lmbId: this.dialogShow.data.lmb_id,
          renderPath: this.LTIdata.render_path,
        });
        //if canvas, check if they have groups imported
        if (this.dialogShow.data.lmb_id == 1) {
          this.lti.type = 'lmb';
          this.lti.options = [ 
            {
              text: 'Learner Made Bulb',
              value: 'lmb',
            },
          ];
          this.$store.dispatch('instructors/getLearnerGroups', this.LTIdata.section_id);
        } else if (this.dialogShow.data.type === 'playlist') {
          this.lti.type = 'playlist';
          this.lti.options = [ 
            { 
              text: 'Playlist',
              value: 'playlist',
            },
          ];
        } else {
          this.lti.type = 'selfpaced';
          this.lti.options = [
            { 
              text: 'Self Paced',
              value: 'selfpaced',
            },
            {
              text: 'Live Broadcast',
              value: 'broadcast',
            },
          ];
        }
      } 
      if (this.dialogShow.data?.list_code == 0) {
       this.activateBulb();
      }
      if(this.popoverToggles.ltiSync) {
        this.getStatus();
      }
      if (this.popoverToggles.lmb) {
        this.lmbData.peer_review = _.get(this.dialogShow, 'data.peer_review', false);
        this.lmbData.advanced = _.get(this.dialogShow, 'data.peer_review', false);
      }
      if (this.popoverToggles.lmbEdit){
        this.$store.dispatch('instructors/checkLMBAttempts', this.dialogShow.data.id);
        let obj = {
          name: this.dialogShow.data.name,
          learning_objective: (this.dialogShow.data.learning_objective != null) ? this.dialogShow.data.learning_objective : '',
          points: this.dialogShow.data.points_available,
          advanced: _.get(this.dialogShow,'data.config.lmb.peer_review', false),
          allow_upload: (this.dialogShow.data.config.lmb.upload) ? true : false,
          peer_review: this.dialogShow.data.config.lmb.peer_review,
          pr_rubric: this.dialogShow.data.config.lmb.pr_rubric,
          pr_anonymous: this.dialogShow.data.config.lmb.pr_anonymous,
          autograde: this.dialogShow.data.config.lmb.grade,
          share: this.dialogShow.data.config.lmb.share,
          data: this.dialogShow.data.config.lmb.data,
          anonymous: this.dialogShow.data.config.lmb.anonymous,
          allowPrivateVideoHosts: this.dialogShow.data.config.lmb.allowPrivateVideoHosts,
          learnersAccessTheirOwnVideoIntegrationContent: this.dialogShow.data.config.lmb.learnersAccessTheirOwnVideoIntegrationContent,
        }
        //turn off allow upload if school does not have hosting field
        if (
            (
              this.instructorType === 'institutionLTI' 
              || this.instructorType === 'institutionNonLTI'
            ) 
            && !this.adminData.hosting 
            && !this.adminData.mp4 ) {
          obj.allow_upload = false;
        }
        this.lmbData = obj;
        this.lmbDataOriginal = Object.assign({}, obj);
     }
       if(this.popoverToggles.shareMenu){
         this.$store.dispatch('sendManualLog',{category:'my bulbs', action:'share'});
       }
       if(this.popoverToggles.addSchool){
         this.schools.data.forEach(item => {
           if(item.master_district){
             this.addSchool.integrations = item.integrations;
             this.addSchool.active_color = this.school.active_color;
             this.addSchool.inactive_color = this.school.inactive_color;
             this.addSchool.base_color = this.school.base_color;
           }
         })
       }
       if(this.popoverToggles.editSchool){
         if(this.dialogShow.data.schools.length === 1){
           //if only one school selectedname: '',
           let obj = {
             name: this.dialogShow.data.schools[0].name,
             integrations: [],
             privacy: 2,
             thumbnail: (this.dialogShow.data.schools[0].logo) ? this.dialogShow.data.schools[0].logo : 'https://cdn.playposit.com/images/dog_white_pad.png',
             active_color: (this.dialogShow.data.schools[0].active_color) ? this.dialogShow.data.schools[0].active_color : '#2196F3',
             inactive_color:(this.dialogShow.data.schools[0].inactive_color) ? this.dialogShow.data.schools[0].inactive_color : '#1976d2',
             base_color: (this.dialogShow.data.schools[0].base_color) ? this.dialogShow.data.schools[0].base_color : '#fff',
           }

           this.addSchool = obj;
           this.addSchoolOriginal = Object.assign({}, obj);
           this.editSchoolOptions.dictDefaultMessage = `<img class="school-branding-preview" style="background-color:#fafafa;" src="${(this.dialogShow.data.schools[0].logo) ? this.dialogShow.data.schools[0].logo : 'https://cdn.playposit.com/images/dog_white_pad.png'}" />`;
         } else {
           //if multiple schools selected
           this.multipleSchools = true;
           let master_district_included = false;

           this.dialogShow.data.schools.forEach((school) => {
             //if master district included in selection, set data based on master district
             if(school.master_district){
               master_district_included = true;
               let obj = {
                 name: 'Multiple Schools Selected',
                 integrations: [],
                 privacy: 2,
                 thumbnail: (school.logo) ? school.logo : 'https://cdn.playposit.com/images/dog_white_pad.png',
                 active_color: (school.active_color) ? school.active_color : '#2196F3',
                 inactive_color:(school.inactive_color) ? school.inactive_color : '#1976d2',
                 base_color: (school.base_color) ? school.base_color : '#fff',
               }
               this.addSchool = obj;
               this.addSchoolOriginal = Object.assign({}, obj);
               this.editSchoolOptions.dictDefaultMessage = `<img class="school-branding-preview" style="background-color:#fafafa;" src="${(school.logo) ? school.logo : 'https://cdn.playposit.com/images/dog_white_pad.png'}" />`;
              }
           })

           //no master district included, set for first school
           if(!master_district_included){
              let obj = {
                 name: 'Multiple Schools Selected',
                 integrations: [],
                 privacy: 2,
                 thumbnail: (this.dialogShow.data.schools[0].logo) ? this.dialogShow.data.schools[0].logo : 'https://cdn.playposit.com/images/dog_white_pad.png',
                 active_color: (this.dialogShow.data.schools[0].active_color) ? this.dialogShow.data.schools[0].active_color : '#2196F3',
                 inactive_color:(this.dialogShow.data.schools[0].inactive_color) ? this.dialogShow.data.schools[0].inactive_color : '#1976d2',
                 base_color: (this.dialogShow.data.schools[0].base_color) ? this.dialogShow.data.schools[0].base_color : '#fff',
               }
               this.addSchool = obj;
               this.addSchoolOriginal = Object.assign({}, obj);
               this.editSchoolOptions.dictDefaultMessage = `<img class="school-branding-preview" style="background-color:#fafafa;" src="${(this.dialogShow.data.schools[0].logo) ? this.dialogShow.data.schools[0].logo : 'https://cdn.playposit.com/images/dog_white_pad.png'}" />`;
           }

         }
       }

       if(this.popoverToggles.editInstructors){
         this.$store.dispatch('admin/getSchoolList', true);

         if(this.dialogShow.data.instructors.length > 1){
           this.multipleInstructors = true;
           this.editInstructor = {
             first_name: 'Multiple Selected',
             last_name: 'Multiple Selected',
             email: 'Multiple Selected',
             institution: {}
           }
         } else {
           let obj = {
             first_name: this.dialogShow.data.instructors[0].first_name,
             last_name: this.dialogShow.data.instructors[0].last_name,
             email: this.dialogShow.data.instructors[0].email,
             institution: {
               id: this.dialogShow.data.instructors[0].school_id,
               name: this.dialogShow.data.instructors[0].school_name
             }
           }
           this.editInstructor = obj;
           this.editInstructorOriginal = Object.assign({}, obj);
         }
       }

       if(this.popoverToggles.addInstructors){
         this.$store.commit('admin/clearInstructorUploadData');
         this.$store.dispatch('admin/getSchoolList', true);
       }


       if(this.popoverToggles.snapshot){
         this.$store.dispatch('admin/getSchoolList', true);
         
         if(this.snapshotsettings.startdate === '' && this.snapshotsettings.enddate === ''){
           const isAugustOver = ((moment().month() + 1) > 8) ? true : false ;
           this.snapshot.date = isAugustOver 
              ? [moment().set('month', 7).set('date', 1).format("YYYY-MM-DD HH:mm:ss") , moment().format("YYYY-MM-DD HH:mm:ss")] 
              : [moment().subtract(1, "year").set('month', 8).set('date', 1).format("YYYY-MM-DD HH:mm:ss") , moment().format("YYYY-MM-DD HH:mm:ss")];
           this.snapshotOriginal.date = isAugustOver 
              ? [moment().subtract(1, "year").set('month', 8).set('date', 1).format("YYYY-MM-DD HH:mm:ss") , moment().format("YYYY-MM-DD HH:mm:ss")]
              : [moment().set('month', 7).set('date', 1).format("YYYY-MM-DD HH:mm:ss") , moment().format("YYYY-MM-DD HH:mm:ss")];
         } else {
           this.snapshot.date = [this.snapshotsettings.startdate, this.snapshotsettings.enddate]
           this.snapshotOriginal.date = [this.snapshotsettings.startdate, this.snapshotsettings.enddate]
         }

         this.snapshot.institution = this.snapshotsettings.institution;
         this.snapshotOriginal.institution = Object.assign({},this.snapshotsettings.institution);
       }
       if(this.popoverToggles.adminFilterMenu){
           this.$store.dispatch('admin/getSchoolList', true);
           this.adminFilters.age = this.adminFilterSearch.age.slice();
           this.adminFilters.subject = this.adminFilterSearch.subject.slice();
           this.adminFilters.name = this.adminFilterSearch.name.slice();
           this.adminFilters.instructor = this.adminFilterSearch.instructor.slice();
           this.adminFilters.keywords = this.adminFilterSearch.keywords.slice();
           this.adminFilters.organization = this.adminFilterSearch.organization.slice();
           this.adminFilters.course = this.adminFilterSearch.course.slice();
           this.adminFilters.bulbId = this.adminFilterSearch.bulbId.slice();
           await this.$store.dispatch('instructors/getTags',{ isSearch: true });
           this.$store.commit('instructors/setKeywordTag',this.adminFilters.keywords);
           if(this.adminFilterSearch.youtube != ''){
             this.adminFilters.youtube = (this.adminFilterSearch.youtube != 'Url Format Not Supported') ? `https://www.youtube.com/watch?v=${this.adminFilterSearch.youtube}` : 'Url Format Not Supported';
           } else {
             this.adminFilters.youtube = '';
           }
        }

        if(this.popoverToggles.filterMenu){
          this.filters.legacy = this.filterSearch.legacy;
          this.filters.all_district = this.filterSearch.all_district;
          this.filters.age = this.filterSearch.age.slice();
          this.filters.subject = this.filterSearch.subject.slice();
          this.filters.name = this.filterSearch.name.slice();
          this.filters.creator = this.filterSearch.creator.slice();
          this.filters.keywords = this.filterSearch.keywords.slice();
          this.filters.bulbId = this.filterSearch.bulbId.slice();
          await this.$store.dispatch('instructors/getTags', {
            isSearch: true,
            isPlaylist: this.activeViewInstructor === 'Playlists' ? true : false,
          });
          this.$store.commit('instructors/setKeywordTag', this.filters.keywords);
          this.filters.bulbRole = this.filterSearch.bulbRole.slice();
          this.filters.playlistRole = this.filterSearch.playlistRole.slice();
          this.filters.playlistId = this.filterSearch.playlistId.slice();
          if(this.filterSearch.youtube != ''){
            this.filters.youtube = (this.filterSearch.youtube != 'Url Format Not Supported') ? `https://www.youtube.com/watch?v=${this.filterSearch.youtube}` : 'Url Format Not Supported';
          } else {
            this.filters.youtube = '';
          }
        }

        if(this.popoverToggles.addVideo){
          this.$store.dispatch('admin/createShellBulb');
        }
        
        //If the LMS is using insert stuff then
        //the default is to disable grading
        this.enableGrading = this.LTIdata.insert_stuff === '1' ? 0 : 1;

     },
    //functions to reset trigger
    resetPopover: function(){
      if(this.popoverToggles.lti){
        this.$store.commit('resetLinkCheck');
      }
      this.assignBroadcast = false;
      this.resetPopoverToggle = false;
      setTimeout(()=> this.resetPopoverToggle = true, .05);
    },


    confirmRedirect: function(type){
      switch(type){
        case 'classic':
          window.location.replace(`${this.phpApiPrefix}/nav?legacy=true`);
          break;
        case 'learner':
          window.location.replace(`${this.phpApiPrefix}/panel/classes`);
          break;
        case 'bulbs':
          window.open(`${this.phpApiPrefix}/nav?legacy=true&access_token=${this.instructorData.token}#!/classes/${this.queryParamsInstructors.section_id}/bulbs?page=1&per_page=20&section=${this.queryParamsInstructors.section_id}&sort`)
          break;
        case 'gradebook':
          window.open(`${this.phpApiPrefix}/nav?legacy=true&access_token=${this.instructorData.token}#!/classes/${this.queryParamsInstructors.section_id}/analytics`)
          break;
        case 'logout':
          storejs.remove('url');
          storejs.remove('pp_instructor_token');
          storejs.remove('pp_learner_token');
          storejs.remove('pp_primary');
          storejs.remove('lti');
          sessionStorage.removeItem('hasUserAlreadyExperiencedPlayPositWeVideoAnnouncement');
          window.location.replace(`${this.phpApiPrefix}/logout`);
          break;
        case 'video':
          this.$store.dispatch('sendManualLog',{category:'video', action:'remove video'});
          this.$store.dispatch('instructors/archiveVideo', this.dialogShow.data.data.id);
          break;
        case 'reset':
          this.$store.dispatch('instructors/resetBulbAttempts');
          break;
        case 'import':
          this.$store.commit('instructors/toggleToastLoader', {toggle: true, text: 'Importing Bulbs'});
          this.$store.dispatch('instructors/importClassicBulbs');
          break;
        case 'lmbreset':
          this.$store.dispatch('instructors/resetLMB');
          break;
        case 'removeClass':
          this.$store.dispatch('learners/removeClass', this.dialogShow.data.data.id);
          break;
        case 'move':
          this.$store.dispatch('sendManualLog',{category:'learners', action:'move students to new class'});
          this.$store.dispatch('instructors/moveStudents', {class_to: this.moveClass.classSelected, class_from: this.queryParamsInstructors.section_id});
          break;
        case 'unlocklmb':
          this.$store.dispatch('instructors/unlockLMB', this.dialogShow.data.data);
          break;
        case 'unarchive':
          this.$store.dispatch('sendManualLog',{category:'class', action:'unarchive class'});
          this.$store.dispatch('instructors/unarchiveClass', this.dialogShow.data.data);
          break;
        case 'rubric':
          this.$store.dispatch('instructors/disableRubricLMB');
          break;
        case 'removeInstructor':
          this.$store.dispatch('admin/removeInstructors');
          this.selectedDataAdmin.forEach(item => {
            this.$store.dispatch('sendManualLog',{category:'instructor-unlinked', action:`Instructor id: ${item.id} Unlinked from School Id: ${this.school.id} on ${moment().format('MMMM Do YYYY, h:mm:ss a')}`});
          });
          break;
        case 'copyfolder':
          this.$store.dispatch('instructors/copyFolder',  {id:this.dialogShow.data.data.id, name:this.dialogShow.data.data.name, subfolder:false, bulbCopy: true});
          break;
        case 'importunits':
          this.$store.dispatch('instructors/importUnits')
          break;
        default:
          break;
      }

      this.closeMenu('confirm');
    },

    clearCourseSearchString() {
      this.searchCourse = '';
    },
    //functions to dispatch actions for instructors
    copyClassicBulbs: function(){
      this.closeMenu('copyClassicBulbs');
      this.$store.commit('instructors/toggleToastLoader', {toggle: true, text: 'Importing Bulbs'});
      this.$store.dispatch('instructors/importClassicBulbs');
    },
    activateBulb: function(){
      this.$store.commit('instructors/toggleToastLoader', {toggle: true, text: 'Activating Bulb'});
      this.$store.dispatch('instructors/activateBulb', {bulb_id: this.dialogShow.data.id, lesson_id: this.dialogShow.data.root_lesson_id});
    },
    createClass: function(){
      //dispatch create class, close modal
      this.$store.dispatch('instructors/createClass', [this.addClass.name, this.addClass.color]);
      this.closeMenu("addClass");
      this.dialogShow.dash = false;
    },
    editClassFunc: function(){
      //dispatch edit class, close modal
      this.$store.dispatch('instructors/editClass', [this.editClass.name, this.editClass.default_color, this.editClass.id]);
      this.closeMenu("editClass");
      this.dialogShow.dash= false;
    },
    createFolder: function(){
      //dispatch create class, close modal
      let parent_id;
      if(this.activeViewInstructor === "Folders"){
        parent_id = this.addFolder.subfolder;
      } else {
        parent_id = this.queryParamsInstructors.folder_id;
      }
      this.$store.dispatch('instructors/createFolder', {name:this.addFolder.name.trim(), default_color:this.addFolder.default_color, parent_id: parent_id});
      this.closeMenu("addFolder");
    },
    createNodeFolder: function(){
      const node = {
        "name": this.addFolder.name,
        "parentId": this.dialogShow.data.id,
        "type": 'folder'
      }
      this.$store.dispatch('admin/createNodeFolder',node);
      this.closeMenu("addNodeFolder");
    },
    editFolderFunc: function(){
      this.$store.dispatch('instructors/editFolder', {id:this.dialogShow.data.id, name:this.editFolder.name.trim(), default_color:this.editFolder.default_color, parent_id: this.editFolder.subfolder});
      this.closeMenu("editFolder");
    },
    editTreeFolderFunc: function(){
      const newNode = this.dialogShow.data;
      newNode.name = this.editFolder.name;
      this.$store.dispatch('admin/dragUpdateFolder', newNode);
      this.closeMenu("editFolder");
    },
    addBulbToFolder: function(id){
      let folder_id = id;
      let bulb_id = this.dialogShow.data.id;

      this.$store.dispatch('instructors/addBulbToFolder', {bulb_id: bulb_id, folder_id: folder_id});
    },
    removeBulbToFolder: function(id){
      let folder_id = id;
      let bulb_id = this.dialogShow.data.id;

      this.$store.dispatch('instructors/removeBulbToFolder', {bulb_id: bulb_id, folder_id: folder_id});
    },
    copyFolderFunc: function(){
      let obj = {
        id: this.dialogShow.data.data.id,
        name: this.copyFolder.name,
        subfolder: this.dialogShow.data.subfolder,
        bulbCopy: false
      }
      this.$store.dispatch('instructors/copyFolder',  obj);
      this.closeMenu("copyFolder");
    },
    copyBulb: function(edit, id, copyLmbData = false) {
      //find copied bulb name
      let name = this.copy.name;
      if(this.activeViewInstructor === 'Bulbs'){
        this.$store.dispatch('sendManualLog',{category:'bulbs', action:'copy bulb'});
      }
      //check if bulb is a lesson from old db
      if(!this.filterSearch.legacy){
        //if not legacy, set to new db
        this.$store.commit('instructors/toggleToastLoader', {toggle: true, text: 'Copying Bulb'});
        this.$store.dispatch('instructors/copyBulb', {
          id,
          name,
          edit,
          newDb: true,
          lti: false,
          fullCopy: this.copy.fullCopy,
          isCopyingUnrestricted: this.dialogShow?.data?.isCopyingUnrestricted,
          copyLmbData,
        });
        this.closeMenu("copy");
        this.dialogShow.dash = false;
      } else {
        //if legacy, set to old db
        this.$store.commit('instructors/toggleToastLoader', {toggle: true, text: 'Copying Bulb'});
        this.$store.dispatch('instructors/copyBulb', {
          id,
          name,
          edit,
          newDb: false,
          lti: false,
          fullCopy: this.copy.fullCopy,
          isCopyingUnrestricted: this.dialogShow?.data?.isCopyingUnrestricted,
        });
        this.closeMenu("copy");
        this.dialogShow.dash = false;
      }
    },
    copyBulbLTI: function(){
      let name = `Copy of ${this.dialogShow.data.name}`;
      this.$store.dispatch('instructors/copyBulb', {id:this.dialogShow.data.id, name:name, edit:false, newDb:true, lti:true, fullCopy: true});
    },
    profile: function(){
      //slides out profile from assign to change profile timezone
      this.$store.commit('slideOut', {toggle: true, view: 'profile'});
    },
    rubric: function(){
      //slides out rubric
      this.$store.commit('slideOut', {toggle: true, view: 'rubric'});
    },
    exportData: function(){
      //export data from table and close popover
      let obj = {}
      if(this.dialogShow.data.analytics){
        obj.type = 'Bulb-Analytics';
        obj.bulb_id = this.dialogShow.data.bulb_id;
        obj.bulb_name = this.dialogShow.data.bulb_name;
      } else if (!_.isNil(this.dialogShow.data.playlist_id) && this.dialogShow.data.playlist_id !== 'All Bulbs' && !this.dialogShow.data.playlistAnalytics) {
        obj.type = 'Gradebook-Playlist';
        obj.playlist_id = this.dialogShow.data.playlist_id;
      } else if (this.dialogShow.data.playlistAnalytics){
        obj.type = 'Playlist-Analytics';
        obj.playlist_id = this.dialogShow.data.playlist_id;
        obj.playlist_name = this.dialogShow.data.playlist_name;
        obj.section_id = this.dialogShow.data.section_id;
      } else {
        obj.type = this.activeViewInstructor;
      }
      if(this.activeViewAdmin === 'Instructors' && this.dialogShow.data.isAdmin) {
        this.$store.dispatch('admin/exportInstructorDataTable',{type: 'Instructors'});
      } else {
        this.$store.dispatch('instructors/exportDataTable', obj);
      }
      
      this.dialogShow.dash = false;
      this.popoverToggles.export = false;
    },
    downloadData: function(type) {
      //function to remove/delete/archive item
      //switch based on type
      switch(type) {
        case 'My-Bulbs-Multiple':
          this.$store.dispatch('instructors/exportDataTable', {type: type, bulb_id: this.dialogShow.data})
          return;
        case 'My-Bulbs-BA':
            this.$store.dispatch('instructors/exportDataTable', {type: type, bulb_id: this.dialogShow.data.id})
            return;
        case 'Remove-Access':
            if (this.dialogShow.data.bulb_role === 3) return;
            this.$store.dispatch('instructors/exportDataTable', {type: type, bulb_id: this.dialogShow.data.id});
            return;
        case 'Gradebook':
            this.$store.dispatch('instructors/exportDataTable', {type: type, section_id: this.dialogShow.data.id})
            return;
        case 'Learners-BA':
            this.$store.dispatch('instructors/exportDataTable', {type: type})
            return;
        case 'Bulbs-BA':
            this.$store.dispatch('instructors/exportDataTable', {type: type, section_id: this.queryParamsInstructors.section_id, bulb_id: this.dialogShow.data.id})
            return;
        default:
          return;
      }
    },
    removeItem: function(type) {
      //function to remove/delete/archive item
      //switch based on type
      switch(type) {
        case 'My-Bulbs-Multiple':
            this.$store.dispatch('instructors/deleteBulb', this.dialogShow.data);
            if (this.$route.name === 'instructor') EventBus.$emit('sendProquestBulbDeletionData');
            this.closeMenu('remove');
            return;
        case 'My-Bulbs-BA':
            this.$store.dispatch('instructors/deleteBulb', this.dialogShow.data.id);
            EventBus.$emit('sendProquestBulbDeletionData', this.dialogShow.data.id);
            this.closeMenu('remove');
            return;
        case 'Remove-Access':
            this.$store.dispatch('instructors/removeAccess', this.dialogShow.data.id);
            this.closeMenu('remove');
            return;
        case 'Gradebook':
            this.$store.dispatch('sendManualLog',{category:'class', action:'archive class'});
            this.$store.dispatch('instructors/archiveClass', this.dialogShow.data.id);
            this.closeMenu('remove');
            return;
        case 'Learners-BA':
            this.$store.dispatch('sendManualLog',{category:'learners', action:'removing students'});
            this.$store.dispatch('instructors/removeStudents');
            this.closeMenu('remove');
            return;
        case 'Bulbs-BA':
          // this should be an archive call, not an update
            this.$store.dispatch('sendManualLog',{category:'bulbs', action:'remove bulb'});
            this.$store.dispatch('instructors/unassignBulbSection', {bulb_id: this.dialogShow.data.id, section_id: this.queryParamsInstructors.section_id, assigned_date: null});
            this.closeMenu('remove');
            return;
        case 'Folders':
            this.$store.dispatch('sendManualLog',{category:'folders', action:'remove folder'});
            this.$store.dispatch('instructors/deleteFolder', {folder_id: this.dialogShow.data.id});
            this.closeMenu('remove');
            return;
        case 'BulbFolder':
          let folder_id;
          if(this.activeViewInstructor === 'Folder'){
            folder_id = this.queryParamsInstructors.folder_id;
          } else {
            folder_id = this.queryParamsInstructors.subfolder_id;
          }
          let bulb_id = this.dialogShow.data.id;
          this.$store.dispatch('sendManualLog',{category:'folders', action:'remove bulb from folder'});
          this.$store.dispatch('instructors/removeBulbToFolder', {bulb_id: bulb_id, folder_id: folder_id});
          this.closeMenu('remove');
          this.$nextTick(()=> {
            this.$store.commit('instructors/refreshData');
          })
          return;
        default:
          return;
      }
    },
    listenToStorage: function(event) {
      const refresh = localStorage.getItem('refreshGroups');
      if (refresh && refresh !== 'false') {
        this.$store.dispatch('instructors/getLearnerGroups', this.LTIdata.section_id);
        storejs.set('refreshGroups', false);
      }
    },
    moveStudents: function(){
      this.popoverToggles.moveMenu = false;
      this.dialogShow.dash = false;
      this.dialogShow.data = {type:'move'};
      this.popoverToggles.confirm = true;
      this.dialogShow.dash = true;
    },
    handleMoveCurrent: function(val){
      //set move class from table
      this.moveClass.classSelected = val;
    },
    broadcast: function(data){
      //create code by base64_encode bulb_section_id
      const code = btoa(data.bulb_section);
      window.open(`/player_v2/?section_id=${data.class.id}&type=broadcast&code=${code}&bulb_id=${this.dialogShow.data.id}&token=${this.instructorData.token}`);
    },
    //LTI functions
    linkAssignment: async function() {
      let renderPath;
      if (this.lti.type === 'selfpaced') {
        renderPath = LTI_RENDER_PATHS.Play2;
      } else if (this.lti.type === 'lmb') {
        renderPath = LTI_RENDER_PATHS.Studentmade2;
      } else if (this.lti.type === 'broadcast') {
        renderPath = LTI_RENDER_PATHS.Broadcast2;
      } else if ( this.lti.type === 'playlist') {
        renderPath = LTI_RENDER_PATHS.Playlist;
      }
      
      if (
        this.LTIdata.isContentItemLaunch == 0
        && this.LTIdata.resource_link_id
      ) {
        this.$store.dispatch('setContentLink', { 
          contentId: this.dialogShow.data.id,
          contentName: this.dialogShow.data.name,
          groupSetId: this.lti.group_set_id,
          renderPath,
          enableGrading: this.enableGrading
        });
      } else {
        if (this.lti.group_set_id) {
          // attach groupSetId to bulbSection
          try {
            await this.assignBulbSection({
              bulb_id: this.dialogShow.data.id,
              group_set_id: this.lti.group_set_id,
              section_id: this.LTIdata.section_id,
            });
          }
          catch (err) {
            // trigger toast
            this.$store.commit('triggerSnackbar', {
              text:"There was an error attaching this Group Set.",
              color: 'red',
              timeout: 6000,
            });
          }
        }

        const disableTitleAutofill = this?.school?.permissionKeys?.includes('disableCanvasAssignmentTitleAutofill');
        if (this.lti13Launch) {
          if (this.LTIdata.disable_placement == 1) {
            return window.location.replace(
              PLAYPOSIT_PHP_ENDPOINTS.LTI_13.contentItemSelectionRequestDisablePlacement({
                phpApiPrefix: this.phpApiPrefix,
                teacherId: this.instructorData.id,
                contentId: this?.dialogShow?.data?.id,
                contentTitle: (!disableTitleAutofill) ? this?.dialogShow?.data?.name: '',
                renderPath,
                schoolId: this?.school?.id,
              }));
          }
          else {
            return window.location.replace(
              PLAYPOSIT_PHP_ENDPOINTS.LTI_13.contentItemSelectionRequestPlacement({
                phpApiPrefix: this.phpApiPrefix,
                teacherId: this.instructorData.id,
                contentId: this?.dialogShow?.data?.id,
                placement: this?.lti?.placement,
                LTIPlacement: this.LTIPlacement,
                placementWidth: this?.lti?.width,
                placementHeight: this?.lti?.height,
                contentTitle: (!disableTitleAutofill) ? this?.dialogShow?.data?.name : '',
                renderPath,
                schoolId: this?.school?.id,
              })
            );
          }
        }

        if (this.LTIdata.disable_placement == 1) {
          return window.location.replace(
            PLAYPOSIT_PHP_ENDPOINTS.LTI_11.contentItemSelectionRequestDisablePlacement({
              phpApiPrefix: this.phpApiPrefix,
              teacherId: this.instructorData.id,
              lessonId: this?.dialogShow?.data?.id,
              consumerPk: this?.LTIdata?.consumer_pk,
              lessonTitle: (!disableTitleAutofill )? this?.dialogShow?.data?.name : '',
              renderPath,
              enableGrading: this.enableGrading,
            })
          );
        }
        else {
          return window.location.replace(
            PLAYPOSIT_PHP_ENDPOINTS.LTI_11.contentItemSelectionRequestPlacement({
              phpApiPrefix: this.phpApiPrefix,
              teacherId: this.instructorData.id,
              lessonId: this?.dialogShow?.data?.id,
              consumerPk: this?.LTIdata?.consumer_pk,
              placement: this.lti.placement,
              placementWidth: this.lti.width,
              placementHeight: this.lti.height,
              lessonTitle: (!disableTitleAutofill )? this?.dialogShow?.data?.name : '',
              renderPath,
              enableGrading: this.enableGrading,
            })
          );
        }
      }
    },
    unlinkAssignment: function() {
      if (this.LTIdata.previouslyLinked.data.lessonUrl === LTI_RENDER_PATHS.Playlist) {
        this.unlinkPlaylist({
          playlistId: this.LTIdata.previouslyLinked.data.defaultLessonId,
          sectionId: this.LTIdata.previouslyLinked.data.sectionId,
          isContentItemLaunch: 1,
          picker: true,
        })
      } else {
        this.unlinkBulb({
          bulb_id: this.LTIdata.previouslyLinked.data.defaultLessonId,
          section_id: this.LTIdata.previouslyLinked.data.sectionId,
          render_path: this.LTIdata.previouslyLinked.data.lessonUrl,
          content_item_launch: 1,
          picker: true,
        });
      }
    },
    downloadLTIData: function(){
      this.$store.dispatch('instructors/exportDataTable', {type: 'Interactions', section_id: this.LTIdata.section_id , bulb_id: this.LTIdata.contentId})
    },
    getStatus: function(){
      this.$store.dispatch('getLtiSyncLogs', { 
        contentId: this.dialogShow.data.contentId,
        renderPath: this.dialogShow.data.renderPath,
        sectionId: this.queryParamsInstructors.section_id,
      });
    },
    //lmb functions
    createLMB: function() {
      // [ ] find time to refactor this later
      //make sure data is false is share is false
      let data; let anonymous; let share; let pr_rubric; let pr_anonymous; let points;
      let grade = (!this.lmbData.pr_rubric && this.lmbData.points === 0) ? true : this.lmbData.autograde; // must auto grade lmbs with points available = 0
      let learning_objective = this.lmbData.learning_objective;
      let upload = this.lmbData.allow_upload;
      //confirm data if peer review is turned off, mark other advanced options as false
      if (this.lmbData.peer_review) {
        data = false;
        anonymous = false;
        share = false;
        points = this.lmbData.points;
        if (this.lmbData.pr_rubric) {
          points = 0;
          pr_rubric = this.lmbData.pr_rubric;
          pr_anonymous = this.lmbData.pr_anonymous;
        } else {
          pr_rubric = this.lmbData.pr_rubric;
          pr_anonymous = false;
        }
      } else {
        if (this.lmbData.learning_objective === '') {
          learning_objective = 'Upload your video, add interactions, and submit it to your instructor.'
        }
        //if peer review off, check if share is off
        share = this.lmbData.share;
        pr_rubric = false;
        pr_anonymous = false;
        points = this.lmbData.points;

        if (!this.lmbData.share) {
          data = false;
          anonymous = false;
        } else {
          data = this.lmbData.data;
          anonymous = this.lmbData.anonymous;
        }
      }
      this.$store.dispatch('instructors/createLMB', {
        name: this.lmbData.name,
        learning_objective,
        points,
        peer_review: this.lmbData.peer_review,
        pr_rubric,
        pr_anonymous,
        grade,
        share,
        data,
        anonymous,
        upload,
        allowPrivateVideoHosts: this.lmbData.allowPrivateVideoHosts,
        learnersAccessTheirOwnVideoIntegrationContent: this.lmbData.learnersAccessTheirOwnVideoIntegrationContent,
      });
    },
    editLMB: function(){
      // [ ] find time to refactor this later
      //make sure data is false is share is false
      let data; let anonymous; let share; let pr_rubric; let pr_anonymous;
      let grade = (!this.lmbData.pr_rubric && this.lmbData.points === 0) ? true : this.lmbData.autograde; // must auto grade lmbs with points available = 0
      //confirm data if peer review is turned off, mark other advanced options as false
      if(this.lmbData.peer_review) {
        data = false;
        anonymous = false;
        share = false;
        pr_rubric = this.lmbData.pr_rubric;
        pr_anonymous = this.lmbData.pr_anonymous;
      } else {
        //if peer review off, check if share is off
        share = this.lmbData.share;
        pr_rubric = false;
        pr_anonymous = false;

        if(!this.lmbData.share){
          data = false;
          anonymous = false;
        } else {
          data = this.lmbData.data;
          anonymous = this.lmbData.anonymous;
        }
      }

      this.$store.dispatch('instructors/editLMB', {
        id: this.dialogShow.data.id,
        name: this.lmbData.name,
        learning_objective: this.lmbData.learning_objective,
        points: this.lmbData.points,
        peer_review: this.lmbData.peer_review,
        pr_rubric: pr_rubric,
        rubric_id: this.lmbData.rubric_id,
        pr_anonymous,
        grade,
        share,
        data,
        anonymous,
        upload: this.lmbData.allow_upload,
        allowPrivateVideoHosts: this.lmbData.allowPrivateVideoHosts,
        learnersAccessTheirOwnVideoIntegrationContent: this.lmbData.learnersAccessTheirOwnVideoIntegrationContent,
      });
      this.closeMenu('lmbEdit')
    },
    editRubric: function(){
      this.$store.dispatch('instructors/getRubricInteractions', this.dialogShow.data.id)
    },

    //filters logic
    clearAllFilters: function(){
      this.filters = {
        name: [],
        contentType: 'Bulbs',
        creator: [],
        subject: [],
        bulbRole: [],
        age: [],
        keywords: [],
        youtube: '',
        bulbId: '',
        legacy: false,
        tagExactMatch: false,
        excludeTags: [],
        playlistRole: [],
        playlistId: [],
      }
    },
    clearAllPlaylistFilters: function(){
      this.filters = {
        name: [],
        contentType: 'Playlists',
        creator: [],
        subject: [],
        bulbRole: [],
        age: [],
        keywords: [],
        youtube: '',
        bulbId: '',
        legacy: false,
        tagExactMatch: false,
        excludeTags: [],
        playlistRole: [],
        playlistId: [],
      }
    },
    clearAllPlaylistFilters: function(){
      this.filters = {
        name: [],
        contentType: 'Playlists',
        creator: [],
        subject: [],
        bulbRole: [],
        age: [],
        keywords: [],
        youtube: '',
        bulbId: '',
        playlistRole: [],
        playlistId: [],
        legacy: false,
        tagExactMatch: false,
        excludeTags: [],
        playlistRole: [],
        playlistId: [],
      }
    },
    timer(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async setFilters() {
      //reset query params and update url
      await this.timer(250);
      this.$store.commit('instructors/setQueryParams', {sort:'', page:1, per_page:20});

      let obj = {
        age: this.filters.age,
        contentType: this.premadeContentType,
        subject: this.filters.subject,
        legacy: this.filters.legacy,
        all_district: this.filters.all_district,
        bulbRole: this.filters.bulbRole,
        keywords: this.filters.keywords,
        name: this.filters.name,
        creator: this.filters.creator,
        tagExactMatch: this.filters.tagExactMatch,
        bulbId: this.filters.bulbId,
        youtube: '',
        excludeTags: this.filters.excludeTags,
        playlistRole: this.filters.playlistRole,
        playlistId: this.filters.playlistId,
      }

      if(this.filters.youtube != ''){
        if(this.filters.youtube.indexOf('v=') >= 0){
          obj.youtube = this.filters.youtube.split('=')[1];
        } else if(this.filters.youtube.indexOf('be/') >= 0){
          obj.youtube = this.filters.youtube.split('be/')[1];
        } else {
          obj.youtube = 'Url Format Not Supported'
        }
      }

      //clear filters not supported in legacy
      if(this.filters.legacy){
        obj.age = [];
        obj.subject = [];
        obj.keywords = [];
        obj.youtube = '';
        obj.all_district = true;
      }

      this.$store.commit('instructors/setFilters', obj);
      
      if(this.activeViewInstructor === "Premade-Bulbs" || this.activeViewInstructor === "Premade-Bulbs-Legacy"  ){
        if(this.filters.legacy){
          this.$store.commit('instructors/setActiveView', ['Premade-Bulbs-Legacy']);
          this.$store.dispatch('instructors/updateUrl');
        } else {
          this.$store.commit('instructors/setActiveView', ['Premade-Bulbs']);
        }
      }

      if(this.activeViewInstructor === "My-Community" || this.activeViewInstructor === "My-Community-Legacy"  ){
        if(this.filters.legacy){
          this.$store.commit('instructors/setActiveView', ['My-Community-Legacy']);
          this.$store.dispatch('instructors/updateUrl');
        } else {
          this.$store.commit('instructors/setActiveView', ['My-Community']);
        }
      }


      this.closeMenu('filterMenu');
    },
    // clear filter from interation filter popover menu
    clearFilterInteractions: function(){
      this.$store.commit('instructors/setFiltersInteractions', {
        selectedStatus: 'All',
        showPointsBadges: false,
        localShowPointsBadges: false,
        isFiltered: false,
        refreshData: this.filtersInteraction.selectedStatus !== 'All',
      });
      this.closeMenu('filterMenuInteraction');
    },
    // on click filter from filter interaction menu, it triggers filter
    setFiltersInteractions(){
      //reset query params and update url
      // if (this.filtersInteraction.selectedStatus === 'All') {
      //   this.$store.commit('instructors/setQueryParams', {filter_status:''});
      // } else {
      //   this.$store.commit('instructors/setQueryParams', {filter_status:this.filtersInteraction.selectedStatus});
      // }
      // this.$store.dispatch('instructors/updateUrl');
      this.$store.commit('instructors/setQueryParams', {sort:'', page:1, per_page:20});
      const selectedStatus = this.filtersInteraction.selectedStatus.length ? this.filtersInteraction.selectedStatus : 'All';
      this.$store.commit('instructors/setFiltersInteractions', {
        selectedStatus,
        showPointsBadges: this.filtersInteraction.localShowPointsBadges,
        localShowPointsBadges: this.filtersInteraction.localShowPointsBadges,
        refreshData: selectedStatus !== 'All',
        isFiltered: (
          selectedStatus !== 'All'
          || this.filtersInteraction.localShowPointsBadges
        ),
      });
      this.closeMenu('filterMenuInteraction');
    },
    setFiltersMyBulbs: function() {
      //reset query params and update url
      this.$store.commit('instructors/setQueryParams', {sort:'', page:1, per_page:20});

      let obj = {
        age: this.filters.age,
        subject: this.filters.subject,
        legacy: this.filters.legacy,
        keywords: this.filters.keywords,
        bulbRole: this.filters.bulbRole,
        name: this.filters.name,
        creator: this.filters.creator,
        youtube: '',
        tagExactMatch: this.filters.tagExactMatch,
        bulbId: this.filters.bulbId,
        excludeTags: this.filters.excludeTags,
        playlistRole: this.filters.playlistRole,
        playlistId: this.filters.playlistId,
      };
      this.$store.commit('instructors/setFilters', obj);
      this.closeMenu('filterMenu');
    },
    setFiltersMyPlaylists: function() {
      //reset query params and update url
      this.$store.commit('instructors/setQueryParams', {sort:'', page:1, per_page:20});

      let obj = {
        age: this.filters.age,
        subject: this.filters.subject,
        legacy: this.filters.legacy,
        keywords: this.filters.keywords,
        bulbRole: this.filters.bulbRole,
        name: this.filters.name,
        creator: this.filters.creator,
        youtube: '',
        tagExactMatch: this.filters.tagExactMatch,
        bulbId: this.filters.bulbId,
        excludeTags: this.filters.excludeTags,
        playlistRole: this.filters.playlistRole,
        playlistId: this.filters.playlistId,
      };
      this.$store.commit('instructors/setFilters', obj);
      this.closeMenu('filterMenu');
    },
    removeFilterChip: function(data){
      let index = this.filters[data[0]].indexOf(data[1]);
      this.filters[data[0]].splice(index, 1);
    },
    saveBulbSettings: function(bulb){
      this.updateInstructorBulbSettings(bulb); 
      this.closeMenu('bulbInfo');
    },
    closeFilterSelector: function(type){
      if(this.filters[type].length) this.$refs[type].blur()
    },

    //learner functions to dispatch actions
     searchClass: function(){
       //split teacher id and section id from class code
       let teacher_id = this.join.classCode.split('-')[0];
       let section_id = this.join.classCode.split('-')[1];
       //dispatch class code search and clear code
       this.$store.dispatch('learners/searchClass', [teacher_id, section_id]);
       this.join.classCode ='';
     },
     joinClass: function(){
       //dispatch join class
       this.$store.dispatch('learners/joinClass');
     },
     saveProfile: function(){
       //change breadcrumbs with new first name and update url
       this.breadcrumbs[0].text = `${this.profileData.first_name.trim()}'s Classes`;
       this.$store.dispatch('updateBreadCrumbs', [this.breadcrumbs, {}]);
       this.$store.dispatch('learners/updateUrl');
       //dispatch save profile changes
       this.$store.dispatch('learners/saveProfile', {first_name: this.profileData.first_name.trim(), last_name: this.profileData.last_name.trim()});
     },
     deleteAccount: function(){
       //dispatch delete account
       if(confirm('Are you sure that you want to delete your PlayPosit account?')){
         this.$store.dispatch('learners/deleteAccount');
       }
     },
     createAriaLabel: function(type, data){
       if(type === 'join'){
         if(data.name === 'No class found'){
           return "No class found matching this class code. Please reenter class code and try again."
         } else {
           return `Class found. The class' name is ${data.name} which is instructed by ${data.teacher_name}. If this is the correct class, tab to the join class button and press enter.`
         }
       }

       if(type === 'email'){
         return `Learner email input. This is not editable. Learner email is ${data}`
       }

       if(type === 'first'){
         return `Learner first name input. Edit here to change the learner first name. Current first name is ${(data != '') ? data : "blank. This field is required. Please type the learner's last name"}.`
       }

       if(type === 'last'){
         return `Learner last name input. Edit here to change the learner last name. Current last name is ${(data != '') ? data : "blank. This field is required. Please type the learner's last name"}.`
       }
     },

    //admin functions
    handleDropzoneSuccess: function(file, urls) {
       if (urls.error) {
        this.$el.querySelector('.dz-message').innerHTML = '<p style="color:red;">Image unable to be uploaded at this time</p>'
        this.$el.querySelector('.dz-message').innerHTML = `<img class="dropzone-uploaded-image" src="${this.addSchool.thumbnail}"/>`;
       } else {
        this.bulbInfo.thumbnail = urls.imageUrl
        this.$el.querySelector('.dz-message').innerHTML = `<img class="dropzone-uploaded-image" src="${urls.imageUrl}"/>`;
       }
     },
     handleDropzoneRemovedFile: function(file, error, xhr) {
       this.bulbInfo.thumbnail = this.addSchool.thumbnail.slice();
       this.$el.querySelector('.dz-message').innerHTML = `<img class="dropzone-uploaded-image" src="${this.addSchool.thumbnail}"/>`;
       this.$refs.bsDropzone.enable();
     },
     clearInstructorFile: function(e) {
        e.target.value = null;
        this.$store.commit('admin/clearInstructorUploadData');
     },
     onInstructorFileChange: function(e){
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length){
          return;
        }
        this.$store.dispatch('admin/uploadTeacherCsv', files[0]);
        this.addInstructorCsvSchool = {};
     },
     removeAdminFilterChip: function(data){
      let index = this.adminFilters[data[0]].indexOf(data[1]);
      this.adminFilters[data[0]].splice(index, 1);
     },
     addInstructor: function(){
       let obj = {
         firstName: this.addInstructorManual.first_name,
         lastName: this.addInstructorManual.last_name,
         email: this.addInstructorManual.email,
         password: this.addInstructorManual.password,
         schoolId: this.addInstructorManual.institution.id,
         schoolName: this.addInstructorManual.institution.name,
       }
       this.$store.dispatch('admin/addInstructor', obj);
     },
     closeAdminFilterSelector: function(type) {
       this.$refs[type].blur()
     },
     clearAdminFilters: function() {
      this.adminFilters = {
        name: [],
        instructor: [],
        subject: [],
        age: [],
        keywords: [],
        organization: [],
        course: [],
        youtube: '',
        tagExactMatch: false,
        bulbId:'',
      }
    },
    handleAdminFilterMenuContentSelection() {
      EventBus.$emit('admin-filter-menu-content-selection-change', { contentType: this.contentType });
    },
    async setAdminFilters(){
      await this.timer(250);
      let obj = {
        creator: {},
        contentType: this.contentType,
        name: this.adminFilters.name,
        instructor: this.adminFilters.instructor,
        subject: this.adminFilters.subject,
        age: this.adminFilters.age,
        keywords: this.adminFilters.keywords,
        organization: this.adminFilters.organization,
        course: this.adminFilters.course,
        youtube: this.adminFilters.youtube,
        adminOnly: this.adminFilters.adminOnly,
        tagExactMatch: this.adminFilters.tagExactMatch,
        bulbId: this.adminFilters.bulbId,
        excludeTags: this.adminFilters.adminExcludeTags,
      }

      if(this.adminFilters.youtube != ''){
        if(this.adminFilters.youtube.indexOf('v=') >= 0){
          obj.youtube = this.adminFilters.youtube.split('=')[1];
        } else if(this.adminFilters.youtube.indexOf('be/') >= 0){
          obj.youtube = this.adminFilters.youtube.split('be/')[1];
        } else {
          obj.youtube = 'Url Format Not Supported'
        }
      }
      //reset query params for filter change and update url
      this.$store.commit('admin/setQueryParams', {sort:'', page:1, per_page:20});
      this.$store.dispatch('admin/updateUrl');

      this.$store.commit('admin/setAdminFilters', obj);
      this.closeMenu('adminFilterMenu');
    },
    removeInstructorAccounts: function(){
      this.popoverToggles.editInstructors = false;
      this.handleDialogOpen({type:'confirm', data:{type:'removeInstructor'}});
    },
    saveEditInstructors: function(){
      let obj = {
        multiple: this.multipleInstructors,
        firstName: this.editInstructor.first_name,
        lastName: this.editInstructor.last_name,
        schoolId: this.editInstructor.institution.id,
        schoolName: this.editInstructor.institution.name
      }
      this.$store.dispatch('admin/editInstructors', obj)
      this.closeMenu('editInstructors')
    },
    filterSnapshot: function(){
      let obj = {
        institution: this.snapshot.institution,
        startdate: moment(this.snapshot.date[0]).format("YYYY-MM-DD HH:mm:ss"),
        enddate: moment(this.snapshot.date[1]).format("YYYY-MM-DD HH:mm:ss"),
      }
      this.$store.commit('admin/setSnapshotSettings', obj);

      this.$nextTick(()=> {
        this.closeMenu('snapshot');
        this.$store.dispatch('admin/getSnapshotData');
      })
    },
    exportSnapshot: function(){
      this.$store.dispatch('admin/exportSnapshot', this.snapshotexport);
      this.closeMenu('snapshot');
    },
    handleVideoTranscoderSuccess: function(data) {
      this.successAdminVideoUpload = true;
      this.$store.dispatch('admin/updateBulbShellVideo', data.playpositVideo.id);
    },
    handleVideoTranscoderError: function(error) {
      this.$store.commit('triggerSnackbar', {text:"Uploading video failed. Try again later or contact PlayPosit support.", color: 'red', timeout: 6000});
      this.$store.dispatch('admin/archiveShellBulb');
    },

    //hotlink functions
    hotlinkAssignCourse() {
      this.$store.dispatch('instructors/getAssignedDates', this.dialogShow.data.id);
      this.assignTabs = 0;
    },
    hotlinkAssignLink(data) {
      this.assignClass = data;
      this.assignTabs = 1;
    }, 
    popoverHotlink: function(oldP, newP, type, data){
      //close old menu and destroy component
      this.closeMenu(oldP);
      this.dialogShow.dash = false;
      this.resetPopover();
      
      //open new menu
      this.dialogShow.dash = true;
      this.popoverToggles[newP]= true;
      
      if (oldP === "monitor" && type === 'broadcast') {
        this.assignBroadcast = true;
        this.assignClass = data;
      }
    },
    monitorHotlink: function(data) {
      //set main nav and close dialog popover
      this.$store.dispatch('sendManualLog',{category:'my bulbs', action:'monitor'});
      this.$store.commit('setNav', ['Classes', 'classes']);
      this.closeMenu('monitor');

      //set query params and active view
      this.$store.commit('instructors/resetQueryParams');
      let queryParams = {section_id: data.id, bulb_id: this.dialogShow.data.id};
      //if lms class, turn on query param to true
      if(data.lmsType != null && data.lmsType != 'Google' && data.lmsType != 'SchoologyFree') queryParams.lms_class = true;

      this.$store.commit('instructors/setQueryParams', queryParams);
      //toggle LMB monitor page
      if(!this.dialogShow.data.lmb_id){
        this.$store.commit('instructors/setActiveView', ['Interactions']);
      } else {
        if(this.dialogShow.data.config.lmb.peer_review){
          this.$store.commit('instructors/setActiveView', ['Peer-Review']);
        } else {
          this.$store.commit('instructors/setActiveView', ['Learner-Made-Bulb']);
        }
      }

      //breadcrumbs
      let payload = {};
      let breadcrumb = [{text:'Classes', disabled: false, payload:'Classes'}, {text:data.name, payload:''}, {text:'My Bulbs', payload:'My-Bulbs'}];
      this.$store.commit('updateBreadCrumbs' , [breadcrumb, payload]);
      this.$store.commit('instructors/setGradebookBreadcrumbs', [{text:this.dialogShow.data.name, payload:''}]);

      //get table data, update url
      this.$store.dispatch('instructors/getTableData');
      this.$store.dispatch('instructors/updateUrl');
    },
    externalMonitorHotlink(data) {
      this.$store.dispatch('sendManualLog', {
        category:'my bulbs',
        action: 'monitor',
      });
      const queryParameters = {
        page: 1,
        per_page: 20,
        search: '',
        sort: '',
        all_data: true,
        interaction_id: '',
        interaction_type: '',
        student_id: '',
        folder_id: '',
        subfolder_id: '',
        lms_class: false,
        lmb_bulb: '',
        lmb_section: '',
        section_id: data.id,
        bulb_id: this.dialogShow.data.id,
        breadcrumbs: encodeURI(JSON.stringify([
          {
            text: 'Classes',
            disabled: false,
            payload:'Classes'
          },
          {
            text: data.name,
            payload:''
          },
          {
            text:'My Bulbs',
            payload:'My-Bulbs'
          },
        ])),
        gradebook: encodeURI(JSON.stringify([{
          text: this.dialogShow.data.name,
          payload:'',
        }])),
      };
      if (
        ![
          null,
          'Google',
          'SchoologyFree'
        ].includes(data.lmsType)
      ) queryParameters.lms_class = true;

      let activeView;
      if(!this.dialogShow.data.lmb_id){
        activeView = 'Interactions';
      } else if (this.dialogShow.data.config.lmb.peer_review) {
        activeView = 'Peer-Review';
      } else {
        activeView = 'Learner-Made-Bulb';
      }
      window.open(`${window.location.origin}/dash/instructor/Classes/${activeView}${queryParameters.toQueryString()}`, '_blank');
    },

    //data validation functions

    formErrors: function(type) {
      //check for form error by various types
        const errors = []
        if(type === 'add'){
          if(this.addClass.name === "") errors.push('Name is required.');
          if(this.addClass.name.length > 255) errors.push('Name can not exceed 255 characters');
        }
        if(type === 'edit'){
          if(this.editClass.name === "") errors.push('Name is required.')
          if(this.editClass.name.length > 255) errors.push('Name can not exceed 255 characters');
        }
        if(type === 'copy'){
          if(this.copy.name === "") errors.push('Name is required.')
          if(this.copy.name.length > 255) errors.push('Name can not exceed 255 characters');
        }
        if(type === 'profileFirst'){
          !this.$v.profileData.first_name.maxLength && errors.push('First name must be at most 25 characters long')
          !this.$v.profileData.first_name.required && errors.push('First name is required.')
          !this.$v.profileData.first_name.excluded && errors.push('First name cannot contain punctuation')
        }
        if(type === 'profileLast'){
          !this.$v.profileData.last_name.maxLength && errors.push('First name must be at most 25 characters long')
          !this.$v.profileData.last_name.required && errors.push('First name is required.')
          !this.$v.profileData.last_name.excluded && errors.push('First name cannot contain punctuation')
        }
        if(type === 'join'){
          let regex1 = RegExp(/(\d *- *\d)/g);
          if(!regex1.test(this.join.classCode) && this.join.classCode.length > 0) errors.push('Class Code should be two numbers with a dash (####-####)')
        }
        if(type === 'lmb'){
          if(this.lmbData.name.length > 255) errors.push('Name can not exceed 255 characters');
        }
        if(type === 'lmbpoints'){
          if(this.lmbData.points === "") errors.push('Integer points are required');
          if (
            (
              this.lmbData.points > 100
              && !this.lmbData.pr_rubric
            )
            || this.lmbData.points < 0
          ) errors.push('Points must be between 0 and 100')
        }

        if(type === 'width'){
          if(this.lti.width < 320) errors.push('320px is the smallest width allowed')
        }

        if(type === 'height'){
          if(this.lti.height < 235) errors.push('235px is the smallest height allowed')
        }

        if(type === 'schoolName'){
          if(this.addSchool.name === '') errors.push('School name is required')
        }

        if(type === 'foldername'){
          if(this.addFolder.name === "") errors.push('Name is required.');
          if(this.addFolder.name.length > 255) errors.push('Name can not exceed 255 characters');
        }

        if(type === 'foldernameedit'){
          if(this.editFolder.name === "") errors.push('Name is required.');
          if(this.editFolder.name.length > 255) errors.push('Name can not exceed 255 characters');
        }

        if(type === 'copyFolder'){
          if(this.copyFolder.name === "") errors.push('Name is required.');
          if(this.copyFolder.name.length > 255) errors.push('Name can not exceed 255 characters');
        }

        return errors
     },
     checkColor: function(){
       //in student profile, check if color is too light to set as active color
       if(this.popoverToggles.profile) {
         this.profileData.colorWarning = false;

         let color = Color(this.profileData.color)
         if(color.luminosity() < .85){
           this.$store.commit('setNewColor', this.profileData.color);
         } else {
           this.profileData.colorWarning = true;
         }
       } else if (this.popoverToggles.addMenu){
         this.addClass.colorWarning = false;

         let color = Color(this.addClass.color)
         if(color.luminosity() > .80){
           this.addClass.colorWarning = true;
           this.addClass.color = '#737373';
         }
       } else if (this.popoverToggles.addMenu){
         this.editClass.colorWarning = false;
         let color = Color(this.editClass.default_color)
         if(color.luminosity() > .80){
           this.editClass.colorWarning = true;
           this.editClass.default_color = this.editClassOriginal.default_color;
         }
       } else if (this.popoverToggles.addFolder){
         this.addFolder.colorWarning = false;
         let color = Color(this.addFolder.default_color)
         if(color.luminosity() > .80){
           this.addFolder.colorWarning = true;
           this.addFolder.default_color = '#737373';
         }
       } else if (this.popoverToggles.editFolder){
         this.editFolder.colorWarning = false;
         let color = Color(this.editFolder.default_color)
         if(color.luminosity() > .80){
           this.editFolder.colorWarning = true;
           this.editFolder.default_color = this.editFolderOriginal.default_color;
         }
       }
     },


    //helper functions to format data
    formatTimestamp:function(row, column){
        return moment.tz(row.timestamp, this.instructorData.timezone).format('MMM DD, YYYY hh:mm A');
    },


    //functions to create css class
    assignTableClass: function(row){
      //assign class table has no borders
      if(this.queryParamsInstructors.section_id === ''){
        return 'no-border padding-left';
      } else {
        if(row.row.id === this.queryParamsInstructors.section_id){
          return 'no-border padding-left';
        } else {
          return 'display-none'
        }
      }
    },
    subFolderClass: function(row){
      return 'no-border'
    },
    joinTableClass: function(){
      //assign class table has no borders
      return 'no-border padding-left join-background';
    },
    shareClassTable: function(){
      //assign class table has no borders
      return 'padding-left smallrow';
    },
    moveStudentTable: function(){
      return 'cursor padding-overall'
    },
    tagStyle: function(type){
      let color;

      if(type === 'Creator'){
        color = '#b2ebf2'
      } else if(type === 'Name') {
        color = '#DCEDC8'
      } else if(type === 'organization'){
        color = '#E1BEE7'
      } else {
        this.tags.rawData.forEach(item => {
          if(item.type === type) color = item.hex;
        })
      }

      let darkColor = Color(color).darken(0.60).hex();
      return {
        'backgroundColor': color,
        'color': `${darkColor} !important`,
        'border': `solid 1px ${darkColor} !important`,
      }
    },
    tagTextStyle: function(type){
      let color;

      if(type === 'Creator'){
        color = '#b2ebf2'
      } else if(type === 'Name') {
        color = '#DCEDC8'
      } else if(type === 'organization'){
        color = '#E1BEE7'
      } else {
        this.tags.rawData.forEach(item => {
          if(item.type === type) color = item.hex;
        })
      }

      let darkColor = Color(color).darken(0.60).hex();
      return {
        'color': `${darkColor} !important`,
      }
    },
    setSnapshotTabs: function(){
      this.snapshotSettingTab = 1;
      setTimeout(() => {
        this.snapshotSettingTab = 0;
      }, 100)
    },
    transferOwnership(bulbId, isAdmin = false) {
      if (this.addEmailList.length > 1) {
        this.$store.commit('triggerSnackbar', {text:"You can only transfer ownership to one instructor.", color: 'red', timeout: 6000});
      } else { 
        this.changeOwner({
          endTeacherId: this.addEmailList.length ? this.addEmailList[0].id : this.selectedUser.teacher_id,
          bulbIds: this.selectedData.length > 0 ? this.selectedData.map(data => data.id) : [bulbId],
          isAdmin,
        });
        this.setSelectedUser(null);
        this.setPermissionPending(false);
        this.resetAddEmailList();
        this.closeMenu('shareMenu');
        this.setDashModal(null);
      }
    },
    transferSectionOwnership(sectionId) {
      this.changeSectionOwner({
        sectionId,
        newTeacherId: this.selectedUser.teacher_id,
        overwriteAccess: this.overwriteAccess,
      });
      this.setSelectedUser(null);
      this.setPermissionPending(false);
      this.closeMenu('coursePermission');
    },
    undoBulbTransfer: function() {
      this.setSelectedUser(null);
      this.setPermissionPending(false);
      this.resetAddEmailList();
    },
    undoSectionTransfer: function() {
      this.setSelectedUser(null);
      this.setPermissionPending(false);
    },
    initializeLmbSettings() {
      if (this.instructorType === 'pro') {
        this.lmbData.allowPrivateVideoHosts = false;
        this.lmbDataOriginal.allowPrivateVideoHosts = false;
        this.lmbData.learnersAccessTheirOwnVideoIntegrationContent = false;
        this.lmbDataOriginal.learnersAccessTheirOwnVideoIntegrationContent = false;
      }
    },
    async setupFocusTrap() {
      await this.$nextTick();
      let trapElement = document.getElementById('dash-popovers');
      this.trap = focusTrap.createFocusTrap(trapElement, {
        clickOutsideDeactivates: true,
        fallbackFocus: trapElement,
      });
      if (trapElement) this.trap.activate();
    },
    removeFocusTrap() {
      this.trap.deactivate();
    },
  },
  watch: {
    searchCourse: _.debounce( function(course){
      if(course && course.length > 3 ) {
        this.$store.commit('admin/setCourseLoadBar');
        this.$store.dispatch('admin/searchCourse',course);
      }
    }, 1000),
    manualAddInstructorSuccess: {
      handler: function(val, oldVal){
        if(val == true){
          this.addInstructorManual = {
            first_name: '',
            last_name: '',
            email: '',
            password: '',
            institution: {}
          }
          this.addInstructorReset = false;
          setTimeout(() => {
            this.addInstructorReset = true;
          }, 50)
          setTimeout(() => {
            this.$store.commit('admin/resetManualAddInstructor')
          }, 6000)
        }
      }
    },
    'lmbData.pr_rubric' (n, o) {
      // In the future, we may want to check for the specific substring and then change that instead of the whole string
      if (n) {
        // reset the autograde switch value if the enable grading rubric toggle (lmbData.pr_rubric) has been toggled:
        this.lmbData.autograde = false;
        const learningObjectiveChanged = "This is a two part assignment. First, upload a video and submit it to your instructor. Second, watch your peer review group's videos and make comments in the discussion forum." !== _.get(this.lmbData, 'learning_objective', '');
        if (!learningObjectiveChanged) this.lmbData.learning_objective = "This is a two part assignment. First, upload a video and submit it to your instructor. Second, watch your peer review group's videos, fill out the grading rubrics, and submit your final feedback.";
      } else {
        // reset the pr_anonymous switch value if the enable grading rubric toggle (lmbData.pr_rubric) has been toggled:
        this.lmbData.pr_anonymous = false;
        const learningObjectiveChanged = "This is a two part assignment. First, upload a video and submit it to your instructor. Second, watch your peer review group's videos, fill out the grading rubrics, and submit your final feedback." !== _.get(this.lmbData, 'learning_objective', '');
        if (!learningObjectiveChanged) this.lmbData.learning_objective = "This is a two part assignment. First, upload a video and submit it to your instructor. Second, watch your peer review group's videos and make comments in the discussion forum.";
      }
    },
    'lmbData.peer_review' (n, o) {
      if (!n) {
        this.lmbData.pr_rubric = false;
        this.lmbData.pr_anonymous = false;
      }
    },
    'tagSearchString' (n, o) {
      // reset tag matches search if input is less than 4 characters
      if (n && n.length < 2) this.tagMatchesSearched = false;
      // Trigger tag matches search when character input length >= 2 and we haven't searched yet:
      if (n && n.length >= 2 && !this.tagMatchesSearched) {
        const data = {
          'searchString': n,
          isSearch: true,
          isPlaylist: this.activeViewInstructor === 'Playlists' ? true : false,
        };
        this.tagMatchesSearched = true;
        this.$store.dispatch('instructors/getTags', data);
      }
    },
    excludeTagSearchString (newValue, oldValue) {
      // reset tag matches search if input is less than 4 characters
      if (
        newValue
        && newValue.length < 2
      ) this.tagMatchesSearched = false;
      // Trigger tag matches search when character input length >= 2 and we haven't searched yet:
      if (
        newValue
        && newValue.length >= 2
        && !this.tagMatchesSearched
      ) {
        const data = {
          'searchString': newValue,
          isSearch: true
        };
        this.tagMatchesSearched = true;
        this.$store.dispatch('instructors/getTags', data);
      }
    },
  },
  created(){
    this.getData();
    if (_.get(this.lmbData, 'peer_review', false) && !_.get(this.lmbData, 'learning_objective', '')) {
      this.lmbData.learning_objective = _.get(this.lmbData, 'pr_rubric', false)
        ? "This is a two part assignment. First, upload a video and submit it to your instructor. Second, watch your peer review group's videos, fill out the grading rubrics, and submit your final feedback."
        : "This is a two part assignment. First, upload a video and submit it to your instructor. Second, watch your peer review group's videos and make comments in the discussion forum.";
    }
    this.setupFocusTrap();
  },
  mounted() {
    //set data from data prop
    this.setSnapshotTabs();
    this.initializeLmbSettings();
    window.addEventListener('storage', this.listenToStorage);
  },
  beforeDestroy(){
    this.removeFocusTrap();
    //reset data on destroy
    this.resetPopover();
  }
};
</script>

<style scoped>
.aria-error {
  text-indent: -10000px;
}


.manage-folders-tooltip {
  width: 200px !important;
}
</style>